// // // import React, { useState, useEffect, useCallback } from "react";
// // // import { useNavigate, useLocation } from "react-router-dom";
// // // import { motion, AnimatePresence } from "framer-motion";
// // // import {
// // //   FiArrowLeft, FiCreditCard, FiUser, FiCheck, FiLoader,
// // //   FiCheckCircle, FiXCircle, FiAlertCircle, FiLogIn, FiShoppingBag,
// // //   FiLock, FiShield, FiPackage, FiTruck, FiInfo, FiTag, FiExternalLink,
// // //   FiMapPin, FiPhone, FiMail, FiHome, FiHeart,
// // // } from "react-icons/fi";
// // // import { FaPhoneAlt, FaRupeeSign } from "react-icons/fa";
// // // import { useAuth } from "../context/AuthContext";

// // // const API_BASE_URL = "https://server.havbit.in/api";

// // // const SAVED_ADDRESS_KEY = "havbit_saved_address";

// // // /* ─────────────────────────────────────────────────────────
// // //    HELPERS
// // // ───────────────────────────────────────────────────────── */
// // // const loadRazorpayScript = () =>
// // //   new Promise((resolve, reject) => {
// // //     if (window.Razorpay) return resolve(true);
// // //     const s = document.createElement("script");
// // //     s.src = "https://checkout.razorpay.com/v1/checkout.js";
// // //     s.onload = () => resolve(true);
// // //     s.onerror = () => reject(new Error("Failed to load Razorpay SDK"));
// // //     document.body.appendChild(s);
// // //   });

// // // const getRazorpayPublicKey = (obj) =>
// // //   obj?.razorpayKey || obj?.key || obj?.razorpay_key || process.env.REACT_APP_RAZORPAY_KEY_ID;

// // // const isOid = (v) => typeof v === "string" && /^[0-9a-fA-F]{24}$/.test(v);

// // // const extractVendorId = (obj) => {
// // //   if (!obj) return null;
// // //   const candidates = [
// // //     obj.vendorId,
// // //     obj.vendor?._id,
// // //     typeof obj.vendor === "string" ? obj.vendor : null,
// // //     obj.sellerId,
// // //     obj.seller?._id,
// // //     typeof obj.seller === "string" ? obj.seller : null,
// // //   ];
// // //   for (const v of candidates) {
// // //     const s = v?.toString?.();
// // //     if (isOid(s)) return s;
// // //   }
// // //   return null;
// // // };

// // // const isPublicProduct = (item) =>
// // //   item.isVendorProduct === false || item.isVendorProduct === undefined || item.isVendorProduct === null;

// // // /* ─────────────────────────────────────────────────────────
// // //    STEP INDICATOR
// // // ───────────────────────────────────────────────────────── */
// // // const StepIndicator = ({ current }) => {
// // //   const steps = [
// // //     { n: 1, label: "Address", icon: FiMapPin },
// // //     { n: 2, label: "Payment", icon: FiCreditCard },
// // //     { n: 3, label: "Confirmed", icon: FiCheckCircle },
// // //   ];
// // //   return (
// // //     <div className="relative flex items-center justify-between mb-10 px-4">
// // //       <div className="absolute inset-x-0 top-5 h-0.5 bg-gray-200 z-0 mx-16" />
// // //       <div
// // //         className="absolute top-5 left-16 h-0.5 bg-gradient-to-r from-red-500 to-red-600 z-0 transition-all duration-700"
// // //         style={{ width: current === 1 ? "0%" : current === 2 ? "50%" : "100%", right: "4rem" }}
// // //       />
// // //       {steps.map(({ n, label, icon: Icon }) => (
// // //         <div key={n} className="relative z-10 flex flex-col items-center gap-2">
// // //           <motion.div
// // //             initial={false}
// // //             animate={{
// // //               scale: current === n ? 1.1 : 1,
// // //               backgroundColor:
// // //                 current > n ? "#16a34a" : current === n ? "#dc2626" : "#e5e7eb",
// // //             }}
// // //             className="w-10 h-10 rounded-full flex items-center justify-center shadow-md"
// // //           >
// // //             {current > n ? (
// // //               <FiCheck className="text-white" size={18} />
// // //             ) : (
// // //               <Icon
// // //                 className={current === n ? "text-white" : "text-gray-400"}
// // //                 size={16}
// // //               />
// // //             )}
// // //           </motion.div>
// // //           <span
// // //             className={`text-xs font-semibold tracking-wide ${
// // //               current >= n ? "text-gray-800" : "text-gray-400"
// // //             }`}
// // //           >
// // //             {label}
// // //           </span>
// // //         </div>
// // //       ))}
// // //     </div>
// // //   );
// // // };

// // // /* ─────────────────────────────────────────────────────────
// // //    INPUT FIELD
// // // ───────────────────────────────────────────────────────── */
// // // const Field = ({ label, icon: Icon, error, ...props }) => (
// // //   <div className="flex flex-col gap-1.5">
// // //     <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
// // //       {label}
// // //     </label>
// // //     <div className="relative">
// // //       {Icon && (
// // //         <Icon
// // //           size={14}
// // //           className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
// // //         />
// // //       )}
// // //       <input
// // //         {...props}
// // //         className={`w-full ${Icon ? "pl-10" : "pl-4"} pr-4 py-3 bg-gray-50 border ${
// // //           error ? "border-red-400" : "border-gray-200"
// // //         } rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-transparent focus:bg-white transition-all`}
// // //       />
// // //     </div>
// // //     {error && <p className="text-xs text-red-500">{error}</p>}
// // //   </div>
// // // );

// // // /* ─────────────────────────────────────────────────────────
// // //    ORDER SUMMARY SIDEBAR
// // // ───────────────────────────────────────────────────────── */
// // // const OrderSummary = ({ cart, totals, appliedCoupon, paymentMethod }) => (
// // //   <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden sticky top-24">
// // //     <div className="bg-gradient-to-r from-gray-900 to-gray-800 px-5 py-4">
// // //       <h3 className="text-white font-bold text-sm flex items-center gap-2">
// // //         <FiShoppingBag size={15} /> Order Summary
// // //       </h3>
// // //       <p className="text-gray-400 text-xs mt-0.5">{cart.length} item{cart.length !== 1 ? "s" : ""}</p>
// // //     </div>

// // //     <div className="max-h-48 overflow-y-auto divide-y divide-gray-50">
// // //       {cart.map((item) => (
// // //         <div key={item._id} className="flex items-center gap-3 px-4 py-3">
// // //           <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-100 shrink-0 border border-gray-200">
// // //             <img
// // //               src={item.image || item.images?.[0] || "/placeholder.png"}
// // //               alt={item.name}
// // //               className="w-full h-full object-cover"
// // //               onError={(e) => { e.target.src = "/placeholder.png"; }}
// // //             />
// // //           </div>
// // //           <div className="flex-1 min-w-0">
// // //             <p className="text-xs font-semibold text-gray-800 truncate">{item.name}</p>
// // //             <p className="text-xs text-gray-400 mt-0.5">Qty: {item.qty || 1}</p>
// // //           </div>
// // //           <p className="text-xs font-bold text-gray-800 shrink-0">
// // //             ₹{((parseFloat(item.price) || 0) * (parseInt(item.qty) || 1)).toFixed(0)}
// // //           </p>
// // //         </div>
// // //       ))}
// // //     </div>

// // //     <div className="px-5 py-4 border-t border-gray-100 space-y-2.5">
// // //       {[
// // //         { label: "Subtotal", value: `₹${totals.subtotal.toFixed(2)}` },
// // //         {
// // //           label: "Delivery",
// // //           value: totals.deliveryFee === 0 ? "FREE" : `₹${totals.deliveryFee}`,
// // //           green: totals.deliveryFee === 0,
// // //           orange: totals.deliveryFee > 0,
// // //         },
// // //         // { label: "Platform Fee", value: `₹${totals.platformFee}` },
// // //         // { label: "GST (5%)", value: `₹${totals.gst.toFixed(2)}` },
// // //       ].map((r) => (
// // //         <div key={r.label} className="flex justify-between text-xs">
// // //           <span className="text-gray-500">{r.label}</span>
// // //           <span className={`font-semibold ${r.green ? "text-green-600" : r.orange ? "text-orange-500" : "text-gray-700"}`}>
// // //             {r.value}
// // //           </span>
// // //         </div>
// // //       ))}

// // //       {paymentMethod === "cod" && (
// // //         <div className="flex items-center gap-1.5 text-xs text-orange-600 bg-orange-50 border border-orange-200 rounded-lg px-2.5 py-1.5">
// // //           <FiInfo size={11} className="shrink-0" />
// // //           <span>₹30 delivery charge for Cash on Delivery</span>
// // //         </div>
// // //       )}
// // //       {paymentMethod === "razorpay" && (
// // //         <div className="flex items-center gap-1.5 text-xs text-green-600 bg-green-50 border border-green-200 rounded-lg px-2.5 py-1.5">
// // //           <FiCheckCircle size={11} className="shrink-0" />
// // //           <span>Free delivery on online payment!</span>
// // //         </div>
// // //       )}

// // //       {appliedCoupon && (
// // //         <div className="flex justify-between text-xs border-t border-dashed border-green-200 pt-2">
// // //           <span className="text-green-600 flex items-center gap-1">
// // //             <FiTag size={11} /> {appliedCoupon.code}
// // //           </span>
// // //           <span className="font-bold text-green-600">-₹{appliedCoupon.discount.toFixed(2)}</span>
// // //         </div>
// // //       )}
// // //       <div className="flex justify-between items-center border-t border-gray-200 pt-3">
// // //         <span className="font-bold text-gray-900">Total</span>
// // //         <span className="text-xl font-extrabold text-red-600">₹{totals.total.toFixed(2)}</span>
// // //       </div>
// // //     </div>

// // //     <div className="px-5 pb-5">
// // //       <div className="flex items-center gap-3 text-xs text-gray-500 border-t border-gray-100 pt-4">
// // //         <FiShield className="text-green-500 shrink-0" size={14} />
// // //         <span>Secure checkout • Bank-level encryption</span>
// // //       </div>
// // //     </div>
// // //   </div>
// // // );

// // // /* ─────────────────────────────────────────────────────────
// // //    MAIN CHECKOUT COMPONENT
// // // ───────────────────────────────────────────────────────── */
// // // export default function Checkout({ cart = [], clearCart }) {
// // //   const navigate = useNavigate();
// // //   const location = useLocation();
// // //   const { user, isAuthenticated, getUserId, getToken } = useAuth();

// // //   const preSelectedPayment = location.state?.paymentMethod;

// // //   const [step, setStep] = useState(1);
// // //   const [loading, setLoading] = useState(false);
// // //   const [paymentLoading, setPaymentLoading] = useState(false);
// // //   const [couponLoading, setCouponLoading] = useState(false);
// // //   const [vendorLoading, setVendorLoading] = useState(false);

// // //   const [formData, setFormData] = useState({
// // //     name: "", email: "", phone: "",
// // //     address: "", city: "", state: "", pincode: "",
// // //     paymentMethod: preSelectedPayment === "ONLINE" ? "razorpay" : "cod",
// // //     weight: "0.5", length: "15", width: "10", height: "5",
// // //   });

// // //   const [fieldErrors, setFieldErrors] = useState({});
// // //   const [orderDetails, setOrderDetails] = useState(null);
// // //   const [paymentError, setPaymentError] = useState(null);
// // //   const [paymentSuccess, setPaymentSuccess] = useState(false);
// // //   const [backendOrderData, setBackendOrderData] = useState(null);
// // //   const [razorpayMeta, setRazorpayMeta] = useState(null);

// // //   const [couponCode, setCouponCode] = useState("");
// // //   const [appliedCoupon, setAppliedCoupon] = useState(null);
// // //   const [couponError, setCouponError] = useState("");
// // //   const [couponDiscount, setCouponDiscount] = useState(0);

// // //   const [resolvedVendorId, setResolvedVendorId] = useState(null);
// // //   const [resolvedWarehouseId, setResolvedWarehouseId] = useState(null);
// // //   const [vendorError, setVendorError] = useState("");

// // //   const [confirmedCart, setConfirmedCart] = useState([]);
// // //   const [confirmedTotals, setConfirmedTotals] = useState(null);
// // //   const [confirmedPaymentMethod, setConfirmedPaymentMethod] = useState(null);
// // //   const [confirmedCoupon, setConfirmedCoupon] = useState(null);

// // //   const allCartItemsPublic = cart.every((item) => isPublicProduct(item));

// // //   const calculateTotals = () => {
// // //     const subtotal = cart.reduce(
// // //       (s, i) => s + (parseFloat(i.price) || 0) * (parseInt(i.qty) || 1),
// // //       0
// // //     );
// // //     const deliveryFee = formData.paymentMethod === "cod" ? 30 : 0;
// // //     const platformFee = 0;
// // //     // const gst = subtotal * 0.05;
// // //     const totalBeforeDiscount = subtotal + deliveryFee + platformFee;
// // //     const total = Math.max(0, totalBeforeDiscount - couponDiscount);
// // //     return {
// // //       subtotal: +subtotal.toFixed(2),
// // //       deliveryFee: +deliveryFee.toFixed(2),
// // //       platformFee: +platformFee.toFixed(2),
// // //       // gst: +gst.toFixed(2),
// // //       totalBeforeDiscount: +totalBeforeDiscount.toFixed(2),
// // //       couponDiscount: +couponDiscount.toFixed(2),
// // //       total: +total.toFixed(2),
// // //     };
// // //   };
// // //   const totals = calculateTotals();

// // //   const resolveVendorAndWarehouse = useCallback(async () => {
// // //     if (cart.length === 0 || allCartItemsPublic) return;
// // //     setVendorLoading(true);
// // //     setVendorError("");
// // //     try {
// // //       const token = getToken();
// // //       if (!token) { setVendorError("Please login to continue."); return; }
// // //       const res = await fetch(`${API_BASE_URL}/parcelx/warehouse`, {
// // //         headers: { Authorization: `Bearer ${token}` },
// // //       });
// // //       const data = await res.json();
// // //       if (!data.success || !data.warehouses?.length) {
// // //         setVendorError("No warehouse configured for this vendor.");
// // //         return;
// // //       }
// // //       setResolvedWarehouseId(data.warehouses[0]._id);
// // //       setResolvedVendorId(data.warehouses[0].vendorId);
// // //     } catch (e) {
// // //       setVendorError("Failed to load shipping info: " + e.message);
// // //     } finally {
// // //       setVendorLoading(false);
// // //     }
// // //   }, [cart, getToken, allCartItemsPublic]);

// // //   useEffect(() => {
// // //     if (isAuthenticated && cart.length > 0) resolveVendorAndWarehouse();
// // //   }, [isAuthenticated, resolveVendorAndWarehouse]);

// // //   useEffect(() => {
// // //     if (!isAuthenticated) navigate("/login", { state: { from: "/checkout" } });
// // //   }, [isAuthenticated, navigate]);

// // //   // ── Auto-fill: user profile + saved address ──
// // //   useEffect(() => {
// // //     if (!user) return;

// // //     // Load saved address from localStorage
// // //     let saved = {};
// // //     try {
// // //       saved = JSON.parse(localStorage.getItem(SAVED_ADDRESS_KEY) || "{}");
// // //     } catch {}

// // //     setFormData((p) => ({
// // //       ...p,
// // //       // Profile fields (always from user)
// // //       name:  user.fullName || user.name  || p.name,
// // //       email: user.email                  || p.email,
// // //       phone: user.phone                  || p.phone,
// // //       // Address fields — use saved if available, else keep blank
// // //       address: saved.address || p.address,
// // //       city:    saved.city    || p.city,
// // //       state:   saved.state   || p.state,
// // //       pincode: saved.pincode || p.pincode,
// // //     }));
// // //   }, [user]);

// // //   const handleApplyCoupon = async () => {
// // //     if (!couponCode.trim()) return setCouponError("Please enter a coupon code");
// // //     setCouponLoading(true); setCouponError("");
// // //     try {
// // //       const token = getToken();
// // //       const res = await fetch(`${API_BASE_URL}/coupons/apply`, {
// // //         method: "POST",
// // //         headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
// // //         body: JSON.stringify({ code: couponCode.toUpperCase(), orderAmount: totals.totalBeforeDiscount }),
// // //       });
// // //       const data = await res.json();
// // //       if (!data.success) return setCouponError(data.message || "Invalid coupon");
// // //       setAppliedCoupon({ code: couponCode.toUpperCase(), discount: data.discount });
// // //       setCouponDiscount(data.discount);
// // //     } catch (e) {
// // //       setCouponError(e.message || "Failed to apply coupon");
// // //     } finally { setCouponLoading(false); }
// // //   };

// // //   const handleRemoveCoupon = () => {
// // //     setAppliedCoupon(null); setCouponDiscount(0); setCouponCode(""); setCouponError("");
// // //   };

// // //   const handleChange = (e) => {
// // //     const { name, value } = e.target;
// // //     setFormData((p) => ({ ...p, [name]: value }));
// // //     if (fieldErrors[name]) setFieldErrors((p) => ({ ...p, [name]: "" }));
// // //   };

// // //   const validateForm = () => {
// // //     const { name, email, phone, address, city, state, pincode } = formData;
// // //     const errors = {};
// // //     if (!name.trim() || name.trim().length < 2) errors.name = "Enter your full name";
// // //     if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "Enter a valid email";
// // //     if (!phone.trim() || !/^[6-9]\d{9}$/.test(phone)) errors.phone = "Valid 10-digit Indian mobile required";
// // //     if (!address.trim() || address.trim().length < 10) errors.address = "Complete address required (min 10 chars)";
// // //     if (!city.trim()) errors.city = "Enter your city";
// // //     if (!state.trim()) errors.state = "Enter your state";
// // //     if (!pincode.trim() || !/^\d{6}$/.test(pincode)) errors.pincode = "Valid 6-digit pincode required";
// // //     setFieldErrors(errors);
// // //     return Object.keys(errors).length === 0;
// // //   };

// // //   // ── Save address to localStorage then go to step 2 ──
// // //   const handleProceedToPayment = async () => {
// // //     if (!validateForm()) return;

// // //     // Save address fields for next time
// // //     try {
// // //       localStorage.setItem(SAVED_ADDRESS_KEY, JSON.stringify({
// // //         address: formData.address,
// // //         city:    formData.city,
// // //         state:   formData.state,
// // //         pincode: formData.pincode,
// // //       }));
// // //     } catch {}

// // //     if (formData.paymentMethod === "razorpay") {
// // //       try { await loadRazorpayScript(); } catch { return alert("Failed to load payment gateway. Try again."); }
// // //     }
// // //     setStep(2);
// // //   };

// // //   const saveOrderToStorage = (order) => {
// // //     try {
// // //       const all = JSON.parse(localStorage.getItem("user_orders") || "[]");
// // //       const idx = all.findIndex((o) => o._id === order._id);
// // //       if (idx === -1) all.unshift(order);
// // //       else all[idx] = order;
// // //       localStorage.setItem("user_orders", JSON.stringify(all.slice(0, 50)));
// // //     } catch (e) { console.error("Storage error:", e); }
// // //   };

// // //   const createParcelxOrder = async () => {
// // //     const token = getToken();
// // //     if (!token) throw new Error("Please login again.");
// // //     const customerId = getUserId();
// // //     if (!customerId) throw new Error("User ID missing — please login again.");

// // //     let vendorId = null;
// // //     let warehouseId = null;

// // //     if (!allCartItemsPublic) {
// // //       vendorId = resolvedVendorId;
// // //       if (!vendorId) {
// // //         for (const item of cart) {
// // //           if (!isPublicProduct(item)) {
// // //             vendorId = extractVendorId(item);
// // //             if (vendorId) break;
// // //           }
// // //         }
// // //       }
// // //       if (!vendorId) {
// // //         for (const item of cart) {
// // //           if (isPublicProduct(item)) continue;
// // //           const productId = item._id || item.productId;
// // //           if (!isOid(productId)) continue;
// // //           try {
// // //             const res = await fetch(`${API_BASE_URL}/products/${productId}`, {
// // //               headers: { Authorization: `Bearer ${token}` },
// // //             });
// // //             const data = await res.json();
// // //             vendorId = extractVendorId(data.product || data.data || data);
// // //             if (vendorId) break;
// // //           } catch (e) { /* continue */ }
// // //         }
// // //       }
// // //       if (!vendorId) throw new Error("Vendor information not found. Please go back and re-add vendor items to cart.");

// // //       warehouseId = resolvedWarehouseId;
// // //       if (!warehouseId) {
// // //         const wRes = await fetch(`${API_BASE_URL}/parcelx/warehouse`, {
// // //           headers: { Authorization: `Bearer ${token}` },
// // //         });
// // //         const wData = await wRes.json();
// // //         if (wData.success && wData.warehouses?.length > 0) {
// // //           warehouseId = wData.warehouses[0]._id;
// // //           setResolvedWarehouseId(warehouseId);
// // //         } else {
// // //           throw new Error("Warehouse not found for this vendor. Please contact support.");
// // //         }
// // //       }
// // //       if (!warehouseId) throw new Error("Warehouse not found for this vendor. Please contact support.");
// // //     }

// // //     const orderItems = cart.map((item) => {
// // //       let pId = item._id || item.productId;
// // //       if (!isOid(pId)) pId = "000000000000000000000001";
// // //       return {
// // //         productId: pId,
// // //         productName: item.name || item.productName || "Product",
// // //         price: parseFloat(item.price) || 0,
// // //         qty: parseInt(item.qty) || 1,
// // //         vendorId: vendorId || null,
// // //       };
// // //     });

// // //     const totalWeight = Math.max(
// // //       cart.reduce((s, i) => s + (parseFloat(i.weight) || 0.5) * (parseInt(i.qty) || 1), 0),
// // //       0.1
// // //     ).toFixed(2);

// // //     const payload = {
// // //       customer: customerId,
// // //       vendorId: vendorId || null,
// // //       warehouseId: warehouseId || null,
// // //       isPublicOrder: allCartItemsPublic,
// // //       orderItems,
// // //       amount: totals.total,
// // //       couponCode: appliedCoupon?.code || null,
// // //       couponDiscount,
// // //       subtotal: totals.subtotal,
// // //       deliveryFee: totals.deliveryFee,
// // //       platformFee: totals.platformFee,
// // //       gst: totals.gst,
// // //       paymentMethod: formData.paymentMethod,
// // //       shippingAddress: {
// // //         name: formData.name,
// // //         email: formData.email,
// // //         phone: formData.phone,
// // //         address: formData.address,
// // //         city: formData.city,
// // //         state: formData.state,
// // //         pincode: formData.pincode,
// // //       },
// // //       shipment: {
// // //         weight: parseFloat(formData.weight) || parseFloat(totalWeight),
// // //         length: parseFloat(formData.length) || 15,
// // //         width: parseFloat(formData.width) || 10,
// // //         height: parseFloat(formData.height) || 5,
// // //       },
// // //     };

// // //     const res = await fetch(`${API_BASE_URL}/parcelx/order`, {
// // //       method: "POST",
// // //       headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
// // //       body: JSON.stringify(payload),
// // //     });
// // //     const json = await res.json();
// // //     if (!res.ok || !json.success) {
// // //       const errMsg = json.parcelxError || json.parcelx?.message || json.message || "Failed to create order";
// // //       throw new Error(errMsg);
// // //     }
// // //     return json.order;
// // //   };

// // //   const createRazorpayOrderFromBackend = async (orderId) => {
// // //     const token = getToken();
// // //     const res = await fetch(`${API_BASE_URL}/razorpay/create-order`, {
// // //       method: "POST",
// // //       headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
// // //       body: JSON.stringify({ orderId, amount: Math.round(totals.total * 100), currency: "INR" }),
// // //     });
// // //     const json = await res.json();
// // //     if (!res.ok || !json.success) throw new Error(json.message || "Failed to init payment");
// // //     return { razorpayOrderId: json.razorpayOrderId, amount: Math.round(totals.total * 100), currency: json.currency || "INR", key: json.key };
// // //   };

// // //   const verifyRazorpayPayment = async (payload) => {
// // //     const token = getToken();
// // //     const res = await fetch(`${API_BASE_URL}/razorpay/verify-payment`, {
// // //       method: "POST",
// // //       headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
// // //       body: JSON.stringify(payload),
// // //     });
// // //     return res.json();
// // //   };

// // //   const initiateRazorpayPayment = async (order) => {
// // //     setPaymentLoading(true); setPaymentError(null);
// // //     try {
// // //       if (!window.Razorpay) await loadRazorpayScript();
// // //       const razorpayKey = getRazorpayPublicKey(razorpayMeta);
// // //       if (!razorpayKey) throw new Error("Razorpay key missing");
// // //       const rp = new window.Razorpay({
// // //         key: razorpayKey,
// // //         amount: Math.round(totals.total * 100),
// // //         currency: razorpayMeta?.currency || "INR",
// // //         name: "HAVBIT",
// // //         description: `Order #${order._id?.slice(-8).toUpperCase()}`,
// // //         image: "/logo.png",
// // //         order_id: razorpayMeta?.razorpayOrderId,
// // //         handler: async (response) => {
// // //           const v = await verifyRazorpayPayment({
// // //             orderId: order._id,
// // //             razorpay_payment_id: response.razorpay_payment_id,
// // //             razorpay_order_id: response.razorpay_order_id,
// // //             razorpay_signature: response.razorpay_signature,
// // //           });
// // //           if (v.success) {
// // //             // await createParcelxOrder();
// // //             const updated = { ...order, paymentStatus: "Success", orderStatus: "Confirmed", razorpayPaymentId: response.razorpay_payment_id };
// // //             saveOrderToStorage(updated);
// // //             setConfirmedCart([...cart]);
// // //             setConfirmedTotals({ ...totals });
// // //             setConfirmedPaymentMethod(formData.paymentMethod);
// // //             setConfirmedCoupon(appliedCoupon ? { ...appliedCoupon } : null);
// // //             setOrderDetails({
// // //               orderId: updated._id, paymentMethod: "razorpay",
// // //               amount: totals.total, orderStatus: "Confirmed", paymentStatus: "Success",
// // //               razorpayPaymentId: updated.razorpayPaymentId,
// // //               coupon: appliedCoupon, awb: order.parcelx?.awb,
// // //               courier: order.parcelx?.courier, trackingUrl: order.parcelx?.tracking_url,
// // //             });
// // //             setPaymentSuccess(true); setStep(3);
// // //             if (clearCart) { clearCart(); localStorage.removeItem("cart"); }
// // //           } else {
// // //             setPaymentError(v.message || "Verification failed");
// // //           }
// // //         },
// // //         prefill: { name: formData.name, email: formData.email, contact: formData.phone },
// // //         notes: { orderId: order._id },
// // //         theme: { color: "#dc2626" },
// // //         modal: { ondismiss: () => { setPaymentError("Payment cancelled"); setPaymentLoading(false); } },
// // //       });
// // //       rp.open();
// // //       rp.on("payment.failed", (r) => {
// // //         setPaymentError(r.error?.description || "Payment failed"); setPaymentLoading(false);
// // //       });
// // //     } catch (err) {
// // //       setPaymentError(err.message); setPaymentLoading(false);
// // //     }
// // //   };

// // //   // const handleCreateOrder = async () => {
// // //   //   if (!validateForm()) return;
// // //   //   setLoading(true); setPaymentError(null);
// // //   //   try {
// // //   //     const createdOrder = await createParcelxOrder();
// // //   //     setBackendOrderData(createdOrder);
// // //   //     saveOrderToStorage(createdOrder);
// // //   //     if (formData.paymentMethod === "razorpay") {
// // //   //       const rpMeta = await createRazorpayOrderFromBackend(createdOrder._id);
// // //   //       setRazorpayMeta(rpMeta);
// // //   //     } else {
// // //   //       saveOrderToStorage({ ...createdOrder, paymentStatus: "Pending", orderStatus: "Confirmed" });
// // //   //       setConfirmedCart([...cart]);
// // //   //       setConfirmedTotals({ ...totals });
// // //   //       setConfirmedPaymentMethod(formData.paymentMethod);
// // //   //       setConfirmedCoupon(appliedCoupon ? { ...appliedCoupon } : null);
// // //   //       setOrderDetails({
// // //   //         orderId: createdOrder._id, paymentMethod: "cod",
// // //   //         amount: totals.total, orderStatus: "Confirmed", paymentStatus: "Pending",
// // //   //         coupon: appliedCoupon, awb: createdOrder.parcelx?.awb,
// // //   //         courier: createdOrder.parcelx?.courier, trackingUrl: createdOrder.parcelx?.tracking_url,
// // //   //       });
// // //   //       setPaymentSuccess(true); setStep(3);
// // //   //       if (clearCart) { clearCart(); localStorage.removeItem("cart"); }
// // //   //     }
// // //   //   } catch (e) {
// // //   //     setPaymentError(e.message);
// // //   //     if (/expired|invalid|session/i.test(e.message)) {
// // //   //       alert("Session expired — please login again.");
// // //   //       navigate("/login", { state: { from: "/checkout" } });
// // //   //     }
// // //   //   } finally { setLoading(false); }
// // //   // };
  
// // //   const handleCreateOrder = async () => {
// // //   if (!validateForm()) return;

// // //   setLoading(true);
// // //   setPaymentError(null);

// // //   try {
// // //     // let createdOrder;

// // //     // ✅ STEP 1: COD vs ONLINE handling
// // //     // if (formData.paymentMethod === "cod") {
// // //     //   // COD → order + shipment (same as before)
// // //     //   createdOrder = await createParcelxOrder();
// // //     // } else {
// // //     //   // ONLINE → sirf order create (NO shipment)
// // //     //   createdOrder = await createOrderOnly();
// // //     // }

// // //     const createdOrder = await createParcelxOrder();

// // //     // ✅ STEP 2: Save order
// // //     setBackendOrderData(createdOrder);
// // //     saveOrderToStorage(createdOrder);

// // //     // ✅ STEP 3: Payment handling
// // //     if (formData.paymentMethod === "razorpay") {
// // //       // 👉 Razorpay order create
// // //       const rpMeta = await createRazorpayOrderFromBackend(createdOrder._id);
// // //       setRazorpayMeta(rpMeta);
// // //     } else {
// // //       // ✅ COD success flow
// // //       const updatedOrder = {
// // //         ...createdOrder,
// // //         paymentStatus: "Pending",
// // //         orderStatus: "Confirmed",
// // //       };

// // //       saveOrderToStorage(updatedOrder);

// // //       setConfirmedCart([...cart]);
// // //       setConfirmedTotals({ ...totals });
// // //       setConfirmedPaymentMethod(formData.paymentMethod);
// // //       setConfirmedCoupon(appliedCoupon ? { ...appliedCoupon } : null);

// // //       setOrderDetails({
// // //         orderId: updatedOrder._id,
// // //         paymentMethod: "cod",
// // //         amount: totals.total,
// // //         orderStatus: "Confirmed",
// // //         paymentStatus: "Pending",
// // //         coupon: appliedCoupon,
// // //         awb: updatedOrder.parcelx?.awb,
// // //         courier: updatedOrder.parcelx?.courier,
// // //         trackingUrl: updatedOrder.parcelx?.tracking_url,
// // //       });

// // //       setPaymentSuccess(true);
// // //       setStep(3);

// // //       if (clearCart) {
// // //         clearCart();
// // //         localStorage.removeItem("cart");
// // //       }
// // //     }

// // //   } catch (e) {
// // //     setPaymentError(e.message);

// // //     if (/expired|invalid|session/i.test(e.message)) {
// // //       alert("Session expired — please login again.");
// // //       navigate("/login", { state: { from: "/checkout" } });
// // //     }

// // //   } finally {
// // //     setLoading(false);
// // //   }
// // // };

// // //   const handleBack = () => {
// // //     if (step === 1) navigate("/cart");
// // //     else if (step === 3) navigate("/orders");
// // //     else setStep(1);
// // //   };

// // //   /* ─────────────── GUARDS ─────────────── */
// // //   if (!isAuthenticated) return (
// // //     <div className="min-h-screen flex items-center justify-center bg-gray-50">
// // //       <div className="text-center">
// // //         <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
// // //           <FiLogIn className="text-red-600" size={24} />
// // //         </div>
// // //         <h2 className="text-xl font-bold text-gray-900 mb-2">Login Required</h2>
// // //         <p className="text-gray-500 text-sm mb-6">Please login to place an order</p>
// // //         <button
// // //           onClick={() => navigate("/login", { state: { from: "/checkout" } })}
// // //           className="px-6 py-3 bg-red-600 text-white rounded-xl font-semibold hover:bg-red-700 transition"
// // //         >
// // //           Login Now
// // //         </button>
// // //       </div>
// // //     </div>
// // //   );

// // //   if (cart.length === 0 && step !== 3) return (
// // //     <div className="min-h-screen flex items-center justify-center bg-gray-50">
// // //       <div className="text-center">
// // //         <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
// // //           <FiShoppingBag className="text-red-600" size={24} />
// // //         </div>
// // //         <h2 className="text-xl font-bold text-gray-900 mb-2">Cart is Empty</h2>
// // //         <p className="text-gray-500 text-sm mb-6">Add products before checking out</p>
// // //         <button
// // //           onClick={() => navigate("/products")}
// // //           className="px-6 py-3 bg-red-600 text-white rounded-xl font-semibold hover:bg-red-700 transition"
// // //         >
// // //           Shop Now
// // //         </button>
// // //       </div>
// // //     </div>
// // //   );

// // //   const sidebarCart    = step === 3 && confirmedCart.length > 0 ? confirmedCart : cart;
// // //   const sidebarTotals  = step === 3 && confirmedTotals          ? confirmedTotals : totals;
// // //   const sidebarPayment = step === 3 && confirmedPaymentMethod   ? confirmedPaymentMethod : formData.paymentMethod;
// // //   const sidebarCoupon  = step === 3                             ? confirmedCoupon : appliedCoupon;

// // //   /* ─────────────── RENDER ─────────────── */
// // //   return (
// // //     <div className="min-h-screen bg-gray-50">
// // //       {/* ── Top Bar ── */}
// // //       <div className="bg-white border-b border-gray-200 sticky top-0 z-30 shadow-sm">
// // //         <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
// // //           <button
// // //             onClick={handleBack}
// // //             className="flex items-center gap-2 text-gray-500 hover:text-red-600 transition-colors text-sm font-medium"
// // //           >
// // //             <FiArrowLeft size={16} />
// // //             <span className="hidden sm:inline">
// // //               {step === 3 ? "View Orders" : step === 2 ? "Back to Address" : "Back to Cart"}
// // //             </span>
// // //           </button>

// // //           <div className="flex items-center gap-2">
// // //             <div className="w-8 h-8 bg-red-600 rounded-lg flex items-center justify-center">
// // //               <FiShoppingBag className="text-white" size={14} />
// // //             </div>
// // //             <span className="font-bold text-gray-900 text-sm hidden sm:inline">Checkout</span>
// // //           </div>

// // //           <div className="flex items-center gap-2">
// // //             <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
// // //               <FiUser className="text-gray-600" size={14} />
// // //             </div>
// // //             <span className="text-sm font-medium text-gray-700 hidden sm:block">
// // //               {user?.fullName?.split(" ")[0] || user?.name?.split(" ")[0] || "User"}
// // //             </span>
// // //           </div>
// // //         </div>
// // //       </div>

// // //       <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
// // //         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
// // //           {/* ── Main Panel ── */}
// // //           <div className="lg:col-span-2">
// // //             <StepIndicator current={step} />

// // //             {vendorLoading && !allCartItemsPublic && (
// // //               <motion.div
// // //                 initial={{ opacity: 0, y: -8 }}
// // //                 animate={{ opacity: 1, y: 0 }}
// // //                 className="mb-5 flex items-center gap-3 px-4 py-3 bg-blue-50 border border-blue-200 rounded-xl text-sm text-blue-700"
// // //               >
// // //                 <FiLoader className="animate-spin shrink-0" size={15} />
// // //                 <span>Setting up shipping configuration...</span>
// // //               </motion.div>
// // //             )}

// // //             {vendorError && !vendorLoading && !allCartItemsPublic && (
// // //               <motion.div
// // //                 initial={{ opacity: 0, y: -8 }}
// // //                 animate={{ opacity: 1, y: 0 }}
// // //                 className="mb-5 flex items-start gap-3 px-4 py-3 bg-amber-50 border border-amber-300 rounded-xl"
// // //               >
// // //                 <FiAlertCircle className="text-amber-500 shrink-0 mt-0.5" size={15} />
// // //                 <div className="flex-1">
// // //                   <p className="text-sm font-semibold text-amber-800">Shipping Setup Issue</p>
// // //                   <p className="text-xs text-amber-700 mt-0.5">{vendorError}</p>
// // //                   <button
// // //                     onClick={resolveVendorAndWarehouse}
// // //                     className="mt-1.5 text-xs text-blue-600 underline hover:text-blue-700"
// // //                   >
// // //                     Retry →
// // //                   </button>
// // //                 </div>
// // //               </motion.div>
// // //             )}

// // //             {paymentError && (
// // //               <motion.div
// // //                 initial={{ opacity: 0, y: -8 }}
// // //                 animate={{ opacity: 1, y: 0 }}
// // //                 className="mb-5 flex items-center gap-3 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-sm text-red-700"
// // //               >
// // //                 <FiXCircle className="shrink-0" size={15} />
// // //                 <span>{paymentError}</span>
// // //               </motion.div>
// // //             )}

// // //             <AnimatePresence mode="wait">

// // //               {/* ══════ STEP 1 – ADDRESS ══════ */}
// // //               {step === 1 && (
// // //                 <motion.div
// // //                   key="step1"
// // //                   initial={{ opacity: 0, x: 20 }}
// // //                   animate={{ opacity: 1, x: 0 }}
// // //                   exit={{ opacity: 0, x: -20 }}
// // //                   transition={{ duration: 0.25 }}
// // //                 >
// // //                   <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
// // //                     <div className="px-6 pt-6 pb-4 border-b border-gray-100">
// // //                       <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
// // //                         <FiMapPin className="text-red-500" size={18} />
// // //                         Delivery Address
// // //                       </h2>
// // //                       <p className="text-xs text-gray-500 mt-1">Where should we send your order?</p>
// // //                     </div>

// // //                     <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-5">
// // //                       <Field label="Full Name" icon={FiUser} name="name" type="text"
// // //                         placeholder="Your full name" value={formData.name}
// // //                         onChange={handleChange} error={fieldErrors.name} />
// // //                       <Field label="Email" icon={FiMail} name="email" type="email"
// // //                         placeholder="email@example.com" value={formData.email}
// // //                         onChange={handleChange} error={fieldErrors.email} />
// // //                       <Field label="Phone" icon={FiPhone} name="phone" type="tel"
// // //                         placeholder="10-digit mobile number" value={formData.phone}
// // //                         onChange={handleChange} error={fieldErrors.phone} />
// // //                       <Field label="Pincode" icon={FiMapPin} name="pincode" type="text"
// // //                         placeholder="6-digit pincode" maxLength={6} value={formData.pincode}
// // //                         onChange={handleChange} error={fieldErrors.pincode} />

// // //                       <div className="sm:col-span-2 flex flex-col gap-1.5">
// // //                         <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
// // //                           Complete Address
// // //                         </label>
// // //                         <div className="relative">
// // //                           <FiHome size={14} className="absolute left-3.5 top-3.5 text-gray-400 pointer-events-none" />
// // //                           <textarea
// // //                             name="address"
// // //                             rows={3}
// // //                             value={formData.address}
// // //                             onChange={handleChange}
// // //                             placeholder="House no., Building, Street, Area, Landmark..."
// // //                             className={`w-full pl-10 pr-4 py-3 bg-gray-50 border ${
// // //                               fieldErrors.address ? "border-red-400" : "border-gray-200"
// // //                             } rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-400 focus:bg-white transition-all resize-none`}
// // //                           />
// // //                         </div>
// // //                         {fieldErrors.address && <p className="text-xs text-red-500">{fieldErrors.address}</p>}
// // //                       </div>

// // //                       <Field label="City" icon={FiMapPin} name="city" type="text"
// // //                         placeholder="Your city" value={formData.city}
// // //                         onChange={handleChange} error={fieldErrors.city} />
// // //                       <Field label="State" icon={FiMapPin} name="state" type="text"
// // //                         placeholder="Your state" value={formData.state}
// // //                         onChange={handleChange} error={fieldErrors.state} />
// // //                     </div>

// // //                     {/* Dimensions */}
// // //                     <div className="px-6 pb-4">
// // //                       <details className="group">
// // //                         <summary className="cursor-pointer text-xs font-semibold text-blue-600 flex items-center gap-1.5 select-none list-none">
// // //                           <FiPackage size={13} />
// // //                           <span>Advanced: Shipment Dimensions</span>
// // //                         </summary>
// // //                         <div className="mt-3 p-4 bg-blue-50 border border-blue-200 rounded-xl">
// // //                           <p className="text-xs text-blue-700 mb-3">
// // //                             Used by ParcelX for rate calculation. Defaults are pre-filled.
// // //                           </p>
// // //                           <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
// // //                             {[
// // //                               { label: "Weight (kg)", name: "weight" },
// // //                               { label: "Length (cm)", name: "length" },
// // //                               { label: "Width (cm)", name: "width" },
// // //                               { label: "Height (cm)", name: "height" },
// // //                             ].map((f) => (
// // //                               <div key={f.name}>
// // //                                 <label className="block text-xs font-medium text-blue-800 mb-1">{f.label}</label>
// // //                                 <input
// // //                                   type="number"
// // //                                   name={f.name}
// // //                                   value={formData[f.name]}
// // //                                   onChange={handleChange}
// // //                                   step="0.1"
// // //                                   min="0.1"
// // //                                   className="w-full px-3 py-2 bg-white border border-blue-200 rounded-lg text-xs focus:outline-none focus:ring-1 focus:ring-blue-400"
// // //                                 />
// // //                               </div>
// // //                             ))}
// // //                           </div>
// // //                         </div>
// // //                       </details>
// // //                     </div>

// // //                     {/* Shipping strip */}
// // //                     <div className="mx-6 mb-6 flex items-center justify-between px-4 py-3 bg-gradient-to-r from-red-50 to-orange-50 border border-red-100 rounded-xl">
// // //                       <div className="flex items-center gap-2">
// // //                         <FiTruck className="text-red-500 shrink-0" size={15} />
// // //                         <span className="text-xs font-semibold text-gray-700">
// // //                           Shipped 3-5 working days
// // //                         </span>
// // //                       </div>
// // //                       <div className="text-xs">
// // //                         {allCartItemsPublic ? (
// // //                           <span className="text-green-600 flex items-center gap-1 font-medium">
// // //                             <FiCheckCircle size={11} /> Auto-configured
// // //                           </span>
// // //                         ) : vendorLoading ? (
// // //                           <span className="text-blue-500 flex items-center gap-1">
// // //                             <FiLoader className="animate-spin" size={11} /> Loading...
// // //                           </span>
// // //                         ) : resolvedWarehouseId ? (
// // //                           <span className="text-green-600 flex items-center gap-1 font-medium">
// // //                             <FiCheckCircle size={11} /> Ready
// // //                           </span>
// // //                         ) : (
// // //                           <span className="text-amber-600 flex items-center gap-1">
// // //                             <FiAlertCircle size={11} /> Pending
// // //                           </span>
// // //                         )}
// // //                       </div>
// // //                     </div>

// // //                     <div className="px-6 pb-6">
// // //                       <button
// // //                         onClick={handleProceedToPayment}
// // //                         className="w-full py-3.5 bg-gradient-to-r from-red-600 to-red-500 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-600 transition-all shadow-lg shadow-red-200 flex items-center justify-center gap-2 text-sm"
// // //                       >
// // //                         <FiCreditCard size={16} />
// // //                         Proceed to Payment
// // //                       </button>
// // //                     </div>
// // //                   </div>
// // //                 </motion.div>
// // //               )}

// // //               {/* ══════ STEP 2 – PAYMENT ══════ */}
// // //               {step === 2 && (
// // //                 <motion.div
// // //                   key="step2"
// // //                   initial={{ opacity: 0, x: 20 }}
// // //                   animate={{ opacity: 1, x: 0 }}
// // //                   exit={{ opacity: 0, x: -20 }}
// // //                   transition={{ duration: 0.25 }}
// // //                 >
// // //                   <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
// // //                     <div className="px-6 pt-6 pb-4 border-b border-gray-100">
// // //                       <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
// // //                         <FiCreditCard className="text-red-500" size={18} />
// // //                         Payment Method
// // //                       </h2>
// // //                       <p className="text-xs text-gray-500 mt-1">How would you like to pay?</p>
// // //                     </div>

// // //                     <div className="p-6 space-y-3">
// // //                       {[
// // //                         {
// // //                           value: "cod",
// // //                           label: "Cash on Delivery",
// // //                           sub: "Pay when your order arrives • ₹30 delivery charge",
// // //                           badge: "Most Popular",
// // //                           icon: <FaPhoneAlt className="text-green-600" size={18} />,
// // //                           badgeColor: "bg-green-100 text-green-700",
// // //                           activeColor: "border-green-400 bg-green-50",
// // //                           deliveryNote: (
// // //                             <span className="text-xs text-orange-600 flex items-center gap-1 mt-1">
// // //                               <FiInfo size={11} /> ₹30 delivery charge applies for COD
// // //                             </span>
// // //                           ),
// // //                         },
// // //                         {
// // //                           value: "razorpay",
// // //                           label: "Online Payment",
// // //                           sub: "Cards • UPI • Net Banking • Wallets",
// // //                           badge: "FREE Delivery",
// // //                           icon: <FiCreditCard className="text-blue-600" size={18} />,
// // //                           badgeColor: "bg-green-100 text-green-700",
// // //                           activeColor: "border-blue-400 bg-blue-50",
// // //                           deliveryNote: (
// // //                             <span className="text-xs text-green-600 flex items-center gap-1 mt-1">
// // //                               <FiCheckCircle size={11} /> Free delivery on online payment!
// // //                             </span>
// // //                           ),
// // //                         },
// // //                       ].map((opt) => (
// // //                         <label
// // //                           key={opt.value}
// // //                           className={`flex items-start gap-4 p-4 border-2 rounded-xl cursor-pointer transition-all ${
// // //                             formData.paymentMethod === opt.value
// // //                               ? opt.activeColor
// // //                               : "border-gray-200 hover:border-gray-300 bg-white"
// // //                           }`}
// // //                         >
// // //                           <input
// // //                             type="radio"
// // //                             name="paymentMethod"
// // //                             value={opt.value}
// // //                             checked={formData.paymentMethod === opt.value}
// // //                             onChange={handleChange}
// // //                             className="w-4 h-4 accent-red-600 mt-1"
// // //                           />
// // //                           <div className="w-10 h-10 bg-white border border-gray-200 rounded-xl flex items-center justify-center shadow-sm shrink-0">
// // //                             {opt.icon}
// // //                           </div>
// // //                           <div className="flex-1">
// // //                             <div className="flex items-center gap-2 flex-wrap">
// // //                               <p className="font-bold text-gray-900 text-sm">{opt.label}</p>
// // //                               <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${opt.badgeColor}`}>
// // //                                 {opt.badge}
// // //                               </span>
// // //                             </div>
// // //                             <p className="text-xs text-gray-500 mt-0.5">{opt.sub}</p>
// // //                             {opt.deliveryNote}
// // //                           </div>
// // //                           {formData.paymentMethod === opt.value && (
// // //                             <div className="w-5 h-5 bg-red-600 rounded-full flex items-center justify-center shrink-0 mt-1">
// // //                               <FiCheck className="text-white" size={11} />
// // //                             </div>
// // //                           )}
// // //                         </label>
// // //                       ))}
// // //                     </div>

// // //                     {/* Coupon Section */}
// // //                     <div className="px-6 pb-4">
// // //                       <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl">
// // //                         <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
// // //                           <FiTag className="text-orange-500" size={15} />
// // //                           Have a Coupon?
// // //                         </h3>
// // //                         <div className="flex gap-2">
// // //                           <input
// // //                             type="text"
// // //                             value={couponCode}
// // //                             onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
// // //                             placeholder="ENTER CODE"
// // //                             disabled={!!appliedCoupon}
// // //                             className="flex-1 px-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm font-mono font-semibold tracking-widest focus:outline-none focus:ring-2 focus:ring-orange-400 disabled:bg-gray-100 disabled:text-gray-400 uppercase"
// // //                           />
// // //                           {appliedCoupon ? (
// // //                             <button
// // //                               onClick={handleRemoveCoupon}
// // //                               className="px-4 py-2.5 bg-red-100 text-red-600 font-semibold rounded-xl hover:bg-red-200 transition text-sm"
// // //                             >
// // //                               Remove
// // //                             </button>
// // //                           ) : (
// // //                             <button
// // //                               onClick={handleApplyCoupon}
// // //                               disabled={couponLoading}
// // //                               className="px-4 py-2.5 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-600 transition disabled:opacity-50 text-sm flex items-center gap-1.5"
// // //                             >
// // //                               {couponLoading ? <FiLoader className="animate-spin" size={14} /> : "Apply"}
// // //                             </button>
// // //                           )}
// // //                         </div>
// // //                         {couponError && (
// // //                           <p className="mt-2 text-xs text-red-500 flex items-center gap-1">
// // //                             <FiAlertCircle size={12} /> {couponError}
// // //                           </p>
// // //                         )}
// // //                         {appliedCoupon && (
// // //                           <div className="mt-3 flex items-center justify-between px-3 py-2.5 bg-green-50 border border-green-200 rounded-lg">
// // //                             <span className="flex items-center gap-1.5 text-sm font-bold text-green-800">
// // //                               <FiCheckCircle className="text-green-600" size={14} />
// // //                               {appliedCoupon.code}
// // //                             </span>
// // //                             <span className="text-sm font-bold text-green-700">
// // //                               -₹{appliedCoupon.discount.toFixed(2)}
// // //                             </span>
// // //                           </div>
// // //                         )}
// // //                       </div>
// // //                     </div>

// // //                     {/* Amount Box */}
// // //                     <div className="px-6 pb-4">
// // //                       <div className="flex items-center justify-between px-5 py-4 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl text-white">
// // //                         <div>
// // //                           <p className="text-xs text-gray-400 font-medium">Total Payable</p>
// // //                           <p className="text-2xl font-extrabold mt-0.5">₹{totals.total.toFixed(2)}</p>
// // //                           {appliedCoupon && (
// // //                             <p className="text-xs text-green-400 mt-0.5">
// // //                               You saved ₹{couponDiscount.toFixed(2)} 🎉
// // //                             </p>
// // //                           )}
// // //                         </div>
// // //                         <div className="text-right text-xs text-gray-400 space-y-1">
// // //                           <p>Subtotal: ₹{totals.subtotal.toFixed(2)}</p>
// // //                           <p className={totals.deliveryFee === 0 ? "text-green-400" : "text-orange-400"}>
// // //                             Delivery: {totals.deliveryFee === 0 ? "FREE" : `₹${totals.deliveryFee}`}
// // //                           </p>
// // //                           {/* <p>GST: ₹{totals.gst.toFixed(2)}</p> */}
// // //                         </div>
// // //                       </div>
// // //                     </div>

// // //                     {/* CTA */}
// // //                     <div className="px-6 pb-6">
// // //                       {!backendOrderData ? (
// // //                         <button
// // //                           onClick={handleCreateOrder}
// // //                           disabled={loading}
// // //                           className="w-full py-3.5 bg-gradient-to-r from-red-600 to-red-500 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-600 transition-all shadow-lg shadow-red-200 flex items-center justify-center gap-2 text-sm disabled:opacity-60 disabled:cursor-not-allowed"
// // //                         >
// // //                           {loading ? (
// // //                             <>
// // //                               <FiLoader className="animate-spin" size={16} />
// // //                               Creating Order & Booking Shipment...
// // //                             </>
// // //                           ) : (
// // //                             <>
// // //                               <FiCheck size={16} />
// // //                               {formData.paymentMethod === "cod"
// // //                                 ? "Place Order (COD • ₹30 Delivery)"
// // //                                 : "Create Order & Pay Online (Free Delivery)"}
// // //                             </>
// // //                           )}
// // //                         </button>
// // //                       ) : formData.paymentMethod === "razorpay" ? (
// // //                         <button
// // //                           onClick={() => initiateRazorpayPayment(backendOrderData)}
// // //                           disabled={paymentLoading}
// // //                           className="w-full py-3.5 bg-gradient-to-r from-blue-600 to-blue-500 text-white font-bold rounded-xl hover:from-blue-700 hover:to-blue-600 transition-all shadow-lg shadow-blue-200 flex items-center justify-center gap-2 text-sm disabled:opacity-60"
// // //                         >
// // //                           {paymentLoading ? (
// // //                             <><FiLoader className="animate-spin" size={16} /> Opening Payment Gateway...</>
// // //                           ) : (
// // //                             <><FiCreditCard size={16} /> Pay ₹{totals.total.toFixed(2)} with Razorpay</>
// // //                           )}
// // //                         </button>
// // //                       ) : (
// // //                         <div className="p-4 bg-green-50 border border-green-200 rounded-xl">
// // //                           <div className="flex items-center gap-3 mb-3">
// // //                             <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center">
// // //                               <FiCheckCircle className="text-green-600" size={20} />
// // //                             </div>
// // //                             <div>
// // //                               <p className="font-bold text-green-800 text-sm">Order & AWB Created!</p>
// // //                               <p className="text-xs text-green-600">
// // //                                 #{backendOrderData._id?.slice(-8).toUpperCase()}
// // //                                 {backendOrderData.parcelx?.awb && (
// // //                                   <> · AWB: <strong>{backendOrderData.parcelx.awb}</strong></>
// // //                                 )}
// // //                               </p>
// // //                             </div>
// // //                           </div>
// // //                           <button
// // //                             onClick={() => setStep(3)}
// // //                             className="w-full py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition font-semibold text-sm"
// // //                           >
// // //                             View Confirmation →
// // //                           </button>
// // //                         </div>
// // //                       )}
// // //                       <p className="text-center text-xs text-gray-400 mt-3 flex items-center justify-center gap-1">
// // //                         <FiLock size={11} /> Secured with bank-level encryption
// // //                       </p>
// // //                     </div>
// // //                   </div>
// // //                 </motion.div>
// // //               )}

// // //               {/* ══════ STEP 3 – CONFIRMATION ══════ */}
// // //               {step === 3 && orderDetails && (
// // //                 <motion.div
// // //                   key="step3"
// // //                   initial={{ opacity: 0, scale: 0.96 }}
// // //                   animate={{ opacity: 1, scale: 1 }}
// // //                   transition={{ duration: 0.3 }}
// // //                 >
// // //                   {/* ── THANK YOU BANNER ── */}
// // //                   <motion.div
// // //                     initial={{ opacity: 0, y: -16 }}
// // //                     animate={{ opacity: 1, y: 0 }}
// // //                     transition={{ delay: 0.15, duration: 0.4 }}
// // //                     className="mb-4 rounded-2xl overflow-hidden bg-gradient-to-r from-red-600 via-red-500 to-orange-500 px-6 py-5 flex items-center justify-between shadow-lg shadow-red-200"
// // //                   >
// // //                     <div>
// // //                       <p className="text-white/80 text-xs font-semibold uppercase tracking-widest mb-1">
// // //                         HAVBIT
// // //                       </p>
// // //                       <h2 className="text-white text-xl font-extrabold leading-tight">
// // //                         Thank you for your order,
// // //                       </h2>
// // //                       <p className="text-white/90 text-lg font-bold">
// // //                         {formData.name?.split(" ")[0] || "Friend"}! 🎉
// // //                       </p>
// // //                       <p className="text-white/70 text-xs mt-1.5">
// // //                         We're thrilled to have you shop with us. Your order is in safe hands!
// // //                       </p>
// // //                     </div>
// // //                     <motion.div
// // //                       animate={{ scale: [1, 1.15, 1] }}
// // //                       transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
// // //                       className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center shrink-0 ml-4"
// // //                     >
// // //                       <FiHeart className="text-white" size={30} />
// // //                     </motion.div>
// // //                   </motion.div>

// // //                   {/* ── ORDER CONFIRMED CARD ── */}
// // //                   <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
// // //                     {/* Success Header */}
// // //                     <div className="bg-gradient-to-br from-green-500 to-emerald-600 px-6 py-10 text-center">
// // //                       <motion.div
// // //                         initial={{ scale: 0 }}
// // //                         animate={{ scale: 1 }}
// // //                         transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
// // //                         className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg"
// // //                       >
// // //                         {paymentSuccess ? (
// // //                           <FiCheck className="text-green-500" size={36} />
// // //                         ) : (
// // //                           <FiAlertCircle className="text-amber-500" size={36} />
// // //                         )}
// // //                       </motion.div>
// // //                       <motion.h2
// // //                         initial={{ opacity: 0, y: 10 }}
// // //                         animate={{ opacity: 1, y: 0 }}
// // //                         transition={{ delay: 0.3 }}
// // //                         className="text-2xl font-extrabold text-white mb-1"
// // //                       >
// // //                         {paymentSuccess ? "Order Confirmed! 🎉" : "Order Created"}
// // //                       </motion.h2>
// // //                       <motion.p
// // //                         initial={{ opacity: 0 }}
// // //                         animate={{ opacity: 1 }}
// // //                         transition={{ delay: 0.4 }}
// // //                         className="text-green-100 text-sm"
// // //                       >
// // //                         {paymentSuccess
// // //                           ? "Your order is confirmed and shipment booked"
// // //                           : "Order placed but payment pending"}
// // //                       </motion.p>
// // //                     </div>

// // //                     <div className="p-6 space-y-4">
// // //                       {/* Order Details Grid */}
// // //                       <div className="grid grid-cols-2 gap-3">
// // //                         {[
// // //                           { label: "Order ID", value: `#${orderDetails.orderId?.slice(-8).toUpperCase()}` },
// // //                           {
// // //                             label: "Amount",
// // //                             value: `₹${orderDetails.amount?.toFixed(2)}`,
// // //                             valueClass: "text-green-600",
// // //                           },
// // //                           {
// // //                             label: "Payment",
// // //                             value: orderDetails.paymentMethod === "cod" ? "Cash on Delivery" : "Online Payment",
// // //                           },
// // //                           {
// // //                             label: "Status",
// // //                             value: orderDetails.orderStatus || "Confirmed",
// // //                             valueClass: "text-green-600",
// // //                           },
// // //                         ].map((item) => (
// // //                           <div key={item.label} className="bg-gray-50 rounded-xl p-3">
// // //                             <p className="text-xs text-gray-500 uppercase tracking-wider font-medium mb-1">
// // //                               {item.label}
// // //                             </p>
// // //                             <p className={`font-bold text-gray-900 text-sm ${item.valueClass || ""}`}>
// // //                               {item.value}
// // //                             </p>
// // //                           </div>
// // //                         ))}
// // //                       </div>

// // //                       {orderDetails.paymentMethod === "cod" && (
// // //                         <div className="flex items-center gap-2 px-4 py-3 bg-orange-50 border border-orange-200 rounded-xl text-xs text-orange-700">
// // //                           <FiInfo size={13} className="shrink-0" />
// // //                           <span>₹30 delivery charge included • Pay on delivery</span>
// // //                         </div>
// // //                       )}

// // //                       {orderDetails.coupon && (
// // //                         <div className="flex items-center justify-between px-4 py-3 bg-green-50 border border-green-200 rounded-xl">
// // //                           <span className="flex items-center gap-2 text-sm font-semibold text-green-800">
// // //                             <FiTag className="text-green-600" size={14} />
// // //                             Coupon saved!
// // //                           </span>
// // //                           <span className="font-bold text-green-700">
// // //                             -₹{orderDetails.coupon.discount.toFixed(2)}
// // //                           </span>
// // //                         </div>
// // //                       )}

// // //                       <div className="text-center py-3 px-4 bg-gray-50 rounded-xl">
// // //                         <p className="text-xs text-gray-500">
// // //                           Updates sent to{" "}
// // //                           <span className="font-semibold text-gray-700">{formData.email}</span>
// // //                           {" "}and{" "}
// // //                           <span className="font-semibold text-gray-700">{formData.phone}</span>
// // //                         </p>
// // //                       </div>

// // //                       {/* Action Buttons */}
// // //                       <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
// // //                         <button
// // //                           onClick={() => navigate(`/order/${orderDetails.orderId}`)}
// // //                           className="py-3.5 bg-gradient-to-r from-red-600 to-red-500 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-600 transition text-sm"
// // //                         >
// // //                           View Order Details
// // //                         </button>
// // //                         <button
// // //                           onClick={() => navigate("/products")}
// // //                           className="py-3.5 border-2 border-gray-200 text-gray-700 font-bold rounded-xl hover:bg-gray-50 hover:border-gray-300 transition text-sm"
// // //                         >
// // //                           Continue Shopping
// // //                         </button>
// // //                       </div>
// // //                     </div>
// // //                   </div>
// // //                 </motion.div>
// // //               )}
// // //             </AnimatePresence>
// // //           </div>

// // //           {/* ── Sidebar ── */}
// // //           <div className="lg:col-span-1">
// // //             <OrderSummary
// // //               cart={sidebarCart}
// // //               totals={sidebarTotals}
// // //               appliedCoupon={sidebarCoupon}
// // //               paymentMethod={sidebarPayment}
// // //             />

// // //             {/* Account info */}
// // //             <div className="mt-5 bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
// // //               <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
// // //                 <FiUser className="text-red-500" size={14} /> Account
// // //               </h3>
// // //               <div className="space-y-1.5">
// // //                 {[
// // //                   { label: "Name", value: user?.fullName || user?.name || "—" },
// // //                   { label: "Email", value: user?.email || "—" },
// // //                   { label: "Phone", value: user?.phone || "—" },
// // //                 ].map(({ label, value }) => (
// // //                   <div key={label} className="flex items-center justify-between text-xs">
// // //                     <span className="text-gray-400">{label}</span>
// // //                     <span className="font-semibold text-gray-700 truncate max-w-[60%] text-right">
// // //                       {value}
// // //                     </span>
// // //                   </div>
// // //                 ))}
// // //               </div>
// // //             </div>

// // //             {/* Help */}
// // //             <div className="mt-4 bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
// // //               <h3 className="text-sm font-bold text-gray-900 mb-2 flex items-center gap-2">
// // //                 <FiInfo className="text-red-500" size={14} /> Need Help?
// // //               </h3>
// // //               <div className="text-xs text-gray-500 space-y-1">
// // //                 <p>support@havbit.in</p>
// // //                 <p>+91 12345 67890</p>
// // //                 <p className="text-gray-400">Mon-Sat · 9 AM - 6 PM</p>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // }




























// // import React, { useState, useEffect, useCallback } from "react";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import { motion, AnimatePresence } from "framer-motion";
// // import {
// //   FiArrowLeft, FiCreditCard, FiUser, FiCheck, FiLoader,
// //   FiCheckCircle, FiXCircle, FiAlertCircle, FiLogIn, FiShoppingBag,
// //   FiLock, FiShield, FiPackage, FiTruck, FiInfo, FiTag, FiExternalLink,
// //   FiMapPin, FiPhone, FiMail, FiHome, FiHeart,
// // } from "react-icons/fi";
// // import { FaPhoneAlt, FaRupeeSign } from "react-icons/fa";
// // import { useAuth } from "../context/AuthContext";

// // const API_BASE_URL = "https://server.havbit.in/api";

// // const SAVED_ADDRESS_KEY = "havbit_saved_address";

// // /* ─────────────────────────────────────────────────────────
// //    HELPERS
// // ───────────────────────────────────────────────────────── */
// // const loadRazorpayScript = () =>
// //   new Promise((resolve, reject) => {
// //     if (window.Razorpay) return resolve(true);
// //     const s = document.createElement("script");
// //     s.src = "https://checkout.razorpay.com/v1/checkout.js";
// //     s.onload = () => resolve(true);
// //     s.onerror = () => reject(new Error("Failed to load Razorpay SDK"));
// //     document.body.appendChild(s);
// //   });

// // const getRazorpayPublicKey = (obj) =>
// //   obj?.razorpayKey || obj?.key || obj?.razorpay_key || process.env.REACT_APP_RAZORPAY_KEY_ID;

// // const isOid = (v) => typeof v === "string" && /^[0-9a-fA-F]{24}$/.test(v);

// // const extractVendorId = (obj) => {
// //   if (!obj) return null;
// //   const candidates = [
// //     obj.vendorId,
// //     obj.vendor?._id,
// //     typeof obj.vendor === "string" ? obj.vendor : null,
// //     obj.sellerId,
// //     obj.seller?._id,
// //     typeof obj.seller === "string" ? obj.seller : null,
// //   ];
// //   for (const v of candidates) {
// //     const s = v?.toString?.();
// //     if (isOid(s)) return s;
// //   }
// //   return null;
// // };

// // const isPublicProduct = (item) =>
// //   item.isVendorProduct === false || item.isVendorProduct === undefined || item.isVendorProduct === null;

// // /* ─────────────────────────────────────────────────────────
// //    STEP INDICATOR
// // ───────────────────────────────────────────────────────── */
// // const StepIndicator = ({ current }) => {
// //   const steps = [
// //     { n: 1, label: "Address", icon: FiMapPin },
// //     { n: 2, label: "Payment", icon: FiCreditCard },
// //     { n: 3, label: "Confirmed", icon: FiCheckCircle },
// //   ];
// //   return (
// //     <div className="relative flex items-center justify-between mb-10 px-4">
// //       <div className="absolute inset-x-0 top-5 h-0.5 bg-gray-200 z-0 mx-16" />
// //       <div
// //         className="absolute top-5 left-16 h-0.5 bg-gradient-to-r from-red-500 to-red-600 z-0 transition-all duration-700"
// //         style={{ width: current === 1 ? "0%" : current === 2 ? "50%" : "100%", right: "4rem" }}
// //       />
// //       {steps.map(({ n, label, icon: Icon }) => (
// //         <div key={n} className="relative z-10 flex flex-col items-center gap-2">
// //           <motion.div
// //             initial={false}
// //             animate={{
// //               scale: current === n ? 1.1 : 1,
// //               backgroundColor:
// //                 current > n ? "#16a34a" : current === n ? "#dc2626" : "#e5e7eb",
// //             }}
// //             className="w-10 h-10 rounded-full flex items-center justify-center shadow-md"
// //           >
// //             {current > n ? (
// //               <FiCheck className="text-white" size={18} />
// //             ) : (
// //               <Icon
// //                 className={current === n ? "text-white" : "text-gray-400"}
// //                 size={16}
// //               />
// //             )}
// //           </motion.div>
// //           <span
// //             className={`text-xs font-semibold tracking-wide ${
// //               current >= n ? "text-gray-800" : "text-gray-400"
// //             }`}
// //           >
// //             {label}
// //           </span>
// //         </div>
// //       ))}
// //     </div>
// //   );
// // };

// // /* ─────────────────────────────────────────────────────────
// //    INPUT FIELD
// // ───────────────────────────────────────────────────────── */
// // const Field = ({ label, icon: Icon, error, ...props }) => (
// //   <div className="flex flex-col gap-1.5">
// //     <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
// //       {label}
// //     </label>
// //     <div className="relative">
// //       {Icon && (
// //         <Icon
// //           size={14}
// //           className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
// //         />
// //       )}
// //       <input
// //         {...props}
// //         className={`w-full ${Icon ? "pl-10" : "pl-4"} pr-4 py-3 bg-gray-50 border ${
// //           error ? "border-red-400" : "border-gray-200"
// //         } rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-transparent focus:bg-white transition-all`}
// //       />
// //     </div>
// //     {error && <p className="text-xs text-red-500">{error}</p>}
// //   </div>
// // );

// // /* ─────────────────────────────────────────────────────────
// //    ORDER SUMMARY SIDEBAR
// //    ✅ FIX: Removed "sticky top-24" from here — now handled by parent wrapper
// // ───────────────────────────────────────────────────────── */
// // const OrderSummary = ({ cart, totals, appliedCoupon, paymentMethod }) => (
// //   <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
// //     <div className="bg-gradient-to-r from-gray-900 to-gray-800 px-5 py-4">
// //       <h3 className="text-white font-bold text-sm flex items-center gap-2">
// //         <FiShoppingBag size={15} /> Order Summary
// //       </h3>
// //       <p className="text-gray-400 text-xs mt-0.5">{cart.length} item{cart.length !== 1 ? "s" : ""}</p>
// //     </div>

// //     <div className="max-h-48 overflow-y-auto divide-y divide-gray-50">
// //       {cart.map((item) => (
// //         <div key={item._id} className="flex items-center gap-3 px-4 py-3">
// //           <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-100 shrink-0 border border-gray-200">
// //             <img
// //               src={item.image || item.images?.[0] || "/placeholder.png"}
// //               alt={item.name}
// //               className="w-full h-full object-cover"
// //               onError={(e) => { e.target.src = "/placeholder.png"; }}
// //             />
// //           </div>
// //           <div className="flex-1 min-w-0">
// //             <p className="text-xs font-semibold text-gray-800 truncate">{item.name}</p>
// //             <p className="text-xs text-gray-400 mt-0.5">Qty: {item.qty || 1}</p>
// //           </div>
// //           <p className="text-xs font-bold text-gray-800 shrink-0">
// //             ₹{((parseFloat(item.price) || 0) * (parseInt(item.qty) || 1)).toFixed(0)}
// //           </p>
// //         </div>
// //       ))}
// //     </div>

// //     <div className="px-5 py-4 border-t border-gray-100 space-y-2.5">
// //       {[
// //         { label: "Subtotal", value: `₹${totals.subtotal.toFixed(2)}` },
// //         {
// //           label: "Delivery",
// //           value: totals.deliveryFee === 0 ? "FREE" : `₹${totals.deliveryFee}`,
// //           green: totals.deliveryFee === 0,
// //           orange: totals.deliveryFee > 0,
// //         },
// //       ].map((r) => (
// //         <div key={r.label} className="flex justify-between text-xs">
// //           <span className="text-gray-500">{r.label}</span>
// //           <span className={`font-semibold ${r.green ? "text-green-600" : r.orange ? "text-orange-500" : "text-gray-700"}`}>
// //             {r.value}
// //           </span>
// //         </div>
// //       ))}

// //       {paymentMethod === "cod" && (
// //         <div className="flex items-center gap-1.5 text-xs text-orange-600 bg-orange-50 border border-orange-200 rounded-lg px-2.5 py-1.5">
// //           <FiInfo size={11} className="shrink-0" />
// //           <span>₹30 delivery charge for Cash on Delivery</span>
// //         </div>
// //       )}
// //       {paymentMethod === "razorpay" && (
// //         <div className="flex items-center gap-1.5 text-xs text-green-600 bg-green-50 border border-green-200 rounded-lg px-2.5 py-1.5">
// //           <FiCheckCircle size={11} className="shrink-0" />
// //           <span>Free delivery on online payment!</span>
// //         </div>
// //       )}

// //       {appliedCoupon && (
// //         <div className="flex justify-between text-xs border-t border-dashed border-green-200 pt-2">
// //           <span className="text-green-600 flex items-center gap-1">
// //             <FiTag size={11} /> {appliedCoupon.code}
// //           </span>
// //           <span className="font-bold text-green-600">-₹{appliedCoupon.discount.toFixed(2)}</span>
// //         </div>
// //       )}
// //       <div className="flex justify-between items-center border-t border-gray-200 pt-3">
// //         <span className="font-bold text-gray-900">Total</span>
// //         <span className="text-xl font-extrabold text-red-600">₹{totals.total.toFixed(2)}</span>
// //       </div>
// //     </div>

// //     <div className="px-5 pb-5">
// //       <div className="flex items-center gap-3 text-xs text-gray-500 border-t border-gray-100 pt-4">
// //         <FiShield className="text-green-500 shrink-0" size={14} />
// //         <span>Secure checkout • Bank-level encryption</span>
// //       </div>
// //     </div>
// //   </div>
// // );

// // /* ─────────────────────────────────────────────────────────
// //    MAIN CHECKOUT COMPONENT
// // ───────────────────────────────────────────────────────── */
// // export default function Checkout({ cart = [], clearCart }) {
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const { user, isAuthenticated, getUserId, getToken } = useAuth();

// //   const preSelectedPayment = location.state?.paymentMethod;

// //   const [step, setStep] = useState(1);
// //   const [loading, setLoading] = useState(false);
// //   const [paymentLoading, setPaymentLoading] = useState(false);
// //   const [couponLoading, setCouponLoading] = useState(false);
// //   const [vendorLoading, setVendorLoading] = useState(false);

// //   const [formData, setFormData] = useState({
// //     name: "", email: "", phone: "",
// //     address: "", city: "", state: "", pincode: "",
// //     paymentMethod: preSelectedPayment === "ONLINE" ? "razorpay" : "cod",
// //     weight: "0.5", length: "15", width: "10", height: "5",
// //   });

// //   const [fieldErrors, setFieldErrors] = useState({});
// //   const [orderDetails, setOrderDetails] = useState(null);
// //   const [paymentError, setPaymentError] = useState(null);
// //   const [paymentSuccess, setPaymentSuccess] = useState(false);
// //   const [backendOrderData, setBackendOrderData] = useState(null);
// //   const [razorpayMeta, setRazorpayMeta] = useState(null);

// //   const [couponCode, setCouponCode] = useState("");
// //   const [appliedCoupon, setAppliedCoupon] = useState(null);
// //   const [couponError, setCouponError] = useState("");
// //   const [couponDiscount, setCouponDiscount] = useState(0);

// //   const [resolvedVendorId, setResolvedVendorId] = useState(null);
// //   const [resolvedWarehouseId, setResolvedWarehouseId] = useState(null);
// //   const [vendorError, setVendorError] = useState("");

// //   const [confirmedCart, setConfirmedCart] = useState([]);
// //   const [confirmedTotals, setConfirmedTotals] = useState(null);
// //   const [confirmedPaymentMethod, setConfirmedPaymentMethod] = useState(null);
// //   const [confirmedCoupon, setConfirmedCoupon] = useState(null);

// //   const allCartItemsPublic = cart.every((item) => isPublicProduct(item));

// //   const calculateTotals = () => {
// //     const subtotal = cart.reduce(
// //       (s, i) => s + (parseFloat(i.price) || 0) * (parseInt(i.qty) || 1),
// //       0
// //     );
// //     const deliveryFee = formData.paymentMethod === "cod" ? 30 : 0;
// //     const platformFee = 0;
// //     const totalBeforeDiscount = subtotal + deliveryFee + platformFee;
// //     const total = Math.max(0, totalBeforeDiscount - couponDiscount);
// //     return {
// //       subtotal: +subtotal.toFixed(2),
// //       deliveryFee: +deliveryFee.toFixed(2),
// //       platformFee: +platformFee.toFixed(2),
// //       totalBeforeDiscount: +totalBeforeDiscount.toFixed(2),
// //       couponDiscount: +couponDiscount.toFixed(2),
// //       total: +total.toFixed(2),
// //     };
// //   };
// //   const totals = calculateTotals();

// //   const resolveVendorAndWarehouse = useCallback(async () => {
// //     if (cart.length === 0 || allCartItemsPublic) return;
// //     setVendorLoading(true);
// //     setVendorError("");
// //     try {
// //       const token = getToken();
// //       if (!token) { setVendorError("Please login to continue."); return; }
// //       const res = await fetch(`${API_BASE_URL}/parcelx/warehouse`, {
// //         headers: { Authorization: `Bearer ${token}` },
// //       });
// //       const data = await res.json();
// //       if (!data.success || !data.warehouses?.length) {
// //         setVendorError("No warehouse configured for this vendor.");
// //         return;
// //       }
// //       setResolvedWarehouseId(data.warehouses[0]._id);
// //       setResolvedVendorId(data.warehouses[0].vendorId);
// //     } catch (e) {
// //       setVendorError("Failed to load shipping info: " + e.message);
// //     } finally {
// //       setVendorLoading(false);
// //     }
// //   }, [cart, getToken, allCartItemsPublic]);

// //   useEffect(() => {
// //     if (isAuthenticated && cart.length > 0) resolveVendorAndWarehouse();
// //   }, [isAuthenticated, resolveVendorAndWarehouse]);

// //   useEffect(() => {
// //     if (!isAuthenticated) navigate("/login", { state: { from: "/checkout" } });
// //   }, [isAuthenticated, navigate]);

// //   // ── Auto-fill: user profile + saved address ──
// //   useEffect(() => {
// //     if (!user) return;
// //     let saved = {};
// //     try {
// //       saved = JSON.parse(localStorage.getItem(SAVED_ADDRESS_KEY) || "{}");
// //     } catch {}
// //     setFormData((p) => ({
// //       ...p,
// //       name:  user.fullName || user.name  || p.name,
// //       email: user.email                  || p.email,
// //       phone: user.phone                  || p.phone,
// //       address: saved.address || p.address,
// //       city:    saved.city    || p.city,
// //       state:   saved.state   || p.state,
// //       pincode: saved.pincode || p.pincode,
// //     }));
// //   }, [user]);

// //   const handleApplyCoupon = async () => {
// //     if (!couponCode.trim()) return setCouponError("Please enter a coupon code");
// //     setCouponLoading(true); setCouponError("");
// //     try {
// //       const token = getToken();
// //       const res = await fetch(`${API_BASE_URL}/coupons/apply`, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
// //         body: JSON.stringify({ code: couponCode.toUpperCase(), orderAmount: totals.totalBeforeDiscount }),
// //       });
// //       const data = await res.json();
// //       if (!data.success) return setCouponError(data.message || "Invalid coupon");
// //       setAppliedCoupon({ code: couponCode.toUpperCase(), discount: data.discount });
// //       setCouponDiscount(data.discount);
// //     } catch (e) {
// //       setCouponError(e.message || "Failed to apply coupon");
// //     } finally { setCouponLoading(false); }
// //   };

// //   const handleRemoveCoupon = () => {
// //     setAppliedCoupon(null); setCouponDiscount(0); setCouponCode(""); setCouponError("");
// //   };

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData((p) => ({ ...p, [name]: value }));
// //     if (fieldErrors[name]) setFieldErrors((p) => ({ ...p, [name]: "" }));
// //   };

// //   const validateForm = () => {
// //     const { name, email, phone, address, city, state, pincode } = formData;
// //     const errors = {};
// //     if (!name.trim() || name.trim().length < 2) errors.name = "Enter your full name";
// //     if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "Enter a valid email";
// //     if (!phone.trim() || !/^[6-9]\d{9}$/.test(phone)) errors.phone = "Valid 10-digit Indian mobile required";
// //     if (!address.trim() || address.trim().length < 10) errors.address = "Complete address required (min 10 chars)";
// //     if (!city.trim()) errors.city = "Enter your city";
// //     if (!state.trim()) errors.state = "Enter your state";
// //     if (!pincode.trim() || !/^\d{6}$/.test(pincode)) errors.pincode = "Valid 6-digit pincode required";
// //     setFieldErrors(errors);
// //     return Object.keys(errors).length === 0;
// //   };

// //   // ── Save address to localStorage then go to step 2 ──
// //   const handleProceedToPayment = async () => {
// //     if (!validateForm()) return;
// //     try {
// //       localStorage.setItem(SAVED_ADDRESS_KEY, JSON.stringify({
// //         address: formData.address,
// //         city:    formData.city,
// //         state:   formData.state,
// //         pincode: formData.pincode,
// //       }));
// //     } catch {}
// //     if (formData.paymentMethod === "razorpay") {
// //       try { await loadRazorpayScript(); } catch { return alert("Failed to load payment gateway. Try again."); }
// //     }
// //     setStep(2);
// //   };

// //   const saveOrderToStorage = (order) => {
// //     try {
// //       const all = JSON.parse(localStorage.getItem("user_orders") || "[]");
// //       const idx = all.findIndex((o) => o._id === order._id);
// //       if (idx === -1) all.unshift(order);
// //       else all[idx] = order;
// //       localStorage.setItem("user_orders", JSON.stringify(all.slice(0, 50)));
// //     } catch (e) { console.error("Storage error:", e); }
// //   };

// //   const createParcelxOrder = async () => {
// //     const token = getToken();
// //     if (!token) throw new Error("Please login again.");
// //     const customerId = getUserId();
// //     if (!customerId) throw new Error("User ID missing — please login again.");

// //     let vendorId = null;
// //     let warehouseId = null;

// //     if (!allCartItemsPublic) {
// //       vendorId = resolvedVendorId;
// //       if (!vendorId) {
// //         for (const item of cart) {
// //           if (!isPublicProduct(item)) {
// //             vendorId = extractVendorId(item);
// //             if (vendorId) break;
// //           }
// //         }
// //       }
// //       if (!vendorId) {
// //         for (const item of cart) {
// //           if (isPublicProduct(item)) continue;
// //           const productId = item._id || item.productId;
// //           if (!isOid(productId)) continue;
// //           try {
// //             const res = await fetch(`${API_BASE_URL}/products/${productId}`, {
// //               headers: { Authorization: `Bearer ${token}` },
// //             });
// //             const data = await res.json();
// //             vendorId = extractVendorId(data.product || data.data || data);
// //             if (vendorId) break;
// //           } catch (e) { /* continue */ }
// //         }
// //       }
// //       if (!vendorId) throw new Error("Vendor information not found. Please go back and re-add vendor items to cart.");

// //       warehouseId = resolvedWarehouseId;
// //       if (!warehouseId) {
// //         const wRes = await fetch(`${API_BASE_URL}/parcelx/warehouse`, {
// //           headers: { Authorization: `Bearer ${token}` },
// //         });
// //         const wData = await wRes.json();
// //         if (wData.success && wData.warehouses?.length > 0) {
// //           warehouseId = wData.warehouses[0]._id;
// //           setResolvedWarehouseId(warehouseId);
// //         } else {
// //           throw new Error("Warehouse not found for this vendor. Please contact support.");
// //         }
// //       }
// //       if (!warehouseId) throw new Error("Warehouse not found for this vendor. Please contact support.");
// //     }

// //     const orderItems = cart.map((item) => {
// //       let pId = item._id || item.productId;
// //       if (!isOid(pId)) pId = "000000000000000000000001";
// //       return {
// //         productId: pId,
// //         productName: item.name || item.productName || "Product",
// //         price: parseFloat(item.price) || 0,
// //         qty: parseInt(item.qty) || 1,
// //         vendorId: vendorId || null,
// //       };
// //     });

// //     const totalWeight = Math.max(
// //       cart.reduce((s, i) => s + (parseFloat(i.weight) || 0.5) * (parseInt(i.qty) || 1), 0),
// //       0.1
// //     ).toFixed(2);

// //     const payload = {
// //       customer: customerId,
// //       vendorId: vendorId || null,
// //       warehouseId: warehouseId || null,
// //       isPublicOrder: allCartItemsPublic,
// //       orderItems,
// //       amount: totals.total,
// //       couponCode: appliedCoupon?.code || null,
// //       couponDiscount,
// //       subtotal: totals.subtotal,
// //       deliveryFee: totals.deliveryFee,
// //       platformFee: totals.platformFee,
// //       gst: totals.gst,
// //       paymentMethod: formData.paymentMethod,
// //       shippingAddress: {
// //         name: formData.name,
// //         email: formData.email,
// //         phone: formData.phone,
// //         address: formData.address,
// //         city: formData.city,
// //         state: formData.state,
// //         pincode: formData.pincode,
// //       },
// //       shipment: {
// //         weight: parseFloat(formData.weight) || parseFloat(totalWeight),
// //         length: parseFloat(formData.length) || 15,
// //         width: parseFloat(formData.width) || 10,
// //         height: parseFloat(formData.height) || 5,
// //       },
// //     };

// //     const res = await fetch(`${API_BASE_URL}/parcelx/order`, {
// //       method: "POST",
// //       headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
// //       body: JSON.stringify(payload),
// //     });
// //     const json = await res.json();
// //     if (!res.ok || !json.success) {
// //       const errMsg = json.parcelxError || json.parcelx?.message || json.message || "Failed to create order";
// //       throw new Error(errMsg);
// //     }
// //     return json.order;
// //   };

// //   const createRazorpayOrderFromBackend = async (orderId) => {
// //     const token = getToken();
// //     const res = await fetch(`${API_BASE_URL}/razorpay/create-order`, {
// //       method: "POST",
// //       headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
// //       body: JSON.stringify({ orderId, amount: Math.round(totals.total * 100), currency: "INR" }),
// //     });
// //     const json = await res.json();
// //     if (!res.ok || !json.success) throw new Error(json.message || "Failed to init payment");
// //     return { razorpayOrderId: json.razorpayOrderId, amount: Math.round(totals.total * 100), currency: json.currency || "INR", key: json.key };
// //   };

// //   const verifyRazorpayPayment = async (payload) => {
// //     const token = getToken();
// //     const res = await fetch(`${API_BASE_URL}/razorpay/verify-payment`, {
// //       method: "POST",
// //       headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
// //       body: JSON.stringify(payload),
// //     });
// //     return res.json();
// //   };

// //   const initiateRazorpayPayment = async (order) => {
// //     setPaymentLoading(true); setPaymentError(null);
// //     try {
// //       if (!window.Razorpay) await loadRazorpayScript();
// //       const razorpayKey = getRazorpayPublicKey(razorpayMeta);
// //       if (!razorpayKey) throw new Error("Razorpay key missing");
// //       const rp = new window.Razorpay({
// //         key: razorpayKey,
// //         amount: Math.round(totals.total * 100),
// //         currency: razorpayMeta?.currency || "INR",
// //         name: "HAVBIT",
// //         description: `Order #${order._id?.slice(-8).toUpperCase()}`,
// //         image: "/logo.png",
// //         order_id: razorpayMeta?.razorpayOrderId,
// //         handler: async (response) => {
// //           const v = await verifyRazorpayPayment({
// //             orderId: order._id,
// //             razorpay_payment_id: response.razorpay_payment_id,
// //             razorpay_order_id: response.razorpay_order_id,
// //             razorpay_signature: response.razorpay_signature,
// //           });
// //           if (v.success) {
// //             const updated = { ...order, paymentStatus: "Success", orderStatus: "Confirmed", razorpayPaymentId: response.razorpay_payment_id };
// //             saveOrderToStorage(updated);
// //             setConfirmedCart([...cart]);
// //             setConfirmedTotals({ ...totals });
// //             setConfirmedPaymentMethod(formData.paymentMethod);
// //             setConfirmedCoupon(appliedCoupon ? { ...appliedCoupon } : null);
// //             setOrderDetails({
// //               orderId: updated._id, paymentMethod: "razorpay",
// //               amount: totals.total, orderStatus: "Confirmed", paymentStatus: "Success",
// //               razorpayPaymentId: updated.razorpayPaymentId,
// //               coupon: appliedCoupon, awb: order.parcelx?.awb,
// //               courier: order.parcelx?.courier, trackingUrl: order.parcelx?.tracking_url,
// //             });
// //             setPaymentSuccess(true); setStep(3);
// //             if (clearCart) { clearCart(); localStorage.removeItem("cart"); }
// //           } else {
// //             setPaymentError(v.message || "Verification failed");
// //           }
// //         },
// //         prefill: { name: formData.name, email: formData.email, contact: formData.phone },
// //         notes: { orderId: order._id },
// //         theme: { color: "#dc2626" },
// //         modal: { ondismiss: () => { setPaymentError("Payment cancelled"); setPaymentLoading(false); } },
// //       });
// //       rp.open();
// //       rp.on("payment.failed", (r) => {
// //         setPaymentError(r.error?.description || "Payment failed"); setPaymentLoading(false);
// //       });
// //     } catch (err) {
// //       setPaymentError(err.message); setPaymentLoading(false);
// //     }
// //   };

// //   const handleCreateOrder = async () => {
// //     if (!validateForm()) return;
// //     setLoading(true);
// //     setPaymentError(null);
// //     try {
// //       const createdOrder = await createParcelxOrder();
// //       setBackendOrderData(createdOrder);
// //       saveOrderToStorage(createdOrder);

// //       if (formData.paymentMethod === "razorpay") {
// //         const rpMeta = await createRazorpayOrderFromBackend(createdOrder._id);
// //         setRazorpayMeta(rpMeta);
// //       } else {
// //         const updatedOrder = {
// //           ...createdOrder,
// //           paymentStatus: "Pending",
// //           orderStatus: "Confirmed",
// //         };
// //         saveOrderToStorage(updatedOrder);
// //         setConfirmedCart([...cart]);
// //         setConfirmedTotals({ ...totals });
// //         setConfirmedPaymentMethod(formData.paymentMethod);
// //         setConfirmedCoupon(appliedCoupon ? { ...appliedCoupon } : null);
// //         setOrderDetails({
// //           orderId: updatedOrder._id,
// //           paymentMethod: "cod",
// //           amount: totals.total,
// //           orderStatus: "Confirmed",
// //           paymentStatus: "Pending",
// //           coupon: appliedCoupon,
// //           awb: updatedOrder.parcelx?.awb,
// //           courier: updatedOrder.parcelx?.courier,
// //           trackingUrl: updatedOrder.parcelx?.tracking_url,
// //         });
// //         setPaymentSuccess(true);
// //         setStep(3);
// //         if (clearCart) {
// //           clearCart();
// //           localStorage.removeItem("cart");
// //         }
// //       }
// //     } catch (e) {
// //       setPaymentError(e.message);
// //       if (/expired|invalid|session/i.test(e.message)) {
// //         alert("Session expired — please login again.");
// //         navigate("/login", { state: { from: "/checkout" } });
// //       }
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleBack = () => {
// //     if (step === 1) navigate("/cart");
// //     else if (step === 3) navigate("/orders");
// //     else setStep(1);
// //   };

// //   /* ─────────────── GUARDS ─────────────── */
// //   if (!isAuthenticated) return (
// //     <div className="min-h-screen flex items-center justify-center bg-gray-50">
// //       <div className="text-center">
// //         <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
// //           <FiLogIn className="text-red-600" size={24} />
// //         </div>
// //         <h2 className="text-xl font-bold text-gray-900 mb-2">Login Required</h2>
// //         <p className="text-gray-500 text-sm mb-6">Please login to place an order</p>
// //         <button
// //           onClick={() => navigate("/login", { state: { from: "/checkout" } })}
// //           className="px-6 py-3 bg-red-600 text-white rounded-xl font-semibold hover:bg-red-700 transition"
// //         >
// //           Login Now
// //         </button>
// //       </div>
// //     </div>
// //   );

// //   if (cart.length === 0 && step !== 3) return (
// //     <div className="min-h-screen flex items-center justify-center bg-gray-50">
// //       <div className="text-center">
// //         <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
// //           <FiShoppingBag className="text-red-600" size={24} />
// //         </div>
// //         <h2 className="text-xl font-bold text-gray-900 mb-2">Cart is Empty</h2>
// //         <p className="text-gray-500 text-sm mb-6">Add products before checking out</p>
// //         <button
// //           onClick={() => navigate("/products")}
// //           className="px-6 py-3 bg-red-600 text-white rounded-xl font-semibold hover:bg-red-700 transition"
// //         >
// //           Shop Now
// //         </button>
// //       </div>
// //     </div>
// //   );

// //   const sidebarCart    = step === 3 && confirmedCart.length > 0 ? confirmedCart : cart;
// //   const sidebarTotals  = step === 3 && confirmedTotals          ? confirmedTotals : totals;
// //   const sidebarPayment = step === 3 && confirmedPaymentMethod   ? confirmedPaymentMethod : formData.paymentMethod;
// //   const sidebarCoupon  = step === 3                             ? confirmedCoupon : appliedCoupon;

// //   /* ─────────────── RENDER ─────────────── */
// //   return (
// //     <div className="min-h-screen bg-gray-50">
// //       {/* ── Top Bar ── */}
// //       <div className="bg-white border-b border-gray-200 sticky top-0 z-30 shadow-sm">
// //         <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
// //           <button
// //             onClick={handleBack}
// //             className="flex items-center gap-2 text-gray-500 hover:text-red-600 transition-colors text-sm font-medium"
// //           >
// //             <FiArrowLeft size={16} />
// //             <span className="hidden sm:inline">
// //               {step === 3 ? "View Orders" : step === 2 ? "Back to Address" : "Back to Cart"}
// //             </span>
// //           </button>

// //           <div className="flex items-center gap-2">
// //             <div className="w-8 h-8 bg-red-600 rounded-lg flex items-center justify-center">
// //               <FiShoppingBag className="text-white" size={14} />
// //             </div>
// //             <span className="font-bold text-gray-900 text-sm hidden sm:inline">Checkout</span>
// //           </div>

// //           <div className="flex items-center gap-2">
// //             <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
// //               <FiUser className="text-gray-600" size={14} />
// //             </div>
// //             <span className="text-sm font-medium text-gray-700 hidden sm:block">
// //               {user?.fullName?.split(" ")[0] || user?.name?.split(" ")[0] || "User"}
// //             </span>
// //           </div>
// //         </div>
// //       </div>

// //       <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
// //         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
// //           {/* ── Main Panel ── */}
// //           <div className="lg:col-span-2">
// //             <StepIndicator current={step} />

// //             {vendorLoading && !allCartItemsPublic && (
// //               <motion.div
// //                 initial={{ opacity: 0, y: -8 }}
// //                 animate={{ opacity: 1, y: 0 }}
// //                 className="mb-5 flex items-center gap-3 px-4 py-3 bg-blue-50 border border-blue-200 rounded-xl text-sm text-blue-700"
// //               >
// //                 <FiLoader className="animate-spin shrink-0" size={15} />
// //                 <span>Setting up shipping configuration...</span>
// //               </motion.div>
// //             )}

// //             {vendorError && !vendorLoading && !allCartItemsPublic && (
// //               <motion.div
// //                 initial={{ opacity: 0, y: -8 }}
// //                 animate={{ opacity: 1, y: 0 }}
// //                 className="mb-5 flex items-start gap-3 px-4 py-3 bg-amber-50 border border-amber-300 rounded-xl"
// //               >
// //                 <FiAlertCircle className="text-amber-500 shrink-0 mt-0.5" size={15} />
// //                 <div className="flex-1">
// //                   <p className="text-sm font-semibold text-amber-800">Shipping Setup Issue</p>
// //                   <p className="text-xs text-amber-700 mt-0.5">{vendorError}</p>
// //                   <button
// //                     onClick={resolveVendorAndWarehouse}
// //                     className="mt-1.5 text-xs text-blue-600 underline hover:text-blue-700"
// //                   >
// //                     Retry →
// //                   </button>
// //                 </div>
// //               </motion.div>
// //             )}

// //             {paymentError && (
// //               <motion.div
// //                 initial={{ opacity: 0, y: -8 }}
// //                 animate={{ opacity: 1, y: 0 }}
// //                 className="mb-5 flex items-center gap-3 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-sm text-red-700"
// //               >
// //                 <FiXCircle className="shrink-0" size={15} />
// //                 <span>{paymentError}</span>
// //               </motion.div>
// //             )}

// //             <AnimatePresence mode="wait">

// //               {/* ══════ STEP 1 – ADDRESS ══════ */}
// //               {step === 1 && (
// //                 <motion.div
// //                   key="step1"
// //                   initial={{ opacity: 0, x: 20 }}
// //                   animate={{ opacity: 1, x: 0 }}
// //                   exit={{ opacity: 0, x: -20 }}
// //                   transition={{ duration: 0.25 }}
// //                 >
// //                   <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
// //                     <div className="px-6 pt-6 pb-4 border-b border-gray-100">
// //                       <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
// //                         <FiMapPin className="text-red-500" size={18} />
// //                         Delivery Address
// //                       </h2>
// //                       <p className="text-xs text-gray-500 mt-1">Where should we send your order?</p>
// //                     </div>

// //                     <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-5">
// //                       <Field label="Full Name" icon={FiUser} name="name" type="text"
// //                         placeholder="Your full name" value={formData.name}
// //                         onChange={handleChange} error={fieldErrors.name} />
// //                       <Field label="Email" icon={FiMail} name="email" type="email"
// //                         placeholder="email@example.com" value={formData.email}
// //                         onChange={handleChange} error={fieldErrors.email} />
// //                       <Field label="Phone" icon={FiPhone} name="phone" type="tel"
// //                         placeholder="10-digit mobile number" value={formData.phone}
// //                         onChange={handleChange} error={fieldErrors.phone} />
// //                       <Field label="Pincode" icon={FiMapPin} name="pincode" type="text"
// //                         placeholder="6-digit pincode" maxLength={6} value={formData.pincode}
// //                         onChange={handleChange} error={fieldErrors.pincode} />

// //                       <div className="sm:col-span-2 flex flex-col gap-1.5">
// //                         <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
// //                           Complete Address
// //                         </label>
// //                         <div className="relative">
// //                           <FiHome size={14} className="absolute left-3.5 top-3.5 text-gray-400 pointer-events-none" />
// //                           <textarea
// //                             name="address"
// //                             rows={3}
// //                             value={formData.address}
// //                             onChange={handleChange}
// //                             placeholder="House no., Building, Street, Area, Landmark..."
// //                             className={`w-full pl-10 pr-4 py-3 bg-gray-50 border ${
// //                               fieldErrors.address ? "border-red-400" : "border-gray-200"
// //                             } rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-400 focus:bg-white transition-all resize-none`}
// //                           />
// //                         </div>
// //                         {fieldErrors.address && <p className="text-xs text-red-500">{fieldErrors.address}</p>}
// //                       </div>

// //                       <Field label="City" icon={FiMapPin} name="city" type="text"
// //                         placeholder="Your city" value={formData.city}
// //                         onChange={handleChange} error={fieldErrors.city} />
// //                       <Field label="State" icon={FiMapPin} name="state" type="text"
// //                         placeholder="Your state" value={formData.state}
// //                         onChange={handleChange} error={fieldErrors.state} />
// //                     </div>

// //                     {/* Dimensions */}
// //                     <div className="px-6 pb-4">
// //                       <details className="group">
// //                         <summary className="cursor-pointer text-xs font-semibold text-blue-600 flex items-center gap-1.5 select-none list-none">
// //                           <FiPackage size={13} />
// //                           <span>Advanced: Shipment Dimensions</span>
// //                         </summary>
// //                         <div className="mt-3 p-4 bg-blue-50 border border-blue-200 rounded-xl">
// //                           <p className="text-xs text-blue-700 mb-3">
// //                             Used by ParcelX for rate calculation. Defaults are pre-filled.
// //                           </p>
// //                           <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
// //                             {[
// //                               { label: "Weight (kg)", name: "weight" },
// //                               { label: "Length (cm)", name: "length" },
// //                               { label: "Width (cm)", name: "width" },
// //                               { label: "Height (cm)", name: "height" },
// //                             ].map((f) => (
// //                               <div key={f.name}>
// //                                 <label className="block text-xs font-medium text-blue-800 mb-1">{f.label}</label>
// //                                 <input
// //                                   type="number"
// //                                   name={f.name}
// //                                   value={formData[f.name]}
// //                                   onChange={handleChange}
// //                                   step="0.1"
// //                                   min="0.1"
// //                                   className="w-full px-3 py-2 bg-white border border-blue-200 rounded-lg text-xs focus:outline-none focus:ring-1 focus:ring-blue-400"
// //                                 />
// //                               </div>
// //                             ))}
// //                           </div>
// //                         </div>
// //                       </details>
// //                     </div>

// //                     {/* Shipping strip */}
// //                     <div className="mx-6 mb-6 flex items-center justify-between px-4 py-3 bg-gradient-to-r from-red-50 to-orange-50 border border-red-100 rounded-xl">
// //                       <div className="flex items-center gap-2">
// //                         <FiTruck className="text-red-500 shrink-0" size={15} />
// //                         <span className="text-xs font-semibold text-gray-700">
// //                           Shipped 3-5 working days
// //                         </span>
// //                       </div>
// //                       <div className="text-xs">
// //                         {allCartItemsPublic ? (
// //                           <span className="text-green-600 flex items-center gap-1 font-medium">
// //                             <FiCheckCircle size={11} /> Auto-configured
// //                           </span>
// //                         ) : vendorLoading ? (
// //                           <span className="text-blue-500 flex items-center gap-1">
// //                             <FiLoader className="animate-spin" size={11} /> Loading...
// //                           </span>
// //                         ) : resolvedWarehouseId ? (
// //                           <span className="text-green-600 flex items-center gap-1 font-medium">
// //                             <FiCheckCircle size={11} /> Ready
// //                           </span>
// //                         ) : (
// //                           <span className="text-amber-600 flex items-center gap-1">
// //                             <FiAlertCircle size={11} /> Pending
// //                           </span>
// //                         )}
// //                       </div>
// //                     </div>

// //                     <div className="px-6 pb-6">
// //                       <button
// //                         onClick={handleProceedToPayment}
// //                         className="w-full py-3.5 bg-gradient-to-r from-red-600 to-red-500 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-600 transition-all shadow-lg shadow-red-200 flex items-center justify-center gap-2 text-sm"
// //                       >
// //                         <FiCreditCard size={16} />
// //                         Proceed to Payment
// //                       </button>
// //                     </div>
// //                   </div>
// //                 </motion.div>
// //               )}

// //               {/* ══════ STEP 2 – PAYMENT ══════ */}
// //               {step === 2 && (
// //                 <motion.div
// //                   key="step2"
// //                   initial={{ opacity: 0, x: 20 }}
// //                   animate={{ opacity: 1, x: 0 }}
// //                   exit={{ opacity: 0, x: -20 }}
// //                   transition={{ duration: 0.25 }}
// //                 >
// //                   <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
// //                     <div className="px-6 pt-6 pb-4 border-b border-gray-100">
// //                       <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
// //                         <FiCreditCard className="text-red-500" size={18} />
// //                         Payment Method
// //                       </h2>
// //                       <p className="text-xs text-gray-500 mt-1">How would you like to pay?</p>
// //                     </div>

// //                     <div className="p-6 space-y-3">
// //                       {[
// //                         {
// //                           value: "cod",
// //                           label: "Cash on Delivery",
// //                           sub: "Pay when your order arrives • ₹30 delivery charge",
// //                           badge: "Most Popular",
// //                           icon: <FaPhoneAlt className="text-green-600" size={18} />,
// //                           badgeColor: "bg-green-100 text-green-700",
// //                           activeColor: "border-green-400 bg-green-50",
// //                           deliveryNote: (
// //                             <span className="text-xs text-orange-600 flex items-center gap-1 mt-1">
// //                               <FiInfo size={11} /> ₹30 delivery charge applies for COD
// //                             </span>
// //                           ),
// //                         },
// //                         {
// //                           value: "razorpay",
// //                           label: "Online Payment",
// //                           sub: "Cards • UPI • Net Banking • Wallets",
// //                           badge: "FREE Delivery",
// //                           icon: <FiCreditCard className="text-blue-600" size={18} />,
// //                           badgeColor: "bg-green-100 text-green-700",
// //                           activeColor: "border-blue-400 bg-blue-50",
// //                           deliveryNote: (
// //                             <span className="text-xs text-green-600 flex items-center gap-1 mt-1">
// //                               <FiCheckCircle size={11} /> Free delivery on online payment!
// //                             </span>
// //                           ),
// //                         },
// //                       ].map((opt) => (
// //                         <label
// //                           key={opt.value}
// //                           className={`flex items-start gap-4 p-4 border-2 rounded-xl cursor-pointer transition-all ${
// //                             formData.paymentMethod === opt.value
// //                               ? opt.activeColor
// //                               : "border-gray-200 hover:border-gray-300 bg-white"
// //                           }`}
// //                         >
// //                           <input
// //                             type="radio"
// //                             name="paymentMethod"
// //                             value={opt.value}
// //                             checked={formData.paymentMethod === opt.value}
// //                             onChange={handleChange}
// //                             className="w-4 h-4 accent-red-600 mt-1"
// //                           />
// //                           <div className="w-10 h-10 bg-white border border-gray-200 rounded-xl flex items-center justify-center shadow-sm shrink-0">
// //                             {opt.icon}
// //                           </div>
// //                           <div className="flex-1">
// //                             <div className="flex items-center gap-2 flex-wrap">
// //                               <p className="font-bold text-gray-900 text-sm">{opt.label}</p>
// //                               <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${opt.badgeColor}`}>
// //                                 {opt.badge}
// //                               </span>
// //                             </div>
// //                             <p className="text-xs text-gray-500 mt-0.5">{opt.sub}</p>
// //                             {opt.deliveryNote}
// //                           </div>
// //                           {formData.paymentMethod === opt.value && (
// //                             <div className="w-5 h-5 bg-red-600 rounded-full flex items-center justify-center shrink-0 mt-1">
// //                               <FiCheck className="text-white" size={11} />
// //                             </div>
// //                           )}
// //                         </label>
// //                       ))}
// //                     </div>

// //                     {/* Coupon Section */}
// //                     <div className="px-6 pb-4">
// //                       <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl">
// //                         <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
// //                           <FiTag className="text-orange-500" size={15} />
// //                           Have a Coupon?
// //                         </h3>
// //                         <div className="flex gap-2">
// //                           <input
// //                             type="text"
// //                             value={couponCode}
// //                             onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
// //                             placeholder="ENTER CODE"
// //                             disabled={!!appliedCoupon}
// //                             className="flex-1 px-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm font-mono font-semibold tracking-widest focus:outline-none focus:ring-2 focus:ring-orange-400 disabled:bg-gray-100 disabled:text-gray-400 uppercase"
// //                           />
// //                           {appliedCoupon ? (
// //                             <button
// //                               onClick={handleRemoveCoupon}
// //                               className="px-4 py-2.5 bg-red-100 text-red-600 font-semibold rounded-xl hover:bg-red-200 transition text-sm"
// //                             >
// //                               Remove
// //                             </button>
// //                           ) : (
// //                             <button
// //                               onClick={handleApplyCoupon}
// //                               disabled={couponLoading}
// //                               className="px-4 py-2.5 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-600 transition disabled:opacity-50 text-sm flex items-center gap-1.5"
// //                             >
// //                               {couponLoading ? <FiLoader className="animate-spin" size={14} /> : "Apply"}
// //                             </button>
// //                           )}
// //                         </div>
// //                         {couponError && (
// //                           <p className="mt-2 text-xs text-red-500 flex items-center gap-1">
// //                             <FiAlertCircle size={12} /> {couponError}
// //                           </p>
// //                         )}
// //                         {appliedCoupon && (
// //                           <div className="mt-3 flex items-center justify-between px-3 py-2.5 bg-green-50 border border-green-200 rounded-lg">
// //                             <span className="flex items-center gap-1.5 text-sm font-bold text-green-800">
// //                               <FiCheckCircle className="text-green-600" size={14} />
// //                               {appliedCoupon.code}
// //                             </span>
// //                             <span className="text-sm font-bold text-green-700">
// //                               -₹{appliedCoupon.discount.toFixed(2)}
// //                             </span>
// //                           </div>
// //                         )}
// //                       </div>
// //                     </div>

// //                     {/* Amount Box */}
// //                     <div className="px-6 pb-4">
// //                       <div className="flex items-center justify-between px-5 py-4 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl text-white">
// //                         <div>
// //                           <p className="text-xs text-gray-400 font-medium">Total Payable</p>
// //                           <p className="text-2xl font-extrabold mt-0.5">₹{totals.total.toFixed(2)}</p>
// //                           {appliedCoupon && (
// //                             <p className="text-xs text-green-400 mt-0.5">
// //                               You saved ₹{couponDiscount.toFixed(2)} 🎉
// //                             </p>
// //                           )}
// //                         </div>
// //                         <div className="text-right text-xs text-gray-400 space-y-1">
// //                           <p>Subtotal: ₹{totals.subtotal.toFixed(2)}</p>
// //                           <p className={totals.deliveryFee === 0 ? "text-green-400" : "text-orange-400"}>
// //                             Delivery: {totals.deliveryFee === 0 ? "FREE" : `₹${totals.deliveryFee}`}
// //                           </p>
// //                         </div>
// //                       </div>
// //                     </div>

// //                     {/* CTA */}
// //                     <div className="px-6 pb-6">
// //                       {!backendOrderData ? (
// //                         <button
// //                           onClick={handleCreateOrder}
// //                           disabled={loading}
// //                           className="w-full py-3.5 bg-gradient-to-r from-red-600 to-red-500 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-600 transition-all shadow-lg shadow-red-200 flex items-center justify-center gap-2 text-sm disabled:opacity-60 disabled:cursor-not-allowed"
// //                         >
// //                           {loading ? (
// //                             <>
// //                               <FiLoader className="animate-spin" size={16} />
// //                               Creating Order & Booking Shipment...
// //                             </>
// //                           ) : (
// //                             <>
// //                               <FiCheck size={16} />
// //                               {formData.paymentMethod === "cod"
// //                                 ? "Place Order (COD • ₹30 Delivery)"
// //                                 : "Create Order & Pay Online (Free Delivery)"}
// //                             </>
// //                           )}
// //                         </button>
// //                       ) : formData.paymentMethod === "razorpay" ? (
// //                         <button
// //                           onClick={() => initiateRazorpayPayment(backendOrderData)}
// //                           disabled={paymentLoading}
// //                           className="w-full py-3.5 bg-gradient-to-r from-blue-600 to-blue-500 text-white font-bold rounded-xl hover:from-blue-700 hover:to-blue-600 transition-all shadow-lg shadow-blue-200 flex items-center justify-center gap-2 text-sm disabled:opacity-60"
// //                         >
// //                           {paymentLoading ? (
// //                             <><FiLoader className="animate-spin" size={16} /> Opening Payment Gateway...</>
// //                           ) : (
// //                             <><FiCreditCard size={16} /> Pay ₹{totals.total.toFixed(2)} with Razorpay</>
// //                           )}
// //                         </button>
// //                       ) : (
// //                         <div className="p-4 bg-green-50 border border-green-200 rounded-xl">
// //                           <div className="flex items-center gap-3 mb-3">
// //                             <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center">
// //                               <FiCheckCircle className="text-green-600" size={20} />
// //                             </div>
// //                             <div>
// //                               <p className="font-bold text-green-800 text-sm">Order & AWB Created!</p>
// //                               <p className="text-xs text-green-600">
// //                                 #{backendOrderData._id?.slice(-8).toUpperCase()}
// //                                 {backendOrderData.parcelx?.awb && (
// //                                   <> · AWB: <strong>{backendOrderData.parcelx.awb}</strong></>
// //                                 )}
// //                               </p>
// //                             </div>
// //                           </div>
// //                           <button
// //                             onClick={() => setStep(3)}
// //                             className="w-full py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition font-semibold text-sm"
// //                           >
// //                             View Confirmation →
// //                           </button>
// //                         </div>
// //                       )}
// //                       <p className="text-center text-xs text-gray-400 mt-3 flex items-center justify-center gap-1">
// //                         <FiLock size={11} /> Secured with bank-level encryption
// //                       </p>
// //                     </div>
// //                   </div>
// //                 </motion.div>
// //               )}

// //               {/* ══════ STEP 3 – CONFIRMATION ══════ */}
// //               {step === 3 && orderDetails && (
// //                 <motion.div
// //                   key="step3"
// //                   initial={{ opacity: 0, scale: 0.96 }}
// //                   animate={{ opacity: 1, scale: 1 }}
// //                   transition={{ duration: 0.3 }}
// //                 >
// //                   {/* ── THANK YOU BANNER ── */}
// //                   <motion.div
// //                     initial={{ opacity: 0, y: -16 }}
// //                     animate={{ opacity: 1, y: 0 }}
// //                     transition={{ delay: 0.15, duration: 0.4 }}
// //                     className="mb-4 rounded-2xl overflow-hidden bg-gradient-to-r from-red-600 via-red-500 to-orange-500 px-6 py-5 flex items-center justify-between shadow-lg shadow-red-200"
// //                   >
// //                     <div>
// //                       <p className="text-white/80 text-xs font-semibold uppercase tracking-widest mb-1">
// //                         HAVBIT
// //                       </p>
// //                       <h2 className="text-white text-xl font-extrabold leading-tight">
// //                         Thank you for your order,
// //                       </h2>
// //                       <p className="text-white/90 text-lg font-bold">
// //                         {formData.name?.split(" ")[0] || "Friend"}! 🎉
// //                       </p>
// //                       <p className="text-white/70 text-xs mt-1.5">
// //                         We're thrilled to have you shop with us. Your order is in safe hands!
// //                       </p>
// //                     </div>
// //                     <motion.div
// //                       animate={{ scale: [1, 1.15, 1] }}
// //                       transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
// //                       className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center shrink-0 ml-4"
// //                     >
// //                       <FiHeart className="text-white" size={30} />
// //                     </motion.div>
// //                   </motion.div>

// //                   {/* ── ORDER CONFIRMED CARD ── */}
// //                   <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
// //                     {/* Success Header */}
// //                     <div className="bg-gradient-to-br from-green-500 to-emerald-600 px-6 py-10 text-center">
// //                       <motion.div
// //                         initial={{ scale: 0 }}
// //                         animate={{ scale: 1 }}
// //                         transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
// //                         className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg"
// //                       >
// //                         {paymentSuccess ? (
// //                           <FiCheck className="text-green-500" size={36} />
// //                         ) : (
// //                           <FiAlertCircle className="text-amber-500" size={36} />
// //                         )}
// //                       </motion.div>
// //                       <motion.h2
// //                         initial={{ opacity: 0, y: 10 }}
// //                         animate={{ opacity: 1, y: 0 }}
// //                         transition={{ delay: 0.3 }}
// //                         className="text-2xl font-extrabold text-white mb-1"
// //                       >
// //                         {paymentSuccess ? "Order Confirmed! 🎉" : "Order Created"}
// //                       </motion.h2>
// //                       <motion.p
// //                         initial={{ opacity: 0 }}
// //                         animate={{ opacity: 1 }}
// //                         transition={{ delay: 0.4 }}
// //                         className="text-green-100 text-sm"
// //                       >
// //                         {paymentSuccess
// //                           ? "Your order is confirmed and shipment booked"
// //                           : "Order placed but payment pending"}
// //                       </motion.p>
// //                     </div>

// //                     <div className="p-6 space-y-4">
// //                       {/* Order Details Grid */}
// //                       <div className="grid grid-cols-2 gap-3">
// //                         {[
// //                           { label: "Order ID", value: `#${orderDetails.orderId?.slice(-8).toUpperCase()}` },
// //                           {
// //                             label: "Amount",
// //                             value: `₹${orderDetails.amount?.toFixed(2)}`,
// //                             valueClass: "text-green-600",
// //                           },
// //                           {
// //                             label: "Payment",
// //                             value: orderDetails.paymentMethod === "cod" ? "Cash on Delivery" : "Online Payment",
// //                           },
// //                           {
// //                             label: "Status",
// //                             value: orderDetails.orderStatus || "Confirmed",
// //                             valueClass: "text-green-600",
// //                           },
// //                         ].map((item) => (
// //                           <div key={item.label} className="bg-gray-50 rounded-xl p-3">
// //                             <p className="text-xs text-gray-500 uppercase tracking-wider font-medium mb-1">
// //                               {item.label}
// //                             </p>
// //                             <p className={`font-bold text-gray-900 text-sm ${item.valueClass || ""}`}>
// //                               {item.value}
// //                             </p>
// //                           </div>
// //                         ))}
// //                       </div>

// //                       {orderDetails.paymentMethod === "cod" && (
// //                         <div className="flex items-center gap-2 px-4 py-3 bg-orange-50 border border-orange-200 rounded-xl text-xs text-orange-700">
// //                           <FiInfo size={13} className="shrink-0" />
// //                           <span>₹30 delivery charge included • Pay on delivery</span>
// //                         </div>
// //                       )}

// //                       {orderDetails.coupon && (
// //                         <div className="flex items-center justify-between px-4 py-3 bg-green-50 border border-green-200 rounded-xl">
// //                           <span className="flex items-center gap-2 text-sm font-semibold text-green-800">
// //                             <FiTag className="text-green-600" size={14} />
// //                             Coupon saved!
// //                           </span>
// //                           <span className="font-bold text-green-700">
// //                             -₹{orderDetails.coupon.discount.toFixed(2)}
// //                           </span>
// //                         </div>
// //                       )}

// //                       <div className="text-center py-3 px-4 bg-gray-50 rounded-xl">
// //                         <p className="text-xs text-gray-500">
// //                           Updates sent to{" "}
// //                           <span className="font-semibold text-gray-700">{formData.email}</span>
// //                           {" "}and{" "}
// //                           <span className="font-semibold text-gray-700">{formData.phone}</span>
// //                         </p>
// //                       </div>

// //                       {/* Action Buttons */}
// //                       <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
// //                         <button
// //                           onClick={() => navigate(`/order/${orderDetails.orderId}`)}
// //                           className="py-3.5 bg-gradient-to-r from-red-600 to-red-500 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-600 transition text-sm"
// //                         >
// //                           View Order Details
// //                         </button>
// //                         <button
// //                           onClick={() => navigate("/products")}
// //                           className="py-3.5 border-2 border-gray-200 text-gray-700 font-bold rounded-xl hover:bg-gray-50 hover:border-gray-300 transition text-sm"
// //                         >
// //                           Continue Shopping
// //                         </button>
// //                       </div>
// //                     </div>
// //                   </div>
// //                 </motion.div>
// //               )}
// //             </AnimatePresence>
// //           </div>

// //           {/* ════════════════════════════════════════════
// //               ✅ FIXED SIDEBAR
// //               - Entire sidebar wrapped in sticky container
// //               - max-h + overflow-y-auto so all cards visible
// //               - scrollbar hidden visually but functional
// //           ════════════════════════════════════════════ */}
// //           <div className="lg:col-span-1">
// //             <div
// //               className="sticky top-24 flex flex-col gap-5"
// //               style={{
// //                 maxHeight: "calc(100vh - 7rem)",
// //                 overflowY: "auto",
// //                 paddingBottom: "1rem",
// //                 scrollbarWidth: "none",        /* Firefox */
// //                 msOverflowStyle: "none",       /* IE/Edge */
// //               }}
// //             >
// //               {/* Hide webkit scrollbar via inline style trick */}
// //               <style>{`
// //                 .sidebar-scroll::-webkit-scrollbar { display: none; }
// //               `}</style>

// //               <div className="sidebar-scroll">
// //                 <OrderSummary
// //                   cart={sidebarCart}
// //                   totals={sidebarTotals}
// //                   appliedCoupon={sidebarCoupon}
// //                   paymentMethod={sidebarPayment}
// //                 />
// //               </div>

// //               {/* Account info */}
// //               <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
// //                 <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
// //                   <FiUser className="text-red-500" size={14} /> Account
// //                 </h3>
// //                 <div className="space-y-1.5">
// //                   {[
// //                     { label: "Name", value: user?.fullName || user?.name || "—" },
// //                     { label: "Email", value: user?.email || "—" },
// //                     { label: "Phone", value: user?.phone || "—" },
// //                   ].map(({ label, value }) => (
// //                     <div key={label} className="flex items-center justify-between text-xs">
// //                       <span className="text-gray-400">{label}</span>
// //                       <span className="font-semibold text-gray-700 truncate max-w-[60%] text-right">
// //                         {value}
// //                       </span>
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>

// //               {/* Help */}
// //               <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
// //                 <h3 className="text-sm font-bold text-gray-900 mb-2 flex items-center gap-2">
// //                   <FiInfo className="text-red-500" size={14} /> Need Help?
// //                 </h3>
// //                 <div className="text-xs text-gray-500 space-y-1">
// //                   <p>support@havbit.in</p>
// //                   <p>+91 12345 67890</p>
// //                   <p className="text-gray-400">Mon-Sat · 9 AM - 6 PM</p>
// //                 </div>
// //               </div>

// //             </div>
// //           </div>
// //           {/* ════════════════════════════════════════════ */}

// //         </div>
// //       </div>
// //     </div>
// //   );
// // }




















// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   FiArrowLeft, FiCreditCard, FiUser, FiCheck, FiLoader,
//   FiCheckCircle, FiXCircle, FiAlertCircle, FiLogIn, FiShoppingBag,
//   FiLock, FiShield, FiPackage, FiTruck, FiInfo, FiTag, FiExternalLink,
//   FiMapPin, FiPhone, FiMail, FiHome, FiHeart, FiPlus, FiChevronRight,
//   FiEdit2, FiX,
// } from "react-icons/fi";
// import { FaPhoneAlt, FaRupeeSign } from "react-icons/fa";
// import { useAuth } from "../context/AuthContext";

// const API_BASE_URL = "https://server.havbit.in/api";

// // ─── Storage Keys ───────────────────────────────────────────────────────────
// const SAVED_ADDRESS_KEY = "havbit_saved_address";
// const SAVED_ALL_ADDRESSES_KEY = "havbit_all_addresses";
// const SAVED_PHONE_KEY = "havbit_saved_phone";

// /* ─────────────────────────────────────────────────────────
//    HELPERS
// ───────────────────────────────────────────────────────── */
// const loadRazorpayScript = () =>
//   new Promise((resolve, reject) => {
//     if (window.Razorpay) return resolve(true);
//     const s = document.createElement("script");
//     s.src = "https://checkout.razorpay.com/v1/checkout.js";
//     s.onload = () => resolve(true);
//     s.onerror = () => reject(new Error("Failed to load Razorpay SDK"));
//     document.body.appendChild(s);
//   });

// const getRazorpayPublicKey = (obj) =>
//   obj?.razorpayKey || obj?.key || obj?.razorpay_key || process.env.REACT_APP_RAZORPAY_KEY_ID;

// const isOid = (v) => typeof v === "string" && /^[0-9a-fA-F]{24}$/.test(v);

// const extractVendorId = (obj) => {
//   if (!obj) return null;
//   const candidates = [
//     obj.vendorId,
//     obj.vendor?._id,
//     typeof obj.vendor === "string" ? obj.vendor : null,
//     obj.sellerId,
//     obj.seller?._id,
//     typeof obj.seller === "string" ? obj.seller : null,
//   ];
//   for (const v of candidates) {
//     const s = v?.toString?.();
//     if (isOid(s)) return s;
//   }
//   return null;
// };

// const isPublicProduct = (item) =>
//   item.isVendorProduct === false || item.isVendorProduct === undefined || item.isVendorProduct === null;

// // ─── Address storage helpers ─────────────────────────────────────────────────
// const getSavedAddresses = () => {
//   try {
//     return JSON.parse(localStorage.getItem(SAVED_ALL_ADDRESSES_KEY) || "[]");
//   } catch { return []; }
// };

// const saveAddressToList = (addr) => {
//   try {
//     const all = getSavedAddresses();
//     // Deduplicate by address+city+pincode
//     const isDuplicate = all.some(
//       (a) => a.address === addr.address && a.city === addr.city && a.pincode === addr.pincode
//     );
//     if (!isDuplicate) {
//       all.unshift(addr);
//       localStorage.setItem(SAVED_ALL_ADDRESSES_KEY, JSON.stringify(all.slice(0, 5)));
//     }
//   } catch {}
// };

// const getSavedPhone = () => {
//   try { return localStorage.getItem(SAVED_PHONE_KEY) || ""; } catch { return ""; }
// };

// const savePhone = (phone) => {
//   try { if (phone) localStorage.setItem(SAVED_PHONE_KEY, phone); } catch {}
// };

// /* ─────────────────────────────────────────────────────────
//    STEP INDICATOR
// ───────────────────────────────────────────────────────── */
// const StepIndicator = ({ current }) => {
//   const steps = [
//     { n: 1, label: "Address", icon: FiMapPin },
//     { n: 2, label: "Payment", icon: FiCreditCard },
//     { n: 3, label: "Confirmed", icon: FiCheckCircle },
//   ];
//   return (
//     <div className="relative flex items-center justify-between mb-10 px-4">
//       <div className="absolute inset-x-0 top-5 h-0.5 bg-gray-200 z-0 mx-16" />
//       <div
//         className="absolute top-5 left-16 h-0.5 bg-gradient-to-r from-red-500 to-red-600 z-0 transition-all duration-700"
//         style={{ width: current === 1 ? "0%" : current === 2 ? "50%" : "100%", right: "4rem" }}
//       />
//       {steps.map(({ n, label, icon: Icon }) => (
//         <div key={n} className="relative z-10 flex flex-col items-center gap-2">
//           <motion.div
//             initial={false}
//             animate={{
//               scale: current === n ? 1.1 : 1,
//               backgroundColor:
//                 current > n ? "#16a34a" : current === n ? "#dc2626" : "#e5e7eb",
//             }}
//             className="w-10 h-10 rounded-full flex items-center justify-center shadow-md"
//           >
//             {current > n ? (
//               <FiCheck className="text-white" size={18} />
//             ) : (
//               <Icon
//                 className={current === n ? "text-white" : "text-gray-400"}
//                 size={16}
//               />
//             )}
//           </motion.div>
//           <span
//             className={`text-xs font-semibold tracking-wide ${
//               current >= n ? "text-gray-800" : "text-gray-400"
//             }`}
//           >
//             {label}
//           </span>
//         </div>
//       ))}
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────
//    INPUT FIELD
// ───────────────────────────────────────────────────────── */
// const Field = ({ label, icon: Icon, error, ...props }) => (
//   <div className="flex flex-col gap-1.5">
//     <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
//       {label}
//     </label>
//     <div className="relative">
//       {Icon && (
//         <Icon
//           size={14}
//           className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
//         />
//       )}
//       <input
//         {...props}
//         className={`w-full ${Icon ? "pl-10" : "pl-4"} pr-4 py-3 bg-gray-50 border ${
//           error ? "border-red-400" : "border-gray-200"
//         } rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-transparent focus:bg-white transition-all`}
//       />
//     </div>
//     {error && <p className="text-xs text-red-500">{error}</p>}
//   </div>
// );

// /* ─────────────────────────────────────────────────────────
//    ADDRESS SELECTOR (Swiggy-style)
//    Shows saved addresses in a bottom-sheet style modal
// ───────────────────────────────────────────────────────── */
// const AddressSelector = ({ savedAddresses, onSelect, onAddNew, onClose }) => (
//   <AnimatePresence>
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       exit={{ opacity: 0 }}
//       className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 backdrop-blur-sm"
//       onClick={onClose}
//     >
//       <motion.div
//         initial={{ y: 80, opacity: 0 }}
//         animate={{ y: 0, opacity: 1 }}
//         exit={{ y: 80, opacity: 0 }}
//         transition={{ type: "spring", stiffness: 300, damping: 30 }}
//         className="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-2xl overflow-hidden shadow-2xl"
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* Header */}
//         <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
//           <h3 className="text-base font-bold text-gray-900">Select Address</h3>
//           <button
//             onClick={onClose}
//             className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition"
//           >
//             <FiX size={18} className="text-gray-500" />
//           </button>
//         </div>

//         {/* Add New Address */}
//         <button
//           onClick={onAddNew}
//           className="w-full flex items-center gap-3 px-5 py-4 border-b border-gray-100 hover:bg-red-50 transition group"
//         >
//           <div className="w-10 h-10 rounded-full border-2 border-red-500 flex items-center justify-center group-hover:bg-red-500 transition">
//             <FiPlus className="text-red-500 group-hover:text-white transition" size={18} />
//           </div>
//           <span className="text-sm font-semibold text-red-500">Add New Address</span>
//           <FiChevronRight className="ml-auto text-red-400" size={16} />
//         </button>

//         {/* Saved Addresses */}
//         {savedAddresses.length > 0 && (
//           <div className="px-5 pt-4 pb-2">
//             <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">
//               Saved Addresses
//             </p>
//             <div className="space-y-2 max-h-72 overflow-y-auto pb-2">
//               {savedAddresses.map((addr, i) => (
//                 <button
//                   key={i}
//                   onClick={() => onSelect(addr)}
//                   className="w-full flex items-start gap-3 p-3 rounded-xl border border-gray-100 hover:border-red-300 hover:bg-red-50 transition text-left group"
//                 >
//                   <div className="w-9 h-9 bg-gray-100 rounded-xl flex items-center justify-center shrink-0 mt-0.5 group-hover:bg-red-100 transition">
//                     <FiMapPin className="text-gray-500 group-hover:text-red-500 transition" size={15} />
//                   </div>
//                   <div className="flex-1 min-w-0">
//                     <p className="text-sm font-semibold text-gray-800 truncate">
//                       {addr.city}, {addr.state}
//                     </p>
//                     <p className="text-xs text-gray-500 mt-0.5 line-clamp-2">
//                       {addr.address}, {addr.pincode}
//                     </p>
//                     {addr.phone && (
//                       <p className="text-xs text-gray-400 mt-0.5">📞 {addr.phone}</p>
//                     )}
//                   </div>
//                   {i === 0 && (
//                     <span className="shrink-0 text-xs bg-green-100 text-green-700 font-semibold px-2 py-0.5 rounded-full mt-0.5">
//                       Recent
//                     </span>
//                   )}
//                 </button>
//               ))}
//             </div>
//           </div>
//         )}

//         <div className="h-6" />
//       </motion.div>
//     </motion.div>
//   </AnimatePresence>
// );

// /* ─────────────────────────────────────────────────────────
//    ORDER SUMMARY SIDEBAR
// ───────────────────────────────────────────────────────── */
// const OrderSummary = ({ cart, totals, appliedCoupon, paymentMethod }) => (
//   <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
//     <div className="bg-gradient-to-r from-gray-900 to-gray-800 px-5 py-4">
//       <h3 className="text-white font-bold text-sm flex items-center gap-2">
//         <FiShoppingBag size={15} /> Order Summary
//       </h3>
//       <p className="text-gray-400 text-xs mt-0.5">{cart.length} item{cart.length !== 1 ? "s" : ""}</p>
//     </div>

//     <div className="max-h-48 overflow-y-auto divide-y divide-gray-50">
//       {cart.map((item) => (
//         <div key={item._id} className="flex items-center gap-3 px-4 py-3">
//           <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-100 shrink-0 border border-gray-200">
//             <img
//               src={item.image || item.images?.[0] || "/placeholder.png"}
//               alt={item.name}
//               className="w-full h-full object-cover"
//               onError={(e) => { e.target.src = "/placeholder.png"; }}
//             />
//           </div>
//           <div className="flex-1 min-w-0">
//             <p className="text-xs font-semibold text-gray-800 truncate">{item.name}</p>
//             <p className="text-xs text-gray-400 mt-0.5">Qty: {item.qty || 1}</p>
//           </div>
//           <p className="text-xs font-bold text-gray-800 shrink-0">
//             ₹{((parseFloat(item.price) || 0) * (parseInt(item.qty) || 1)).toFixed(0)}
//           </p>
//         </div>
//       ))}
//     </div>

//     <div className="px-5 py-4 border-t border-gray-100 space-y-2.5">
//       {[
//         { label: "Subtotal", value: `₹${totals.subtotal.toFixed(2)}` },
//         {
//           label: "Delivery",
//           value: totals.deliveryFee === 0 ? "FREE" : `₹${totals.deliveryFee}`,
//           green: totals.deliveryFee === 0,
//           orange: totals.deliveryFee > 0,
//         },
//       ].map((r) => (
//         <div key={r.label} className="flex justify-between text-xs">
//           <span className="text-gray-500">{r.label}</span>
//           <span className={`font-semibold ${r.green ? "text-green-600" : r.orange ? "text-orange-500" : "text-gray-700"}`}>
//             {r.value}
//           </span>
//         </div>
//       ))}

//       {paymentMethod === "cod" && (
//         <div className="flex items-center gap-1.5 text-xs text-orange-600 bg-orange-50 border border-orange-200 rounded-lg px-2.5 py-1.5">
//           <FiInfo size={11} className="shrink-0" />
//           <span>₹30 delivery charge for Cash on Delivery</span>
//         </div>
//       )}
//       {paymentMethod === "razorpay" && (
//         <div className="flex items-center gap-1.5 text-xs text-green-600 bg-green-50 border border-green-200 rounded-lg px-2.5 py-1.5">
//           <FiCheckCircle size={11} className="shrink-0" />
//           <span>Free delivery on online payment!</span>
//         </div>
//       )}

//       {appliedCoupon && (
//         <div className="flex justify-between text-xs border-t border-dashed border-green-200 pt-2">
//           <span className="text-green-600 flex items-center gap-1">
//             <FiTag size={11} /> {appliedCoupon.code}
//           </span>
//           <span className="font-bold text-green-600">-₹{appliedCoupon.discount.toFixed(2)}</span>
//         </div>
//       )}
//       <div className="flex justify-between items-center border-t border-gray-200 pt-3">
//         <span className="font-bold text-gray-900">Total</span>
//         <span className="text-xl font-extrabold text-red-600">₹{totals.total.toFixed(2)}</span>
//       </div>
//     </div>

//     <div className="px-5 pb-5">
//       <div className="flex items-center gap-3 text-xs text-gray-500 border-t border-gray-100 pt-4">
//         <FiShield className="text-green-500 shrink-0" size={14} />
//         <span>Secure checkout • Bank-level encryption</span>
//       </div>
//     </div>
//   </div>
// );

// /* ─────────────────────────────────────────────────────────
//    MAIN CHECKOUT COMPONENT
// ───────────────────────────────────────────────────────── */
// export default function Checkout({ cart = [], clearCart }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user, isAuthenticated, getUserId, getToken } = useAuth();

//   const preSelectedPayment = location.state?.paymentMethod;

//   const [step, setStep] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [paymentLoading, setPaymentLoading] = useState(false);
//   const [couponLoading, setCouponLoading] = useState(false);
//   const [vendorLoading, setVendorLoading] = useState(false);

//   // ── Address selector state ──
//   const [showAddressSelector, setShowAddressSelector] = useState(false);
//   const [savedAddresses, setSavedAddresses] = useState([]);
//   const [showAddressForm, setShowAddressForm] = useState(true); // true = show form

//   const [formData, setFormData] = useState({
//     name: "", email: "", phone: "",
//     address: "", city: "", state: "", pincode: "",
//     paymentMethod: preSelectedPayment === "ONLINE" ? "razorpay" : "cod",
//     weight: "0.5", length: "15", width: "10", height: "5",
//   });

//   const [fieldErrors, setFieldErrors] = useState({});
//   const [orderDetails, setOrderDetails] = useState(null);
//   const [paymentError, setPaymentError] = useState(null);
//   const [paymentSuccess, setPaymentSuccess] = useState(false);
//   const [backendOrderData, setBackendOrderData] = useState(null);
//   const [razorpayMeta, setRazorpayMeta] = useState(null);

//   const [couponCode, setCouponCode] = useState("");
//   const [appliedCoupon, setAppliedCoupon] = useState(null);
//   const [couponError, setCouponError] = useState("");
//   const [couponDiscount, setCouponDiscount] = useState(0);

//   const [resolvedVendorId, setResolvedVendorId] = useState(null);
//   const [resolvedWarehouseId, setResolvedWarehouseId] = useState(null);
//   const [vendorError, setVendorError] = useState("");

//   const [confirmedCart, setConfirmedCart] = useState([]);
//   const [confirmedTotals, setConfirmedTotals] = useState(null);
//   const [confirmedPaymentMethod, setConfirmedPaymentMethod] = useState(null);
//   const [confirmedCoupon, setConfirmedCoupon] = useState(null);

//   const allCartItemsPublic = cart.every((item) => isPublicProduct(item));

//   const calculateTotals = () => {
//     const subtotal = cart.reduce(
//       (s, i) => s + (parseFloat(i.price) || 0) * (parseInt(i.qty) || 1),
//       0
//     );
//     const deliveryFee = formData.paymentMethod === "cod" ? 30 : 0;
//     const platformFee = 0;
//     const totalBeforeDiscount = subtotal + deliveryFee + platformFee;
//     const total = Math.max(0, totalBeforeDiscount - couponDiscount);
//     return {
//       subtotal: +subtotal.toFixed(2),
//       deliveryFee: +deliveryFee.toFixed(2),
//       platformFee: +platformFee.toFixed(2),
//       totalBeforeDiscount: +totalBeforeDiscount.toFixed(2),
//       couponDiscount: +couponDiscount.toFixed(2),
//       total: +total.toFixed(2),
//     };
//   };
//   const totals = calculateTotals();

//   const resolveVendorAndWarehouse = useCallback(async () => {
//     if (cart.length === 0 || allCartItemsPublic) return;
//     setVendorLoading(true);
//     setVendorError("");
//     try {
//       const token = getToken();
//       if (!token) { setVendorError("Please login to continue."); return; }
//       const res = await fetch(`${API_BASE_URL}/parcelx/warehouse`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       const data = await res.json();
//       if (!data.success || !data.warehouses?.length) {
//         setVendorError("No warehouse configured for this vendor.");
//         return;
//       }
//       setResolvedWarehouseId(data.warehouses[0]._id);
//       setResolvedVendorId(data.warehouses[0].vendorId);
//     } catch (e) {
//       setVendorError("Failed to load shipping info: " + e.message);
//     } finally {
//       setVendorLoading(false);
//     }
//   }, [cart, getToken, allCartItemsPublic]);

//   useEffect(() => {
//     if (isAuthenticated && cart.length > 0) resolveVendorAndWarehouse();
//   }, [isAuthenticated, resolveVendorAndWarehouse]);

//   useEffect(() => {
//     if (!isAuthenticated) navigate("/login", { state: { from: "/checkout" } });
//   }, [isAuthenticated, navigate]);

//   // ── On mount: load saved addresses and decide flow ──
//   useEffect(() => {
//     const addresses = getSavedAddresses();
//     setSavedAddresses(addresses);

//     // If user has saved addresses → show selector directly
//     if (addresses.length > 0) {
//       setShowAddressForm(false);
//       setShowAddressSelector(true);
//     }
//     // else: show form directly (first time user)
//   }, []);

//   // ── Auto-fill: user profile + saved phone ──
//   useEffect(() => {
//     if (!user) return;
//     const savedPhone = getSavedPhone();
//     setFormData((p) => ({
//       ...p,
//       name:  user.fullName || user.name  || p.name,
//       email: user.email                  || p.email,
//       // phone: saved phone first, then user profile phone
//       phone: savedPhone || user.phone    || p.phone,
//     }));
//   }, [user]);

//   // ── When user selects a saved address ──
//   const handleSelectSavedAddress = (addr) => {
//     setFormData((p) => ({
//       ...p,
//       address: addr.address || p.address,
//       city:    addr.city    || p.city,
//       state:   addr.state   || p.state,
//       pincode: addr.pincode || p.pincode,
//       // Fill phone from saved address if available
//       phone:   addr.phone   || p.phone,
//     }));
//     setShowAddressSelector(false);
//     setShowAddressForm(true);
//   };

//   // ── Add new address: close selector, show blank form ──
//   const handleAddNewAddress = () => {
//     setFormData((p) => ({
//       ...p,
//       address: "", city: "", state: "", pincode: "",
//     }));
//     setShowAddressSelector(false);
//     setShowAddressForm(true);
//   };

//   const handleApplyCoupon = async () => {
//     if (!couponCode.trim()) return setCouponError("Please enter a coupon code");
//     setCouponLoading(true); setCouponError("");
//     try {
//       const token = getToken();
//       const res = await fetch(`${API_BASE_URL}/coupons/apply`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//         body: JSON.stringify({ code: couponCode.toUpperCase(), orderAmount: totals.totalBeforeDiscount }),
//       });
//       const data = await res.json();
//       if (!data.success) return setCouponError(data.message || "Invalid coupon");
//       setAppliedCoupon({ code: couponCode.toUpperCase(), discount: data.discount });
//       setCouponDiscount(data.discount);
//     } catch (e) {
//       setCouponError(e.message || "Failed to apply coupon");
//     } finally { setCouponLoading(false); }
//   };

//   const handleRemoveCoupon = () => {
//     setAppliedCoupon(null); setCouponDiscount(0); setCouponCode(""); setCouponError("");
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((p) => ({ ...p, [name]: value }));
//     if (fieldErrors[name]) setFieldErrors((p) => ({ ...p, [name]: "" }));
//   };

//   const validateForm = () => {
//     const { name, email, phone, address, city, state, pincode } = formData;
//     const errors = {};
//     if (!name.trim() || name.trim().length < 2) errors.name = "Enter your full name";
//     if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "Enter a valid email";
//     if (!phone.trim() || !/^[6-9]\d{9}$/.test(phone)) errors.phone = "Valid 10-digit Indian mobile required";
//     if (!address.trim() || address.trim().length < 10) errors.address = "Complete address required (min 10 chars)";
//     if (!city.trim()) errors.city = "Enter your city";
//     if (!state.trim()) errors.state = "Enter your state";
//     if (!pincode.trim() || !/^\d{6}$/.test(pincode)) errors.pincode = "Valid 6-digit pincode required";
//     setFieldErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   // ── Save address + phone to localStorage then go to step 2 ──
//   const handleProceedToPayment = async () => {
//     if (!validateForm()) return;

//     // ✅ FIX 1: Save phone number separately
//     savePhone(formData.phone);

//     // ✅ FIX 2: Save full address including phone to the addresses list
//     const addressEntry = {
//       address: formData.address,
//       city:    formData.city,
//       state:   formData.state,
//       pincode: formData.pincode,
//       phone:   formData.phone,  // also store phone with address
//     };
//     saveAddressToList(addressEntry);

//     // Also update the old single-address key for backward compat
//     try {
//       localStorage.setItem(SAVED_ADDRESS_KEY, JSON.stringify(addressEntry));
//     } catch {}

//     // Refresh saved addresses list
//     setSavedAddresses(getSavedAddresses());

//     if (formData.paymentMethod === "razorpay") {
//       try { await loadRazorpayScript(); } catch { return alert("Failed to load payment gateway. Try again."); }
//     }
//     setStep(2);
//   };

//   const saveOrderToStorage = (order) => {
//     try {
//       const all = JSON.parse(localStorage.getItem("user_orders") || "[]");
//       const idx = all.findIndex((o) => o._id === order._id);
//       if (idx === -1) all.unshift(order);
//       else all[idx] = order;
//       localStorage.setItem("user_orders", JSON.stringify(all.slice(0, 50)));
//     } catch (e) { console.error("Storage error:", e); }
//   };

//   const createParcelxOrder = async () => {
//     const token = getToken();
//     if (!token) throw new Error("Please login again.");
//     const customerId = getUserId();
//     if (!customerId) throw new Error("User ID missing — please login again.");

//     let vendorId = null;
//     let warehouseId = null;

//     if (!allCartItemsPublic) {
//       vendorId = resolvedVendorId;
//       if (!vendorId) {
//         for (const item of cart) {
//           if (!isPublicProduct(item)) {
//             vendorId = extractVendorId(item);
//             if (vendorId) break;
//           }
//         }
//       }
//       if (!vendorId) {
//         for (const item of cart) {
//           if (isPublicProduct(item)) continue;
//           const productId = item._id || item.productId;
//           if (!isOid(productId)) continue;
//           try {
//             const res = await fetch(`${API_BASE_URL}/products/${productId}`, {
//               headers: { Authorization: `Bearer ${token}` },
//             });
//             const data = await res.json();
//             vendorId = extractVendorId(data.product || data.data || data);
//             if (vendorId) break;
//           } catch (e) { /* continue */ }
//         }
//       }
//       if (!vendorId) throw new Error("Vendor information not found. Please go back and re-add vendor items to cart.");

//       warehouseId = resolvedWarehouseId;
//       if (!warehouseId) {
//         const wRes = await fetch(`${API_BASE_URL}/parcelx/warehouse`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         const wData = await wRes.json();
//         if (wData.success && wData.warehouses?.length > 0) {
//           warehouseId = wData.warehouses[0]._id;
//           setResolvedWarehouseId(warehouseId);
//         } else {
//           throw new Error("Warehouse not found for this vendor. Please contact support.");
//         }
//       }
//       if (!warehouseId) throw new Error("Warehouse not found for this vendor. Please contact support.");
//     }

//     const orderItems = cart.map((item) => {
//       let pId = item._id || item.productId;
//       if (!isOid(pId)) pId = "000000000000000000000001";
//       return {
//         productId: pId,
//         productName: item.name || item.productName || "Product",
//         price: parseFloat(item.price) || 0,
//         qty: parseInt(item.qty) || 1,
//         vendorId: vendorId || null,
//       };
//     });

//     const totalWeight = Math.max(
//       cart.reduce((s, i) => s + (parseFloat(i.weight) || 0.5) * (parseInt(i.qty) || 1), 0),
//       0.1
//     ).toFixed(2);

//     const payload = {
//       customer: customerId,
//       vendorId: vendorId || null,
//       warehouseId: warehouseId || null,
//       isPublicOrder: allCartItemsPublic,
//       orderItems,
//       amount: totals.total,
//       couponCode: appliedCoupon?.code || null,
//       couponDiscount,
//       subtotal: totals.subtotal,
//       deliveryFee: totals.deliveryFee,
//       platformFee: totals.platformFee,
//       gst: totals.gst,
//       paymentMethod: formData.paymentMethod,
//       shippingAddress: {
//         name: formData.name,
//         email: formData.email,
//         phone: formData.phone,
//         address: formData.address,
//         city: formData.city,
//         state: formData.state,
//         pincode: formData.pincode,
//       },
//       shipment: {
//         weight: parseFloat(formData.weight) || parseFloat(totalWeight),
//         length: parseFloat(formData.length) || 15,
//         width: parseFloat(formData.width) || 10,
//         height: parseFloat(formData.height) || 5,
//       },
//     };

//     const res = await fetch(`${API_BASE_URL}/parcelx/order`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//       body: JSON.stringify(payload),
//     });
//     const json = await res.json();
//     if (!res.ok || !json.success) {
//       const errMsg = json.parcelxError || json.parcelx?.message || json.message || "Failed to create order";
//       throw new Error(errMsg);
//     }
//     return json.order;
//   };

//   const createRazorpayOrderFromBackend = async (orderId) => {
//     const token = getToken();
//     const res = await fetch(`${API_BASE_URL}/razorpay/create-order`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//       body: JSON.stringify({ orderId, amount: Math.round(totals.total * 100), currency: "INR" }),
//     });
//     const json = await res.json();
//     if (!res.ok || !json.success) throw new Error(json.message || "Failed to init payment");
//     return { razorpayOrderId: json.razorpayOrderId, amount: Math.round(totals.total * 100), currency: json.currency || "INR", key: json.key };
//   };

//   const verifyRazorpayPayment = async (payload) => {
//     const token = getToken();
//     const res = await fetch(`${API_BASE_URL}/razorpay/verify-payment`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//       body: JSON.stringify(payload),
//     });
//     return res.json();
//   };

//   const initiateRazorpayPayment = async (order) => {
//     setPaymentLoading(true); setPaymentError(null);
//     try {
//       if (!window.Razorpay) await loadRazorpayScript();
//       const razorpayKey = getRazorpayPublicKey(razorpayMeta);
//       if (!razorpayKey) throw new Error("Razorpay key missing");
//       const rp = new window.Razorpay({
//         key: razorpayKey,
//         amount: Math.round(totals.total * 100),
//         currency: razorpayMeta?.currency || "INR",
//         name: "HAVBIT",
//         description: `Order #${order._id?.slice(-8).toUpperCase()}`,
//         image: "/logo.png",
//         order_id: razorpayMeta?.razorpayOrderId,
//         handler: async (response) => {
//           const v = await verifyRazorpayPayment({
//             orderId: order._id,
//             razorpay_payment_id: response.razorpay_payment_id,
//             razorpay_order_id: response.razorpay_order_id,
//             razorpay_signature: response.razorpay_signature,
//           });
//           if (v.success) {
//             const updated = { ...order, paymentStatus: "Success", orderStatus: "Confirmed", razorpayPaymentId: response.razorpay_payment_id };
//             saveOrderToStorage(updated);
//             setConfirmedCart([...cart]);
//             setConfirmedTotals({ ...totals });
//             setConfirmedPaymentMethod(formData.paymentMethod);
//             setConfirmedCoupon(appliedCoupon ? { ...appliedCoupon } : null);
//             setOrderDetails({
//               orderId: updated._id, paymentMethod: "razorpay",
//               amount: totals.total, orderStatus: "Confirmed", paymentStatus: "Success",
//               razorpayPaymentId: updated.razorpayPaymentId,
//               coupon: appliedCoupon, awb: order.parcelx?.awb,
//               courier: order.parcelx?.courier, trackingUrl: order.parcelx?.tracking_url,
//             });
//             setPaymentSuccess(true); setStep(3);
//             if (clearCart) { clearCart(); localStorage.removeItem("cart"); }
//           } else {
//             setPaymentError(v.message || "Verification failed");
//           }
//         },
//         prefill: { name: formData.name, email: formData.email, contact: formData.phone },
//         notes: { orderId: order._id },
//         theme: { color: "#dc2626" },
//         modal: { ondismiss: () => { setPaymentError("Payment cancelled"); setPaymentLoading(false); } },
//       });
//       rp.open();
//       rp.on("payment.failed", (r) => {
//         setPaymentError(r.error?.description || "Payment failed"); setPaymentLoading(false);
//       });
//     } catch (err) {
//       setPaymentError(err.message); setPaymentLoading(false);
//     }
//   };

//   const handleCreateOrder = async () => {
//     if (!validateForm()) return;
//     setLoading(true);
//     setPaymentError(null);
//     try {
//       const createdOrder = await createParcelxOrder();
//       setBackendOrderData(createdOrder);
//       saveOrderToStorage(createdOrder);

//       if (formData.paymentMethod === "razorpay") {
//         const rpMeta = await createRazorpayOrderFromBackend(createdOrder._id);
//         setRazorpayMeta(rpMeta);
//       } else {
//         const updatedOrder = {
//           ...createdOrder,
//           paymentStatus: "Pending",
//           orderStatus: "Confirmed",
//         };
//         saveOrderToStorage(updatedOrder);
//         setConfirmedCart([...cart]);
//         setConfirmedTotals({ ...totals });
//         setConfirmedPaymentMethod(formData.paymentMethod);
//         setConfirmedCoupon(appliedCoupon ? { ...appliedCoupon } : null);
//         setOrderDetails({
//           orderId: updatedOrder._id,
//           paymentMethod: "cod",
//           amount: totals.total,
//           orderStatus: "Confirmed",
//           paymentStatus: "Pending",
//           coupon: appliedCoupon,
//           awb: updatedOrder.parcelx?.awb,
//           courier: updatedOrder.parcelx?.courier,
//           trackingUrl: updatedOrder.parcelx?.tracking_url,
//         });
//         setPaymentSuccess(true);
//         setStep(3);
//         if (clearCart) {
//           clearCart();
//           localStorage.removeItem("cart");
//         }
//       }
//     } catch (e) {
//       setPaymentError(e.message);
//       if (/expired|invalid|session/i.test(e.message)) {
//         alert("Session expired — please login again.");
//         navigate("/login", { state: { from: "/checkout" } });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleBack = () => {
//     if (step === 1) navigate("/cart");
//     else if (step === 3) navigate("/orders");
//     else setStep(1);
//   };

//   /* ─────────────── GUARDS ─────────────── */
//   if (!isAuthenticated) return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-50">
//       <div className="text-center">
//         <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
//           <FiLogIn className="text-red-600" size={24} />
//         </div>
//         <h2 className="text-xl font-bold text-gray-900 mb-2">Login Required</h2>
//         <p className="text-gray-500 text-sm mb-6">Please login to place an order</p>
//         <button
//           onClick={() => navigate("/login", { state: { from: "/checkout" } })}
//           className="px-6 py-3 bg-red-600 text-white rounded-xl font-semibold hover:bg-red-700 transition"
//         >
//           Login Now
//         </button>
//       </div>
//     </div>
//   );

//   if (cart.length === 0 && step !== 3) return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-50">
//       <div className="text-center">
//         <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
//           <FiShoppingBag className="text-red-600" size={24} />
//         </div>
//         <h2 className="text-xl font-bold text-gray-900 mb-2">Cart is Empty</h2>
//         <p className="text-gray-500 text-sm mb-6">Add products before checking out</p>
//         <button
//           onClick={() => navigate("/products")}
//           className="px-6 py-3 bg-red-600 text-white rounded-xl font-semibold hover:bg-red-700 transition"
//         >
//           Shop Now
//         </button>
//       </div>
//     </div>
//   );

//   const sidebarCart    = step === 3 && confirmedCart.length > 0 ? confirmedCart : cart;
//   const sidebarTotals  = step === 3 && confirmedTotals          ? confirmedTotals : totals;
//   const sidebarPayment = step === 3 && confirmedPaymentMethod   ? confirmedPaymentMethod : formData.paymentMethod;
//   const sidebarCoupon  = step === 3                             ? confirmedCoupon : appliedCoupon;

//   /* ─────────────── RENDER ─────────────── */
//   return (
//     <div className="min-h-screen bg-gray-50">

//       {/* ── Address Selector Modal (Swiggy-style) ── */}
//       {showAddressSelector && (
//         <AddressSelector
//           savedAddresses={savedAddresses}
//           onSelect={handleSelectSavedAddress}
//           onAddNew={handleAddNewAddress}
//           onClose={() => {
//             setShowAddressSelector(false);
//             setShowAddressForm(true);
//           }}
//         />
//       )}

//       {/* ── Top Bar ── */}
//       <div className="bg-white border-b border-gray-200 sticky top-0 z-30 shadow-sm">
//         <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
//           <button
//             onClick={handleBack}
//             className="flex items-center gap-2 text-gray-500 hover:text-red-600 transition-colors text-sm font-medium"
//           >
//             <FiArrowLeft size={16} />
//             <span className="hidden sm:inline">
//               {step === 3 ? "View Orders" : step === 2 ? "Back to Address" : "Back to Cart"}
//             </span>
//           </button>

//           <div className="flex items-center gap-2">
//             <div className="w-8 h-8 bg-red-600 rounded-lg flex items-center justify-center">
//               <FiShoppingBag className="text-white" size={14} />
//             </div>
//             <span className="font-bold text-gray-900 text-sm hidden sm:inline">Checkout</span>
//           </div>

//           <div className="flex items-center gap-2">
//             <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
//               <FiUser className="text-gray-600" size={14} />
//             </div>
//             <span className="text-sm font-medium text-gray-700 hidden sm:block">
//               {user?.fullName?.split(" ")[0] || user?.name?.split(" ")[0] || "User"}
//             </span>
//           </div>
//         </div>
//       </div>

//       <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
//           {/* ── Main Panel ── */}
//           <div className="lg:col-span-2">
//             <StepIndicator current={step} />

//             {vendorLoading && !allCartItemsPublic && (
//               <motion.div
//                 initial={{ opacity: 0, y: -8 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 className="mb-5 flex items-center gap-3 px-4 py-3 bg-blue-50 border border-blue-200 rounded-xl text-sm text-blue-700"
//               >
//                 <FiLoader className="animate-spin shrink-0" size={15} />
//                 <span>Setting up shipping configuration...</span>
//               </motion.div>
//             )}

//             {vendorError && !vendorLoading && !allCartItemsPublic && (
//               <motion.div
//                 initial={{ opacity: 0, y: -8 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 className="mb-5 flex items-start gap-3 px-4 py-3 bg-amber-50 border border-amber-300 rounded-xl"
//               >
//                 <FiAlertCircle className="text-amber-500 shrink-0 mt-0.5" size={15} />
//                 <div className="flex-1">
//                   <p className="text-sm font-semibold text-amber-800">Shipping Setup Issue</p>
//                   <p className="text-xs text-amber-700 mt-0.5">{vendorError}</p>
//                   <button
//                     onClick={resolveVendorAndWarehouse}
//                     className="mt-1.5 text-xs text-blue-600 underline hover:text-blue-700"
//                   >
//                     Retry →
//                   </button>
//                 </div>
//               </motion.div>
//             )}

//             {paymentError && (
//               <motion.div
//                 initial={{ opacity: 0, y: -8 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 className="mb-5 flex items-center gap-3 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-sm text-red-700"
//               >
//                 <FiXCircle className="shrink-0" size={15} />
//                 <span>{paymentError}</span>
//               </motion.div>
//             )}

//             <AnimatePresence mode="wait">

//               {/* ══════ STEP 1 – ADDRESS ══════ */}
//               {step === 1 && (
//                 <motion.div
//                   key="step1"
//                   initial={{ opacity: 0, x: 20 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   exit={{ opacity: 0, x: -20 }}
//                   transition={{ duration: 0.25 }}
//                 >
//                   <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
//                     <div className="px-6 pt-6 pb-4 border-b border-gray-100">
//                       <div className="flex items-center justify-between">
//                         <div>
//                           <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
//                             <FiMapPin className="text-red-500" size={18} />
//                             Delivery Address
//                           </h2>
//                           <p className="text-xs text-gray-500 mt-1">Where should we send your order?</p>
//                         </div>

//                         {/* ✅ Change Address button — only if saved addresses exist */}
//                         {savedAddresses.length > 0 && (
//                           <button
//                             onClick={() => setShowAddressSelector(true)}
//                             className="flex items-center gap-1.5 text-xs font-semibold text-red-600 border border-red-200 bg-red-50 hover:bg-red-100 px-3 py-1.5 rounded-xl transition"
//                           >
//                             <FiEdit2 size={11} />
//                             Change
//                           </button>
//                         )}
//                       </div>
//                     </div>

//                     <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-5">
//                       <Field label="Full Name" icon={FiUser} name="name" type="text"
//                         placeholder="Your full name" value={formData.name}
//                         onChange={handleChange} error={fieldErrors.name} />
//                       <Field label="Email" icon={FiMail} name="email" type="email"
//                         placeholder="email@example.com" value={formData.email}
//                         onChange={handleChange} error={fieldErrors.email} />
//                       <Field label="Phone" icon={FiPhone} name="phone" type="tel"
//                         placeholder="10-digit mobile number" value={formData.phone}
//                         onChange={handleChange} error={fieldErrors.phone} />
//                       <Field label="Pincode" icon={FiMapPin} name="pincode" type="text"
//                         placeholder="6-digit pincode" maxLength={6} value={formData.pincode}
//                         onChange={handleChange} error={fieldErrors.pincode} />

//                       <div className="sm:col-span-2 flex flex-col gap-1.5">
//                         <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
//                           Complete Address
//                         </label>
//                         <div className="relative">
//                           <FiHome size={14} className="absolute left-3.5 top-3.5 text-gray-400 pointer-events-none" />
//                           <textarea
//                             name="address"
//                             rows={3}
//                             value={formData.address}
//                             onChange={handleChange}
//                             placeholder="House no., Building, Street, Area, Landmark..."
//                             className={`w-full pl-10 pr-4 py-3 bg-gray-50 border ${
//                               fieldErrors.address ? "border-red-400" : "border-gray-200"
//                             } rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-400 focus:bg-white transition-all resize-none`}
//                           />
//                         </div>
//                         {fieldErrors.address && <p className="text-xs text-red-500">{fieldErrors.address}</p>}
//                       </div>

//                       <Field label="City" icon={FiMapPin} name="city" type="text"
//                         placeholder="Your city" value={formData.city}
//                         onChange={handleChange} error={fieldErrors.city} />
//                       <Field label="State" icon={FiMapPin} name="state" type="text"
//                         placeholder="Your state" value={formData.state}
//                         onChange={handleChange} error={fieldErrors.state} />
//                     </div>

//                     {/* Dimensions */}
//                     <div className="px-6 pb-4">
//                       <details className="group">
//                         <summary className="cursor-pointer text-xs font-semibold text-blue-600 flex items-center gap-1.5 select-none list-none">
//                           <FiPackage size={13} />
//                           <span>Advanced: Shipment Dimensions</span>
//                         </summary>
//                         <div className="mt-3 p-4 bg-blue-50 border border-blue-200 rounded-xl">
//                           <p className="text-xs text-blue-700 mb-3">
//                             Used by ParcelX for rate calculation. Defaults are pre-filled.
//                           </p>
//                           <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
//                             {[
//                               { label: "Weight (kg)", name: "weight" },
//                               { label: "Length (cm)", name: "length" },
//                               { label: "Width (cm)", name: "width" },
//                               { label: "Height (cm)", name: "height" },
//                             ].map((f) => (
//                               <div key={f.name}>
//                                 <label className="block text-xs font-medium text-blue-800 mb-1">{f.label}</label>
//                                 <input
//                                   type="number"
//                                   name={f.name}
//                                   value={formData[f.name]}
//                                   onChange={handleChange}
//                                   step="0.1"
//                                   min="0.1"
//                                   className="w-full px-3 py-2 bg-white border border-blue-200 rounded-lg text-xs focus:outline-none focus:ring-1 focus:ring-blue-400"
//                                 />
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       </details>
//                     </div>

//                     {/* Shipping strip */}
//                     <div className="mx-6 mb-6 flex items-center justify-between px-4 py-3 bg-gradient-to-r from-red-50 to-orange-50 border border-red-100 rounded-xl">
//                       <div className="flex items-center gap-2">
//                         <FiTruck className="text-red-500 shrink-0" size={15} />
//                         <span className="text-xs font-semibold text-gray-700">
//                           Shipped 3-5 working days
//                         </span>
//                       </div>
//                       <div className="text-xs">
//                         {allCartItemsPublic ? (
//                           <span className="text-green-600 flex items-center gap-1 font-medium">
//                             <FiCheckCircle size={11} /> Auto-configured
//                           </span>
//                         ) : vendorLoading ? (
//                           <span className="text-blue-500 flex items-center gap-1">
//                             <FiLoader className="animate-spin" size={11} /> Loading...
//                           </span>
//                         ) : resolvedWarehouseId ? (
//                           <span className="text-green-600 flex items-center gap-1 font-medium">
//                             <FiCheckCircle size={11} /> Ready
//                           </span>
//                         ) : (
//                           <span className="text-amber-600 flex items-center gap-1">
//                             <FiAlertCircle size={11} /> Pending
//                           </span>
//                         )}
//                       </div>
//                     </div>

//                     <div className="px-6 pb-6">
//                       <button
//                         onClick={handleProceedToPayment}
//                         className="w-full py-3.5 bg-gradient-to-r from-red-600 to-red-500 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-600 transition-all shadow-lg shadow-red-200 flex items-center justify-center gap-2 text-sm"
//                       >
//                         <FiCreditCard size={16} />
//                         Proceed to Payment
//                       </button>
//                     </div>
//                   </div>
//                 </motion.div>
//               )}

//               {/* ══════ STEP 2 – PAYMENT ══════ */}
//               {step === 2 && (
//                 <motion.div
//                   key="step2"
//                   initial={{ opacity: 0, x: 20 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   exit={{ opacity: 0, x: -20 }}
//                   transition={{ duration: 0.25 }}
//                 >
//                   <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
//                     <div className="px-6 pt-6 pb-4 border-b border-gray-100">
//                       <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
//                         <FiCreditCard className="text-red-500" size={18} />
//                         Payment Method
//                       </h2>
//                       <p className="text-xs text-gray-500 mt-1">How would you like to pay?</p>
//                     </div>

//                     <div className="p-6 space-y-3">
//                       {[
//                         {
//                           value: "cod",
//                           label: "Cash on Delivery",
//                           sub: "Pay when your order arrives • ₹30 delivery charge",
//                           badge: "Most Popular",
//                           icon: <FaPhoneAlt className="text-green-600" size={18} />,
//                           badgeColor: "bg-green-100 text-green-700",
//                           activeColor: "border-green-400 bg-green-50",
//                           deliveryNote: (
//                             <span className="text-xs text-orange-600 flex items-center gap-1 mt-1">
//                               <FiInfo size={11} /> ₹30 delivery charge applies for COD
//                             </span>
//                           ),
//                         },
//                         {
//                           value: "razorpay",
//                           label: "Online Payment",
//                           sub: "Cards • UPI • Net Banking • Wallets",
//                           badge: "FREE Delivery",
//                           icon: <FiCreditCard className="text-blue-600" size={18} />,
//                           badgeColor: "bg-green-100 text-green-700",
//                           activeColor: "border-blue-400 bg-blue-50",
//                           deliveryNote: (
//                             <span className="text-xs text-green-600 flex items-center gap-1 mt-1">
//                               <FiCheckCircle size={11} /> Free delivery on online payment!
//                             </span>
//                           ),
//                         },
//                       ].map((opt) => (
//                         <label
//                           key={opt.value}
//                           className={`flex items-start gap-4 p-4 border-2 rounded-xl cursor-pointer transition-all ${
//                             formData.paymentMethod === opt.value
//                               ? opt.activeColor
//                               : "border-gray-200 hover:border-gray-300 bg-white"
//                           }`}
//                         >
//                           <input
//                             type="radio"
//                             name="paymentMethod"
//                             value={opt.value}
//                             checked={formData.paymentMethod === opt.value}
//                             onChange={handleChange}
//                             className="w-4 h-4 accent-red-600 mt-1"
//                           />
//                           <div className="w-10 h-10 bg-white border border-gray-200 rounded-xl flex items-center justify-center shadow-sm shrink-0">
//                             {opt.icon}
//                           </div>
//                           <div className="flex-1">
//                             <div className="flex items-center gap-2 flex-wrap">
//                               <p className="font-bold text-gray-900 text-sm">{opt.label}</p>
//                               <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${opt.badgeColor}`}>
//                                 {opt.badge}
//                               </span>
//                             </div>
//                             <p className="text-xs text-gray-500 mt-0.5">{opt.sub}</p>
//                             {opt.deliveryNote}
//                           </div>
//                           {formData.paymentMethod === opt.value && (
//                             <div className="w-5 h-5 bg-red-600 rounded-full flex items-center justify-center shrink-0 mt-1">
//                               <FiCheck className="text-white" size={11} />
//                             </div>
//                           )}
//                         </label>
//                       ))}
//                     </div>

//                     {/* Coupon Section */}
//                     <div className="px-6 pb-4">
//                       <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl">
//                         <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
//                           <FiTag className="text-orange-500" size={15} />
//                           Have a Coupon?
//                         </h3>
//                         <div className="flex gap-2">
//                           <input
//                             type="text"
//                             value={couponCode}
//                             onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
//                             placeholder="ENTER CODE"
//                             disabled={!!appliedCoupon}
//                             className="flex-1 px-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm font-mono font-semibold tracking-widest focus:outline-none focus:ring-2 focus:ring-orange-400 disabled:bg-gray-100 disabled:text-gray-400 uppercase"
//                           />
//                           {appliedCoupon ? (
//                             <button
//                               onClick={handleRemoveCoupon}
//                               className="px-4 py-2.5 bg-red-100 text-red-600 font-semibold rounded-xl hover:bg-red-200 transition text-sm"
//                             >
//                               Remove
//                             </button>
//                           ) : (
//                             <button
//                               onClick={handleApplyCoupon}
//                               disabled={couponLoading}
//                               className="px-4 py-2.5 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-600 transition disabled:opacity-50 text-sm flex items-center gap-1.5"
//                             >
//                               {couponLoading ? <FiLoader className="animate-spin" size={14} /> : "Apply"}
//                             </button>
//                           )}
//                         </div>
//                         {couponError && (
//                           <p className="mt-2 text-xs text-red-500 flex items-center gap-1">
//                             <FiAlertCircle size={12} /> {couponError}
//                           </p>
//                         )}
//                         {appliedCoupon && (
//                           <div className="mt-3 flex items-center justify-between px-3 py-2.5 bg-green-50 border border-green-200 rounded-lg">
//                             <span className="flex items-center gap-1.5 text-sm font-bold text-green-800">
//                               <FiCheckCircle className="text-green-600" size={14} />
//                               {appliedCoupon.code}
//                             </span>
//                             <span className="text-sm font-bold text-green-700">
//                               -₹{appliedCoupon.discount.toFixed(2)}
//                             </span>
//                           </div>
//                         )}
//                       </div>
//                     </div>

//                     {/* Amount Box */}
//                     <div className="px-6 pb-4">
//                       <div className="flex items-center justify-between px-5 py-4 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl text-white">
//                         <div>
//                           <p className="text-xs text-gray-400 font-medium">Total Payable</p>
//                           <p className="text-2xl font-extrabold mt-0.5">₹{totals.total.toFixed(2)}</p>
//                           {appliedCoupon && (
//                             <p className="text-xs text-green-400 mt-0.5">
//                               You saved ₹{couponDiscount.toFixed(2)} 🎉
//                             </p>
//                           )}
//                         </div>
//                         <div className="text-right text-xs text-gray-400 space-y-1">
//                           <p>Subtotal: ₹{totals.subtotal.toFixed(2)}</p>
//                           <p className={totals.deliveryFee === 0 ? "text-green-400" : "text-orange-400"}>
//                             Delivery: {totals.deliveryFee === 0 ? "FREE" : `₹${totals.deliveryFee}`}
//                           </p>
//                         </div>
//                       </div>
//                     </div>

//                     {/* CTA */}
//                     <div className="px-6 pb-6">
//                       {!backendOrderData ? (
//                         <button
//                           onClick={handleCreateOrder}
//                           disabled={loading}
//                           className="w-full py-3.5 bg-gradient-to-r from-red-600 to-red-500 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-600 transition-all shadow-lg shadow-red-200 flex items-center justify-center gap-2 text-sm disabled:opacity-60 disabled:cursor-not-allowed"
//                         >
//                           {loading ? (
//                             <>
//                               <FiLoader className="animate-spin" size={16} />
//                               Creating Order & Booking Shipment...
//                             </>
//                           ) : (
//                             <>
//                               <FiCheck size={16} />
//                               {formData.paymentMethod === "cod"
//                                 ? "Place Order (COD • ₹30 Delivery)"
//                                 : "Create Order & Pay Online (Free Delivery)"}
//                             </>
//                           )}
//                         </button>
//                       ) : formData.paymentMethod === "razorpay" ? (
//                         <button
//                           onClick={() => initiateRazorpayPayment(backendOrderData)}
//                           disabled={paymentLoading}
//                           className="w-full py-3.5 bg-gradient-to-r from-blue-600 to-blue-500 text-white font-bold rounded-xl hover:from-blue-700 hover:to-blue-600 transition-all shadow-lg shadow-blue-200 flex items-center justify-center gap-2 text-sm disabled:opacity-60"
//                         >
//                           {paymentLoading ? (
//                             <><FiLoader className="animate-spin" size={16} /> Opening Payment Gateway...</>
//                           ) : (
//                             <><FiCreditCard size={16} /> Pay ₹{totals.total.toFixed(2)} with Razorpay</>
//                           )}
//                         </button>
//                       ) : (
//                         <div className="p-4 bg-green-50 border border-green-200 rounded-xl">
//                           <div className="flex items-center gap-3 mb-3">
//                             <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center">
//                               <FiCheckCircle className="text-green-600" size={20} />
//                             </div>
//                             <div>
//                               <p className="font-bold text-green-800 text-sm">Order & AWB Created!</p>
//                               <p className="text-xs text-green-600">
//                                 #{backendOrderData._id?.slice(-8).toUpperCase()}
//                                 {backendOrderData.parcelx?.awb && (
//                                   <> · AWB: <strong>{backendOrderData.parcelx.awb}</strong></>
//                                 )}
//                               </p>
//                             </div>
//                           </div>
//                           <button
//                             onClick={() => setStep(3)}
//                             className="w-full py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition font-semibold text-sm"
//                           >
//                             View Confirmation →
//                           </button>
//                         </div>
//                       )}
//                       <p className="text-center text-xs text-gray-400 mt-3 flex items-center justify-center gap-1">
//                         <FiLock size={11} /> Secured with bank-level encryption
//                       </p>
//                     </div>
//                   </div>
//                 </motion.div>
//               )}

//               {/* ══════ STEP 3 – CONFIRMATION ══════ */}
//               {step === 3 && orderDetails && (
//                 <motion.div
//                   key="step3"
//                   initial={{ opacity: 0, scale: 0.96 }}
//                   animate={{ opacity: 1, scale: 1 }}
//                   transition={{ duration: 0.3 }}
//                 >
//                   {/* ── THANK YOU BANNER ── */}
//                   <motion.div
//                     initial={{ opacity: 0, y: -16 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: 0.15, duration: 0.4 }}
//                     className="mb-4 rounded-2xl overflow-hidden bg-gradient-to-r from-red-600 via-red-500 to-orange-500 px-6 py-5 flex items-center justify-between shadow-lg shadow-red-200"
//                   >
//                     <div>
//                       <p className="text-white/80 text-xs font-semibold uppercase tracking-widest mb-1">
//                         HAVBIT
//                       </p>
//                       <h2 className="text-white text-xl font-extrabold leading-tight">
//                         Thank you for your order,
//                       </h2>
//                       <p className="text-white/90 text-lg font-bold">
//                         {formData.name?.split(" ")[0] || "Friend"}! 🎉
//                       </p>
//                       <p className="text-white/70 text-xs mt-1.5">
//                         We're thrilled to have you shop with us. Your order is in safe hands!
//                       </p>
//                     </div>
//                     <motion.div
//                       animate={{ scale: [1, 1.15, 1] }}
//                       transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
//                       className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center shrink-0 ml-4"
//                     >
//                       <FiHeart className="text-white" size={30} />
//                     </motion.div>
//                   </motion.div>

//                   {/* ── ORDER CONFIRMED CARD ── */}
//                   <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
//                     <div className="bg-gradient-to-br from-green-500 to-emerald-600 px-6 py-10 text-center">
//                       <motion.div
//                         initial={{ scale: 0 }}
//                         animate={{ scale: 1 }}
//                         transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
//                         className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg"
//                       >
//                         {paymentSuccess ? (
//                           <FiCheck className="text-green-500" size={36} />
//                         ) : (
//                           <FiAlertCircle className="text-amber-500" size={36} />
//                         )}
//                       </motion.div>
//                       <motion.h2
//                         initial={{ opacity: 0, y: 10 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         transition={{ delay: 0.3 }}
//                         className="text-2xl font-extrabold text-white mb-1"
//                       >
//                         {paymentSuccess ? "Order Confirmed! 🎉" : "Order Created"}
//                       </motion.h2>
//                       <motion.p
//                         initial={{ opacity: 0 }}
//                         animate={{ opacity: 1 }}
//                         transition={{ delay: 0.4 }}
//                         className="text-green-100 text-sm"
//                       >
//                         {paymentSuccess
//                           ? "Your order is confirmed and shipment booked"
//                           : "Order placed but payment pending"}
//                       </motion.p>
//                     </div>

//                     <div className="p-6 space-y-4">
//                       <div className="grid grid-cols-2 gap-3">
//                         {[
//                           { label: "Order ID", value: `#${orderDetails.orderId?.slice(-8).toUpperCase()}` },
//                           {
//                             label: "Amount",
//                             value: `₹${orderDetails.amount?.toFixed(2)}`,
//                             valueClass: "text-green-600",
//                           },
//                           {
//                             label: "Payment",
//                             value: orderDetails.paymentMethod === "cod" ? "Cash on Delivery" : "Online Payment",
//                           },
//                           {
//                             label: "Status",
//                             value: orderDetails.orderStatus || "Confirmed",
//                             valueClass: "text-green-600",
//                           },
//                         ].map((item) => (
//                           <div key={item.label} className="bg-gray-50 rounded-xl p-3">
//                             <p className="text-xs text-gray-500 uppercase tracking-wider font-medium mb-1">
//                               {item.label}
//                             </p>
//                             <p className={`font-bold text-gray-900 text-sm ${item.valueClass || ""}`}>
//                               {item.value}
//                             </p>
//                           </div>
//                         ))}
//                       </div>

//                       {orderDetails.paymentMethod === "cod" && (
//                         <div className="flex items-center gap-2 px-4 py-3 bg-orange-50 border border-orange-200 rounded-xl text-xs text-orange-700">
//                           <FiInfo size={13} className="shrink-0" />
//                           <span>₹30 delivery charge included • Pay on delivery</span>
//                         </div>
//                       )}

//                       {orderDetails.coupon && (
//                         <div className="flex items-center justify-between px-4 py-3 bg-green-50 border border-green-200 rounded-xl">
//                           <span className="flex items-center gap-2 text-sm font-semibold text-green-800">
//                             <FiTag className="text-green-600" size={14} />
//                             Coupon saved!
//                           </span>
//                           <span className="font-bold text-green-700">
//                             -₹{orderDetails.coupon.discount.toFixed(2)}
//                           </span>
//                         </div>
//                       )}

//                       <div className="text-center py-3 px-4 bg-gray-50 rounded-xl">
//                         <p className="text-xs text-gray-500">
//                           Updates sent to{" "}
//                           <span className="font-semibold text-gray-700">{formData.email}</span>
//                           {" "}and{" "}
//                           <span className="font-semibold text-gray-700">{formData.phone}</span>
//                         </p>
//                       </div>

//                       <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
//                         <button
//                           onClick={() => navigate(`/order/${orderDetails.orderId}`)}
//                           className="py-3.5 bg-gradient-to-r from-red-600 to-red-500 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-600 transition text-sm"
//                         >
//                           View Order Details
//                         </button>
//                         <button
//                           onClick={() => navigate("/products")}
//                           className="py-3.5 border-2 border-gray-200 text-gray-700 font-bold rounded-xl hover:bg-gray-50 hover:border-gray-300 transition text-sm"
//                         >
//                           Continue Shopping
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </motion.div>
//               )}
//             </AnimatePresence>
//           </div>

//           {/* ── Sidebar ── */}
//           <div className="lg:col-span-1">
//             <div
//               className="sticky top-24 flex flex-col gap-5"
//               style={{
//                 maxHeight: "calc(100vh - 7rem)",
//                 overflowY: "auto",
//                 paddingBottom: "1rem",
//                 scrollbarWidth: "none",
//                 msOverflowStyle: "none",
//               }}
//             >
//               <style>{`.sidebar-scroll::-webkit-scrollbar { display: none; }`}</style>
//               <div className="sidebar-scroll">
//                 <OrderSummary
//                   cart={sidebarCart}
//                   totals={sidebarTotals}
//                   appliedCoupon={sidebarCoupon}
//                   paymentMethod={sidebarPayment}
//                 />
//               </div>

//               {/* Account info */}
//               <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
//                 <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
//                   <FiUser className="text-red-500" size={14} /> Account
//                 </h3>
//                 <div className="space-y-1.5">
//                   {[
//                     { label: "Name", value: user?.fullName || user?.name || "—" },
//                     { label: "Email", value: user?.email || "—" },
//                     { label: "Phone", value: user?.phone || formData.phone || "—" },
//                   ].map(({ label, value }) => (
//                     <div key={label} className="flex items-center justify-between text-xs">
//                       <span className="text-gray-400">{label}</span>
//                       <span className="font-semibold text-gray-700 truncate max-w-[60%] text-right">
//                         {value}
//                       </span>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Help */}
//               <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
//                 <h3 className="text-sm font-bold text-gray-900 mb-2 flex items-center gap-2">
//                   <FiInfo className="text-red-500" size={14} /> Need Help?
//                 </h3>
//                 <div className="text-xs text-gray-500 space-y-1">
//                   <p>support@havbit.in</p>
//                   <p>+91 12345 67890</p>
//                   <p className="text-gray-400">Mon-Sat · 9 AM - 6 PM</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }



















import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  FiArrowLeft, FiCreditCard, FiUser, FiCheck, FiLoader,
  FiCheckCircle, FiXCircle, FiAlertCircle, FiLogIn, FiShoppingBag,
  FiLock, FiShield, FiPackage, FiTruck, FiInfo, FiTag, FiExternalLink,
  FiMapPin, FiPhone, FiMail, FiHome, FiHeart, FiPlus, FiChevronRight,
  FiEdit2, FiX, FiFileText,
} from "react-icons/fi";
import { FaPhoneAlt, FaRupeeSign } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";

const API_BASE_URL = "https://server.havbit.in/api";

// ─── Storage Keys ───────────────────────────────────────────────────────────
const SAVED_ADDRESS_KEY = "havbit_saved_address";
const SAVED_ALL_ADDRESSES_KEY = "havbit_all_addresses";
const SAVED_PHONE_KEY = "havbit_saved_phone";

/* ─────────────────────────────────────────────────────────
   HELPERS
───────────────────────────────────────────────────────── */
const loadRazorpayScript = () =>
  new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error("Failed to load Razorpay SDK"));
    document.body.appendChild(s);
  });

const getRazorpayPublicKey = (obj) =>
  obj?.razorpayKey || obj?.key || obj?.razorpay_key || process.env.REACT_APP_RAZORPAY_KEY_ID;

const isOid = (v) => typeof v === "string" && /^[0-9a-fA-F]{24}$/.test(v);

const extractVendorId = (obj) => {
  if (!obj) return null;
  // const candidates = [
  //   obj.vendorId,
  //   obj.vendor?._id,
  //   typeof obj.vendor === "string" ? obj.vendor : null,
  //   obj.sellerId,
  //   obj.seller?._id,
  //   typeof obj.seller === "string" ? obj.seller : null,
  // ];
  const candidates = [
  obj.vendorId,
  obj.vendor?._id,
];
  for (const v of candidates) {
    const s = v?.toString?.();
    if (isOid(s)) return s;
  }
  return null;
};

// const isPublicProduct = (item) =>
//   item.isVendorProduct === false || item.isVendorProduct === undefined || item.isVendorProduct === null;

const isPublicProduct = (item) => {
  return !(item.vendorId || item.vendor?._id);
};
const getSavedAddresses = () => {
  try {
    return JSON.parse(localStorage.getItem(SAVED_ALL_ADDRESSES_KEY) || "[]");
  } catch { return []; }
};

const saveAddressToList = (addr) => {
  try {
    const all = getSavedAddresses();
    const isDuplicate = all.some(
      (a) => a.address === addr.address && a.city === addr.city && a.pincode === addr.pincode
    );
    if (!isDuplicate) {
      all.unshift(addr);
      localStorage.setItem(SAVED_ALL_ADDRESSES_KEY, JSON.stringify(all.slice(0, 5)));
    }
  } catch {}
};

const getSavedPhone = () => {
  try { return localStorage.getItem(SAVED_PHONE_KEY) || ""; } catch { return ""; }
};
 
const savePhone = (phone) => {
  try { if (phone) localStorage.setItem(SAVED_PHONE_KEY, phone); } catch {}
};

/* ─────────────────────────────────────────────────────────
   STEP INDICATOR
───────────────────────────────────────────────────────── */
const StepIndicator = ({ current }) => {
  const steps = [
    { n: 1, label: "Address", icon: FiMapPin },
    { n: 2, label: "Payment", icon: FiCreditCard },
    { n: 3, label: "Confirmed", icon: FiCheckCircle },
  ];
  return (
    <div className="relative flex items-center justify-between mb-10 px-4">
      <div className="absolute inset-x-0 top-5 h-0.5 bg-gray-200 z-0 mx-16" />
      <div
        className="absolute top-5 left-16 h-0.5 bg-gradient-to-r from-red-500 to-red-600 z-0 transition-all duration-700"
        style={{ width: current === 1 ? "0%" : current === 2 ? "50%" : "100%", right: "4rem" }}
      />
      {steps.map(({ n, label, icon: Icon }) => (
        <div key={n} className="relative z-10 flex flex-col items-center gap-2">
          <motion.div
            initial={false}
            animate={{
              scale: current === n ? 1.1 : 1,
              backgroundColor:
                current > n ? "#16a34a" : current === n ? "#dc2626" : "#e5e7eb",
            }}
            className="w-10 h-10 rounded-full flex items-center justify-center shadow-md"
          >
            {current > n ? (
              <FiCheck className="text-white" size={18} />
            ) : (
              <Icon
                className={current === n ? "text-white" : "text-gray-400"}
                size={16}
              />
            )}
          </motion.div>
          <span
            className={`text-xs font-semibold tracking-wide ${
              current >= n ? "text-gray-800" : "text-gray-400"
            }`}
          >
            {label}
          </span>
        </div>
      ))}
    </div>
  );
};

/* ─────────────────────────────────────────────────────────
   INPUT FIELD
───────────────────────────────────────────────────────── */
const Field = ({ label, icon: Icon, error, ...props }) => (
  <div className="flex flex-col gap-1.5">
    <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
      {label}
    </label>
    <div className="relative">
      {Icon && (
        <Icon
          size={14}
          className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
        />
      )}
      <input
        {...props}
        className={`w-full ${Icon ? "pl-10" : "pl-4"} pr-4 py-3 bg-gray-50 border ${
          error ? "border-red-400" : "border-gray-200"
        } rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-transparent focus:bg-white transition-all`}
      />
    </div>
    {error && <p className="text-xs text-red-500">{error}</p>}
  </div>
);

/* ─────────────────────────────────────────────────────────
   ADDRESS SELECTOR (Swiggy-style)
───────────────────────────────────────────────────────── */
const AddressSelector = ({ savedAddresses, onSelect, onAddNew, onClose }) => (
  <AnimatePresence>
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 backdrop-blur-sm"
      onClick={onClose}
    >
      <motion.div
        initial={{ y: 80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 80, opacity: 0 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        className="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-2xl overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
          <h3 className="text-base font-bold text-gray-900">Select Address</h3>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition"
          >
            <FiX size={18} className="text-gray-500" />
          </button>
        </div>

        {/* Add New Address */}
        <button
          onClick={onAddNew}
          className="w-full flex items-center gap-3 px-5 py-4 border-b border-gray-100 hover:bg-red-50 transition group"
        >
          <div className="w-10 h-10 rounded-full border-2 border-red-500 flex items-center justify-center group-hover:bg-red-500 transition">
            <FiPlus className="text-red-500 group-hover:text-white transition" size={18} />
          </div>
          <span className="text-sm font-semibold text-red-500">Add New Address</span>
          <FiChevronRight className="ml-auto text-red-400" size={16} />
        </button>

        {/* Saved Addresses */}
        {savedAddresses.length > 0 && (
          <div className="px-5 pt-4 pb-2">
            <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">
              Saved Addresses
            </p>
            <div className="space-y-2 max-h-72 overflow-y-auto pb-2">
              {savedAddresses.map((addr, i) => (
                <button
                  key={i}
                  onClick={() => onSelect(addr)}
                  className="w-full flex items-start gap-3 p-3 rounded-xl border border-gray-100 hover:border-red-300 hover:bg-red-50 transition text-left group"
                >
                  <div className="w-9 h-9 bg-gray-100 rounded-xl flex items-center justify-center shrink-0 mt-0.5 group-hover:bg-red-100 transition">
                    <FiMapPin className="text-gray-500 group-hover:text-red-500 transition" size={15} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-800 truncate">
                      {addr.city}, {addr.state}
                    </p>
                    <p className="text-xs text-gray-500 mt-0.5 line-clamp-2">
                      {addr.address}, {addr.pincode}
                    </p>
                    {addr.phone && (
                      <p className="text-xs text-gray-400 mt-0.5">📞 {addr.phone}</p>
                    )}
                  </div>
                  {i === 0 && (
                    <span className="shrink-0 text-xs bg-green-100 text-green-700 font-semibold px-2 py-0.5 rounded-full mt-0.5">
                      Recent
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="h-6" />
      </motion.div>
    </motion.div>
  </AnimatePresence>
);

/* ─────────────────────────────────────────────────────────
   ORDER SUMMARY SIDEBAR
───────────────────────────────────────────────────────── */
const OrderSummary = ({
  cart,
  totals,
  appliedCoupon,
  paymentMethod,
  gstin,
  gstinInput,
  gstinExpanded,
  gstinError,
  gstinVerificationLoading,
  gstinVerifiedDetails,
  onShowGstTerms,
  onGstinInputChange,
  onToggleGstin,
  onSaveGstin,
  onRemoveGstin,
}) => (
  <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
    <div className="px-5 py-4 border-b border-gray-100">
      <h3 className="text-gray-900 font-bold text-base">Bill details</h3>
      <p className="text-gray-500 text-xs mt-1">{cart.length} item{cart.length !== 1 ? "s" : ""} in your order</p>
    </div>

    <div className="max-h-48 overflow-y-auto divide-y divide-gray-50">
      {cart.map((item) => (
        <div key={item._id} className="flex items-center gap-3 px-4 py-3">
          <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-100 shrink-0 border border-gray-200">
            <img
              src={item.image || item.images?.[0] || "/placeholder.png"}
              alt={item.name}
              className="w-full h-full object-cover"
              onError={(e) => { e.target.src = "/placeholder.png"; }}
            />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold text-gray-800 truncate">{item.name}</p>
            <p className="text-xs text-gray-400 mt-0.5">Qty: {item.qty || 1}</p>
          </div>
          <p className="text-xs font-bold text-gray-800 shrink-0">
            ₹{((parseFloat(item.price) || 0) * (parseInt(item.qty) || 1)).toFixed(0)}
          </p>
        </div>
      ))}
    </div>

    <div className="px-5 py-4 border-t border-gray-100 space-y-3">
      <div className="flex justify-between text-sm">
        <span className="text-gray-600">Items total</span>
        <span className="font-medium text-gray-900">₹{totals.subtotal.toFixed(2)}</span>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-gray-600">Delivery charge</span>
        <span className={`font-medium ${totals.deliveryFee === 0 ? "text-green-600" : "text-gray-900"}`}>
          {totals.deliveryFee === 0 ? "FREE" : `₹${totals.deliveryFee}`}
        </span>
      </div>

      {paymentMethod === "cod" && (
        <div className="flex items-center gap-1.5 text-xs text-orange-600 bg-orange-50 border border-orange-200 rounded-lg px-2.5 py-1.5">
          <FiInfo size={11} className="shrink-0" />
          <span>₹30 delivery charge for Cash on Delivery</span>
        </div>
      )}
      {paymentMethod === "razorpay" && (
        <div className="flex items-center gap-1.5 text-xs text-green-600 bg-green-50 border border-green-200 rounded-lg px-2.5 py-1.5">
          <FiCheckCircle size={11} className="shrink-0" />
          <span>Free delivery on online payment!</span>
        </div>
      )}

      {appliedCoupon && (
        <div className="flex justify-between text-xs border-t border-dashed border-green-200 pt-2">
          <span className="text-green-600 flex items-center gap-1">
            <FiTag size={11} /> {appliedCoupon.code}
          </span>
          <span className="font-bold text-green-600">-₹{appliedCoupon.discount.toFixed(2)}</span>
        </div>
      )}
      <div className="flex justify-between items-center border-t border-dashed border-gray-200 pt-3">
        <span className="font-bold text-gray-900">Grand total</span>
        <span className="text-xl font-extrabold text-gray-900">₹{totals.total.toFixed(2)}</span>
      </div>
    </div>

    <div className="px-4 pb-4">
      <div className="overflow-hidden rounded-2xl border border-blue-100 bg-white">
        <button
          type="button"
          onClick={onToggleGstin}
          aria-expanded={gstinExpanded}
          aria-label={gstin ? "Edit GSTIN" : "Add GSTIN"}
          className="flex w-full items-center gap-3 px-4 py-3 text-left transition hover:bg-blue-50/60"
        >
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-blue-600">
            <FiFileText size={20} />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block text-sm font-bold text-gray-900">
              {gstin ? "GSTIN verified" : "Add GSTIN"}
            </span>
            <span className="mt-0.5 block text-xs leading-5 text-gray-500">
              {gstinVerifiedDetails?.legalName || gstin || "Claim GST input credit up to 18% on your order"}
            </span>
          </span>
          <FiChevronRight
            className={`shrink-0 text-gray-400 transition-transform ${gstinExpanded ? "rotate-90" : ""}`}
            size={20}
          />
        </button>
        <p className="px-4 pb-3 text-center text-xs text-gray-500">
          By continuing, you agree to our{" "}
          <button
            type="button"
            onClick={onShowGstTerms}
            className="font-semibold text-red-600 underline underline-offset-2 transition hover:text-red-700"
          >
            Terms &amp; Conditions
          </button>
        </p>
        {gstinExpanded && (
          <div className="space-y-3 border-t border-blue-50 px-4 pb-4 pt-3">
            <label htmlFor="checkout-gstin" className="block text-xs font-semibold text-gray-700">
              GSTIN
            </label>
            <input
              id="checkout-gstin"
              type="text"
              value={gstinInput}
              onChange={(event) => onGstinInputChange(event.target.value)}
              placeholder="Enter your 15-character GSTIN"
              maxLength={15}
              autoComplete="off"
              className={`w-full rounded-xl border bg-gray-50 px-3.5 py-3 text-sm uppercase tracking-wider text-gray-900 outline-none transition placeholder:normal-case placeholder:tracking-normal focus:bg-white ${
                gstinError
                  ? "border-red-300 focus:border-red-400 focus:ring-2 focus:ring-red-100"
                  : "border-gray-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100"
              }`}
              aria-invalid={Boolean(gstinError)}
              aria-describedby={gstinError ? "checkout-gstin-error" : "checkout-gstin-help"}
            />
            {gstinError ? (
              <p id="checkout-gstin-error" className="text-xs text-red-600">{gstinError}</p>
            ) : (
              <p id="checkout-gstin-help" className="text-xs leading-5 text-gray-500">
                We’ll verify that this GSTIN is active before adding it to your order.
              </p>
            )}
            <div className="flex flex-wrap items-center justify-end gap-2">
              <button
                type="button"
                onClick={onToggleGstin}
                className="rounded-xl px-4 py-2.5 text-sm font-semibold text-gray-600 transition hover:bg-gray-100"
              >
                Cancel
              </button>
              {gstin && (
                <button
                  type="button"
                  onClick={onRemoveGstin}
                  className="rounded-xl px-3 py-2.5 text-sm font-semibold text-red-600 transition hover:bg-red-50"
                >
                  Remove
                </button>
              )}
              <button
                type="button"
                onClick={onSaveGstin}
                disabled={gstinVerificationLoading}
                className="rounded-xl bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-blue-700 disabled:cursor-wait disabled:opacity-60"
              >
                {gstinVerificationLoading
                  ? "Verifying…"
                  : gstin
                    ? "Update GSTIN"
                    : "Verify GSTIN"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>

    <div className="px-5 pb-5">
      <div className="flex items-center gap-3 text-xs text-gray-500 border-t border-gray-100 pt-4">
        <FiShield className="text-green-500 shrink-0" size={14} />
        <span>Secure checkout • Bank-level encryption</span>
      </div>
    </div>
  </div>
);

/* ─────────────────────────────────────────────────────────
   MAIN CHECKOUT COMPONENT
───────────────────────────────────────────────────────── */
export default function Checkout({ cart = [], clearCart }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated, getUserId, getToken, logout } = useAuth();

  const preSelectedPayment = location.state?.paymentMethod;

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [couponLoading, setCouponLoading] = useState(false);
  const [vendorLoading, setVendorLoading] = useState(false);

  // ── Address selector state ──
  const [showAddressSelector, setShowAddressSelector] = useState(false);
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [showAddressForm, setShowAddressForm] = useState(true);

  const [formData, setFormData] = useState({
    name: "", email: "", phone: "",
    address: "", city: "", state: "", pincode: "",
    paymentMethod: preSelectedPayment === "ONLINE" ? "razorpay" : "cod",
    weight: "0.5", length: "15", width: "10", height: "5",
  });

  const [fieldErrors, setFieldErrors] = useState({});
  const [orderDetails, setOrderDetails] = useState(null);
  const [paymentError, setPaymentError] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [backendOrderData, setBackendOrderData] = useState(null);
  const [razorpayMeta, setRazorpayMeta] = useState(null);

  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [gstinInput, setGstinInput] = useState("");
  const [gstin, setGstin] = useState("");
  const [gstinExpanded, setGstinExpanded] = useState(false);
  const [gstinError, setGstinError] = useState("");
  const [gstinVerificationLoading, setGstinVerificationLoading] = useState(false);
  const [gstinVerificationToken, setGstinVerificationToken] = useState("");
  const [gstinVerifiedDetails, setGstinVerifiedDetails] = useState(null);
  const [showGstTerms, setShowGstTerms] = useState(false);

  const gstTerms = [
    "GST invoice can be availed by adding your GST number on Havbit.",
    "GST number can be added or updated from the Cart, Profile, and Product Description pages.",
    "Ensure that the GSTIN and business name are accurate, as Havbit and the seller will not revise invoices or be held liable for any errors.",
    "Once GST details are saved, they will remain stored for future orders.",
    "A GST invoice will be issued once the order is delivered.",
    "The GST invoice will be billed to the address where the GST is registered.",
    "A GST invoice will not be issued if the shipping address differs from the state in which the GST number is registered.",
    "A GST invoice will not be issued if the GST number has expired.",
    "Eligible products will receive a GST invoice, which includes the GSTIN, business entity name, billing address, and IRN number.",
    "Not all products are eligible for a GST invoice; a bill of supply will be generated for ineligible items.",
    "In case of refunds, a positive credit note will be issued on the GST portal for the refund amount.",
  ];

  const handleGstinInputChange = (value) => {
    const normalizedValue = value.toUpperCase().replace(/\s/g, "").slice(0, 15);
    setGstinInput(normalizedValue);
    setGstinError("");
    if (normalizedValue !== gstin) {
      setGstin("");
      setGstinVerificationToken("");
      setGstinVerifiedDetails(null);
    }
  };

  const handleSaveGstin = async () => {
    const normalizedGstin = gstinInput.trim().toUpperCase();
    const gstinPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
    if (!gstinPattern.test(normalizedGstin)) {
      setGstinError("Enter a valid 15-character GSTIN.");
      return;
    }
    setGstinVerificationLoading(true);
    setGstinError("");
    try {
      const token = getToken();
      if (!token) throw new Error("Please log in again to verify your GSTIN.");

      const response = await fetch(`${API_BASE_URL}/parcelx/verify-gstin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ gstin: normalizedGstin }),
      });
      const result = await response.json();
      if (response.status === 401 || result.tokenExpired) {
        await logout();
        alert("Your session has expired. Please log in again to verify your GSTIN.");
        navigate("/login", { state: { from: "/checkout" } });
        return;
      }
      if (!response.ok || !result.success || !result.verificationToken) {
        throw new Error(result.message || "GSTIN verification failed.");
      }

      setGstin(result.gstin);
      setGstinInput(result.gstin);
      setGstinVerificationToken(result.verificationToken);
      setGstinVerifiedDetails({
        legalName: result.legalName,
        tradeName: result.tradeName,
      });
      setGstinExpanded(false);
    } catch (error) {
      setGstinError(error.message || "Unable to verify GSTIN. Please try again.");
    } finally {
      setGstinVerificationLoading(false);
    }
  };

  const handleRemoveGstin = () => {
    setGstin("");
    setGstinInput("");
    setGstinError("");
    setGstinVerificationToken("");
    setGstinVerifiedDetails(null);
    setGstinExpanded(false);
  };

  const [resolvedVendorId, setResolvedVendorId] = useState(null);
  const [resolvedWarehouseId, setResolvedWarehouseId] = useState(null);
  const [vendorError, setVendorError] = useState("");

  const [confirmedCart, setConfirmedCart] = useState([]);
  const [confirmedTotals, setConfirmedTotals] = useState(null);
  const [confirmedPaymentMethod, setConfirmedPaymentMethod] = useState(null);
  const [confirmedCoupon, setConfirmedCoupon] = useState(null);

  const allCartItemsPublic = cart.every((item) => isPublicProduct(item));

  const calculateTotals = () => {
    const subtotal = cart.reduce(
      (s, i) => s + (parseFloat(i.price) || 0) * (parseInt(i.qty) || 1),
      0
    );
    const deliveryFee = formData.paymentMethod === "cod" ? 30 : 0;
    const handlingFee = 0;
    const smallCartFee = 0;
    const platformFee = 0;
    const totalBeforeDiscount = subtotal + deliveryFee + platformFee;
    const total = Math.max(0, totalBeforeDiscount - couponDiscount);
    return {
      subtotal: +subtotal.toFixed(2),
      deliveryFee: +deliveryFee.toFixed(2),
      handlingFee: +handlingFee.toFixed(2),
      smallCartFee: +smallCartFee.toFixed(2),
      platformFee: +platformFee.toFixed(2),
      totalBeforeDiscount: +totalBeforeDiscount.toFixed(2),
      couponDiscount: +couponDiscount.toFixed(2),
      total: +total.toFixed(2),
    };
  };
  const totals = calculateTotals();

  const resolveVendorAndWarehouse = useCallback(async () => {
    if (cart.length === 0 || allCartItemsPublic) return;
    setVendorLoading(true);
    setVendorError("");
    try {
      const token = getToken();
      if (!token) { setVendorError("Please login to continue."); return; }
      const res = await fetch(`${API_BASE_URL}/parcelx/warehouse`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (!data.success || !data.warehouses?.length) {
        setVendorError("No warehouse configured for this vendor.");
        return;
      }
      setResolvedWarehouseId(data.warehouses[0]._id);
      setResolvedVendorId(data.warehouses[0].vendorId);
    } catch (e) {
      setVendorError("Failed to load shipping info: " + e.message);
    } finally {
      setVendorLoading(false);
    }
  }, [cart, getToken, allCartItemsPublic]);

  useEffect(() => {
    if (isAuthenticated && cart.length > 0) resolveVendorAndWarehouse();
  }, [isAuthenticated, resolveVendorAndWarehouse]);

  useEffect(() => {
    if (!isAuthenticated) navigate("/login", { state: { from: "/checkout" } });
  }, [isAuthenticated, navigate]);

  // ── On mount: load saved addresses ──
  // ✅ KEY CHANGE: Agar saved addresses hain → directly selector dikhao
  //    User jab koi address select kare → Step 2 pe jaao (form skip)
  //    "Add New Address" click kare → form dikhao
  useEffect(() => {
    const addresses = getSavedAddresses();
    setSavedAddresses(addresses);

    if (addresses.length > 0) {
      // Saved addresses hain → selector dikhao, form mat dikhao
      setShowAddressForm(false);
      setShowAddressSelector(true);
    } else {
      // Pehli baar → directly form dikhao
      setShowAddressForm(true);
      setShowAddressSelector(false);
    }
  }, []);

  // ── Auto-fill: user profile + saved phone ──
  useEffect(() => {
    if (!user) return;
    const savedPhone = getSavedPhone();
    setFormData((p) => ({
      ...p,
      name:  user.fullName || user.name  || p.name,
      email: user.email                  || p.email,
      phone: savedPhone || user.phone    || p.phone,
    }));
  }, [user]);

  // ✅ KEY CHANGE: Saved address select karo → form fill karo + DIRECTLY STEP 2 PE JAO
  const handleSelectSavedAddress = async (addr) => {
    // Form data fill karo
    setFormData((p) => ({
      ...p,
      address: addr.address || p.address,
      city:    addr.city    || p.city,
      state:   addr.state   || p.state,
      pincode: addr.pincode || p.pincode,
      phone:   addr.phone   || p.phone,
    }));

    // Selector band karo
    setShowAddressSelector(false);
    setShowAddressForm(false); // form bhi mat dikhao

    // Razorpay preload (agar online payment selected hai)
    if (formData.paymentMethod === "razorpay") {
      try { await loadRazorpayScript(); } catch { /* ignore */ }
    }

    // ✅ Directly Step 2 pe jump karo
    setStep(2);
  };

  // "Add New Address" → form dikhao (blank)
  const handleAddNewAddress = () => {
    setFormData((p) => ({
      ...p,
      address: "", city: "", state: "", pincode: "",
    }));
    setShowAddressSelector(false);
    setShowAddressForm(true);
  };

  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) return setCouponError("Please enter a coupon code");
    setCouponLoading(true); setCouponError("");
    try {
      const token = getToken();
      const res = await fetch(`${API_BASE_URL}/coupons/apply`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ code: couponCode.toUpperCase(), orderAmount: totals.totalBeforeDiscount }),
      });
      const data = await res.json();
      if (!data.success) return setCouponError(data.message || "Invalid coupon");
      setAppliedCoupon({ code: couponCode.toUpperCase(), discount: data.discount });
      setCouponDiscount(data.discount);
    } catch (e) {
      setCouponError(e.message || "Failed to apply coupon");
    } finally { setCouponLoading(false); }
  };

  const handleRemoveCoupon = () => {
    setAppliedCoupon(null); setCouponDiscount(0); setCouponCode(""); setCouponError("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
    if (fieldErrors[name]) setFieldErrors((p) => ({ ...p, [name]: "" }));
  };

  const validateForm = () => {
    const { name, email, phone, address, city, state, pincode } = formData;
    const errors = {};
    if (!name.trim() || name.trim().length < 2) errors.name = "Enter your full name";
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "Enter a valid email";
    if (!phone.trim() || !/^[6-9]\d{9}$/.test(phone)) errors.phone = "Valid 10-digit Indian mobile required";
    if (!address.trim() || address.trim().length < 10) errors.address = "Complete address required (min 10 chars)";
    if (!city.trim()) errors.city = "Enter your city";
    if (!state.trim()) errors.state = "Enter your state";
    if (!pincode.trim() || !/^\d{6}$/.test(pincode)) errors.pincode = "Valid 6-digit pincode required";
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // ── Step 1 form se aage jaana (manually typed address) ──
  const handleProceedToPayment = async () => {
    if (!validateForm()) return;

    savePhone(formData.phone);

    const addressEntry = {
      address: formData.address,
      city:    formData.city,
      state:   formData.state,
      pincode: formData.pincode,
      phone:   formData.phone,
    };
    saveAddressToList(addressEntry);

    try {
      localStorage.setItem(SAVED_ADDRESS_KEY, JSON.stringify(addressEntry));
    } catch {}

    setSavedAddresses(getSavedAddresses());

    if (formData.paymentMethod === "razorpay") {
      try { await loadRazorpayScript(); } catch { return alert("Failed to load payment gateway. Try again."); }
    }
    setStep(2);
  };

  const saveOrderToStorage = (order) => {
    try {
      const all = JSON.parse(localStorage.getItem("user_orders") || "[]");
      const idx = all.findIndex((o) => o._id === order._id);
      if (idx === -1) all.unshift(order);
      else all[idx] = order;
      localStorage.setItem("user_orders", JSON.stringify(all.slice(0, 50)));
    } catch (e) { console.error("Storage error:", e); }
  };

  const createParcelxOrder = async () => {
    const token = getToken();
    if (!token) throw new Error("Please login again.");
    const customerId = getUserId();
    if (!customerId) throw new Error("User ID missing — please login again.");

    let vendorId = null;
    let warehouseId = null;

    if (!allCartItemsPublic) {
      vendorId = resolvedVendorId;
      if (!vendorId) {
        for (const item of cart) {
          if (!isPublicProduct(item)) {
            vendorId = extractVendorId(item);
            if (vendorId) break;
          }
        }
      }
      if (!vendorId) {
        for (const item of cart) {
          if (isPublicProduct(item)) continue;
          const productId = item._id || item.productId;
          if (!isOid(productId)) continue;
          try {
            const res = await fetch(`${API_BASE_URL}/products/${productId}`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            const data = await res.json();
            vendorId = extractVendorId(data.product || data.data || data);
            if (vendorId) break;
          } catch (e) { /* continue */ }
        }
      }
      // if (!vendorId) throw new Error("Vendor information not found. Please go back and re-add vendor items to cart.");
      if (!allCartItemsPublic && !vendorId) {
  throw new Error("Vendor information not found. Please re-add vendor items.");
}

      warehouseId = resolvedWarehouseId;
      if (!warehouseId) {
        const wRes = await fetch(`${API_BASE_URL}/parcelx/warehouse`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const wData = await wRes.json();
        if (wData.success && wData.warehouses?.length > 0) {
          warehouseId = wData.warehouses[0]._id;
          setResolvedWarehouseId(warehouseId);
        } else {
          throw new Error("Warehouse not found for this vendor. Please contact support.");
        }
      }
      if (!warehouseId) throw new Error("Warehouse not found for this vendor. Please contact support.");
    }

   const orderItems = cart.map((item) => {

  let pId =
    item._id ||
    item.productId;

  if (!isOid(pId))
    pId =
      "000000000000000000000001";

  const itemVendorId =
    item.vendorId ||
    item.vendor?._id ||
    resolvedVendorId ||
    vendorId ||
    null;

  return {
    productId: pId,

    productName:
      item.name ||
      item.productName ||
      "Product",

    price:
      parseFloat(item.price) || 0,

    qty:
      parseInt(item.qty) || 1,

    vendorId:
      itemVendorId,
  };
});

    const totalWeight = Math.max(
      cart.reduce((s, i) => s + (parseFloat(i.weight) || 0.5) * (parseInt(i.qty) || 1), 0),
      0.1
    ).toFixed(2);
    const userId = getUserId();

if (!userId) {
  alert("User not logged in properly");
  return;
}
    const payload = {
      customer: userId, 
      // vendorId: vendorId || null,
      vendorId:
  allCartItemsPublic
    ? null
    : vendorId,
      warehouseId: warehouseId || null,
      isPublicOrder: allCartItemsPublic,

      orderItems,
      amount: totals.total,
      gstin,
      gstinVerificationToken,
      couponCode: appliedCoupon?.code || null,
      couponDiscount,
      subtotal: totals.subtotal,
      deliveryFee: totals.deliveryFee,
      platformFee: totals.platformFee,
      gst: totals.gst,
      paymentMethod: formData.paymentMethod,
      shippingAddress: {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        pincode: formData.pincode,
      },
      shipment: {
        weight: parseFloat(formData.weight) || parseFloat(totalWeight),
        length: parseFloat(formData.length) || 15,
        width: parseFloat(formData.width) || 10,
        height: parseFloat(formData.height) || 5,
      },
    };

    const res = await fetch(`${API_BASE_URL}/parcelx/order`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
    const json = await res.json();
    if (!res.ok || !json.success) {
      const errMsg = json.parcelxError || json.parcelx?.message || json.message || "Failed to create order";
      throw new Error(errMsg);
    }
    return json.order;
  };

  // const createRazorpayOrderFromBackend = async (orderId) => {
  //   const token = getToken();
  //   const res = await fetch(`${API_BASE_URL}/razorpay/create-order`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  //     body: JSON.stringify({ orderId, amount: Math.round(totals.total * 100), currency: "INR" }),
  //   });
  //   const json = await res.json();
  //   if (!res.ok || !json.success) throw new Error(json.message || "Failed to init payment");
  //   return { razorpayOrderId: json.razorpayOrderId, amount: Math.round(totals.total * 100), currency: json.currency || "INR", key: json.key };
  // };

  const createRazorpayOrderFromBackend = async (orderId) => {
  const token = getToken();

  const res = await fetch(`${API_BASE_URL}/razorpay/create-order`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ orderId }), // ✅ सिर्फ orderId — backend खुद calculate करता है
  });

  const json = await res.json();

  if (!res.ok || !json.success) {
    throw new Error(json.message || "Failed to init payment");
  }

  return {
    razorpayOrderId: json.razorpayOrderId,
    amount: json.amount,                 
    currency: json.currency || "INR",
    key: json.key,
  };
};

  const verifyRazorpayPayment = async (payload) => {
    const token = getToken();
    const res = await fetch(`${API_BASE_URL}/razorpay/verify-payment`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
    return res.json();
  };

  const initiateRazorpayPayment = async (order) => {
    setPaymentLoading(true); setPaymentError(null);
    try {
      if (!window.Razorpay) await loadRazorpayScript();
      const razorpayKey = getRazorpayPublicKey(razorpayMeta);
      if (!razorpayKey) throw new Error("Razorpay key missing");
      // const rp = new window.Razorpay({
      //   key: razorpayKey,
      //   amount: Math.round(totals.total * 100),
      //   currency: razorpayMeta?.currency || "INR",
      //   name: "HAVBIT",
      //   description: `Order #${order._id?.slice(-8).toUpperCase()}`,
      //   image: "/logo.png",
      //   order_id: razorpayMeta?.razorpayOrderId,
      //   handler: async (response) => {
      //     const v = await verifyRazorpayPayment({
      //       orderId: order._id,
      //       razorpay_payment_id: response.razorpay_payment_id,
      //       razorpay_order_id: response.razorpay_order_id,
      //       razorpay_signature: response.razorpay_signature,
      //     });
      //     if (v.success) {
      //       const updated = { ...order, paymentStatus: "Success", orderStatus: "Confirmed", razorpayPaymentId: response.razorpay_payment_id };
      //       saveOrderToStorage(updated);
      //       setConfirmedCart([...cart]);
      //       setConfirmedTotals({ ...totals });
      //       setConfirmedPaymentMethod(formData.paymentMethod);
      //       setConfirmedCoupon(appliedCoupon ? { ...appliedCoupon } : null);
      //       setOrderDetails({
      //         orderId: updated._id, paymentMethod: "razorpay",
      //         amount: totals.total, orderStatus: "Confirmed", paymentStatus: "Success",
      //         razorpayPaymentId: updated.razorpayPaymentId,
      //         coupon: appliedCoupon, awb: order.parcelx?.awb,
      //         courier: order.parcelx?.courier, trackingUrl: order.parcelx?.tracking_url,
      //       });
      //       setPaymentSuccess(true); setStep(3);
      //       if (clearCart) { clearCart(); localStorage.removeItem("cart"); }
      //     } else {
      //       setPaymentError(v.message || "Verification failed");
      //     }
      //   },
      //   prefill: { name: formData.name, email: formData.email, contact: formData.phone },
      //   notes: { orderId: order._id },
      //   theme: { color: "#dc2626" },
      //   modal: { ondismiss: () => { setPaymentError("Payment cancelled"); setPaymentLoading(false); } },
      // });
      const rp = new window.Razorpay({

  key: razorpayKey,

  amount: Math.round(
    totals.total * 100
  ),

  currency:
    razorpayMeta?.currency ||
    "INR",

  name: "HAVBIT",

  description:
    `Order #${order._id
      ?.slice(-8)
      .toUpperCase()}`,

  image: "/logo.png",

  order_id:
    razorpayMeta?.razorpayOrderId,

  handler: async (
    response
  ) => {

    try {

      console.log(
        "RAZORPAY RESPONSE:",
        response
      );

      /* ===============================
         VALIDATION
      ============================== */

      if (

        !response?.razorpay_payment_id ||

        !response?.razorpay_order_id ||

        !response?.razorpay_signature

      ) {

        setPaymentError(
          "Missing payment fields"
        );

        setPaymentLoading(
          false
        );

        return;
      }

      /* ===============================
         VERIFY PAYMENT
      ============================== */

      const v =
        await verifyRazorpayPayment({

          orderId:
            order._id,

          razorpay_payment_id:
            response.razorpay_payment_id,

          razorpay_order_id:
            response.razorpay_order_id,

          razorpay_signature:
            response.razorpay_signature,
        });

      console.log(
        "VERIFY RESPONSE:",
        v
      );

      /* ===============================
         SUCCESS
      ============================== */

      if (v.success) {

        const updated = {

          ...order,

          paymentStatus:
            "Success",

          orderStatus:
            "Confirmed",

          razorpayPaymentId:
            response.razorpay_payment_id,
        };

        /* SAVE ORDER */

        saveOrderToStorage(
          updated
        );

        /* SAVE CONFIRMED DATA */

        setConfirmedCart([
          ...cart
        ]);

        setConfirmedTotals({
          ...totals
        });

        setConfirmedPaymentMethod(
          formData.paymentMethod
        );

        setConfirmedCoupon(

          appliedCoupon

            ? {
                ...appliedCoupon,
              }

            : null
        );

        /* ORDER DETAILS */

        setOrderDetails({

          orderId:
            updated._id,

          paymentMethod:
            "razorpay",

          amount:
            totals.total,

          orderStatus:
            "Confirmed",

          paymentStatus:
            "Success",

          razorpayPaymentId:
            updated.razorpayPaymentId,

          coupon:
            appliedCoupon,

          awb:
            order.parcelx?.awb,

          courier:
            order.parcelx?.courier,

          trackingUrl:
            order.parcelx?.tracking_url,
        });

        /* SUCCESS UI */

        setPaymentSuccess(
          true
        );

        setPaymentError("");

        setStep(3);

        /* CLEAR CART */

        if (clearCart) {

          clearCart();

          localStorage.removeItem(
            "cart"
          );
        }

      } else {

        setPaymentError(

          v.message ||

          "Verification failed"
        );
      }

    } catch (err) {

      console.log(
        "RAZORPAY VERIFY ERROR:",
        err
      );

      setPaymentError(

        err?.response?.data
          ?.message ||

        err.message ||

        "Payment verification failed"
      );

    } finally {

      setPaymentLoading(
        false
      );
    }
  },

  prefill: {

    name:
      formData.name,

    email:
      formData.email,

    contact:
      formData.phone,
  },

  notes: {

    orderId:
      order._id,
  },

  theme: {

    color:
      "#dc2626",
  },

  modal: {

    ondismiss: () => {

      setPaymentError(
        "Payment cancelled"
      );

      setPaymentLoading(
        false
      );
    },
  },
});
      rp.open();
      rp.on("payment.failed", (r) => {
        setPaymentError(r.error?.description || "Payment failed"); setPaymentLoading(false);
      });
    } catch (err) {
      setPaymentError(err.message); setPaymentLoading(false);
    }
  };

  const handleCreateOrder = async () => {
    if (!validateForm()) return;
    setLoading(true);
    setPaymentError(null);
    try {
      const createdOrder = await createParcelxOrder();
      setBackendOrderData(createdOrder);
      saveOrderToStorage(createdOrder);

      if (formData.paymentMethod === "razorpay") {
        const rpMeta = await createRazorpayOrderFromBackend(createdOrder._id);
        setRazorpayMeta(rpMeta);
      } else {
        const updatedOrder = {
          ...createdOrder,
          paymentStatus: "Pending",
          orderStatus: "Confirmed",
        };
        saveOrderToStorage(updatedOrder);
        setConfirmedCart([...cart]);
        setConfirmedTotals({ ...totals });
        setConfirmedPaymentMethod(formData.paymentMethod);
        setConfirmedCoupon(appliedCoupon ? { ...appliedCoupon } : null);
        setOrderDetails({
          orderId: updatedOrder._id,
          paymentMethod: "cod",
          amount: totals.total,
          orderStatus: "Confirmed",
          paymentStatus: "Pending",
          coupon: appliedCoupon,
          awb: updatedOrder.parcelx?.awb,
          courier: updatedOrder.parcelx?.courier,
          trackingUrl: updatedOrder.parcelx?.tracking_url,
        });
        setPaymentSuccess(true);
        setStep(3);
        if (clearCart) {
          clearCart();
          localStorage.removeItem("cart");
        }
      }
    } catch (e) {
      setPaymentError(e.message);
      if (/expired|invalid|session/i.test(e.message)) {
        alert("Session expired — please login again.");
        navigate("/login", { state: { from: "/checkout" } });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    if (step === 3) navigate("/orders");
    else if (step === 2) {
      // Step 2 se wapas → agar saved addresses hain to selector dikhao, warna form
      setBackendOrderData(null);
      setRazorpayMeta(null);
      setPaymentError(null);
      if (savedAddresses.length > 0) {
        setShowAddressForm(false);
        setShowAddressSelector(true);
        setStep(1);
      } else {
        setShowAddressForm(true);
        setStep(1);
      }
    } else {
      navigate("/cart");
    }
  };

  /* ─────────────── GUARDS ─────────────── */
  if (!isAuthenticated) return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <FiLogIn className="text-red-600" size={24} />
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">Login Required</h2>
        <p className="text-gray-500 text-sm mb-6">Please login to place an order</p>
        <button
          onClick={() => navigate("/login", { state: { from: "/checkout" } })}
          className="px-6 py-3 bg-red-600 text-white rounded-xl font-semibold hover:bg-red-700 transition"
        >
          Login Now
        </button>
      </div>
    </div>
  );

  if (cart.length === 0 && step !== 3) return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <FiShoppingBag className="text-red-600" size={24} />
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">Cart is Empty</h2>
        <p className="text-gray-500 text-sm mb-6">Add products before checking out</p>
        <button
          onClick={() => navigate("/products")}
          className="px-6 py-3 bg-red-600 text-white rounded-xl font-semibold hover:bg-red-700 transition"
        >
          Shop Now
        </button>
      </div>
    </div>
  );

  const sidebarCart    = step === 3 && confirmedCart.length > 0 ? confirmedCart : cart;
  const sidebarTotals  = step === 3 && confirmedTotals          ? confirmedTotals : totals;
  const sidebarPayment = step === 3 && confirmedPaymentMethod   ? confirmedPaymentMethod : formData.paymentMethod;
  const sidebarCoupon  = step === 3                             ? confirmedCoupon : appliedCoupon;

  /* ─────────────── RENDER ─────────────── */
  return (
    <div className="min-h-screen bg-gray-50">

      {/* ── Address Selector Modal ── */}
      {showAddressSelector && (
        <AddressSelector
          savedAddresses={savedAddresses}
          onSelect={handleSelectSavedAddress}
          onAddNew={handleAddNewAddress}
          onClose={() => {
            // Agar close kiya bina select kiye → form dikhao
            setShowAddressSelector(false);
            setShowAddressForm(true);
          }}
        />
      )}

      {showGstTerms && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4"
          role="presentation"
          onClick={() => setShowGstTerms(false)}
        >
          <motion.section
            initial={{ opacity: 0, y: 16, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="gst-terms-title"
            className="flex max-h-[85vh] w-full max-w-xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
              <h2 id="gst-terms-title" className="text-lg font-bold text-gray-900">
                Terms &amp; Conditions
              </h2>
              <button
                type="button"
                onClick={() => setShowGstTerms(false)}
                aria-label="Close Terms & Conditions"
                className="flex h-9 w-9 items-center justify-center rounded-full text-gray-500 transition hover:bg-gray-100 hover:text-gray-900"
              >
                <FiX size={19} />
              </button>
            </div>
            <ul className="list-disc space-y-3 overflow-y-auto px-6 py-5 pl-10 text-sm leading-6 text-gray-700">
              {gstTerms.map((term) => <li key={term}>{term}</li>)}
            </ul>
          </motion.section>
        </div>
      )}

      {/* ── Top Bar ── */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-30 shadow-sm">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <button
            onClick={handleBack}
            className="flex items-center gap-2 text-gray-500 hover:text-red-600 transition-colors text-sm font-medium"
          >
            <FiArrowLeft size={16} />
            <span className="hidden sm:inline">
              {step === 3 ? "View Orders" : step === 2 ? "Back to Address" : "Back to Cart"}
            </span>
          </button>

          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-red-600 rounded-lg flex items-center justify-center">
              <FiShoppingBag className="text-white" size={14} />
            </div>
            <span className="font-bold text-gray-900 text-sm hidden sm:inline">Checkout</span>
          </div>

          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
              <FiUser className="text-gray-600" size={14} />
            </div>
            <span className="text-sm font-medium text-gray-700 hidden sm:block">
              {user?.fullName?.split(" ")[0] || user?.name?.split(" ")[0] || "User"}
            </span>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          {/* ── Main Panel ── */}
          <div className="lg:col-span-2">
            <StepIndicator current={step} />

            {vendorLoading && !allCartItemsPublic && (
              <motion.div
                initial={{ opacity: 0, y: -8 }}
                animate={{ opacity: 1, y: 0 }}
                className="mb-5 flex items-center gap-3 px-4 py-3 bg-blue-50 border border-blue-200 rounded-xl text-sm text-blue-700"
              >
                <FiLoader className="animate-spin shrink-0" size={15} />
                <span>Setting up shipping configuration...</span>
              </motion.div>
            )}

            {vendorError && !vendorLoading && !allCartItemsPublic && (
              <motion.div
                initial={{ opacity: 0, y: -8 }}
                animate={{ opacity: 1, y: 0 }}
                    className="mb-5 flex items-start gap-3 px-4 py-3 bg-amber-50 border border-amber-300 rounded-xl"
              >
                <FiAlertCircle className="text-amber-500 shrink-0 mt-0.5" size={15} />
                <div className="flex-1">
                  <p className="text-sm font-semibold text-amber-800">Shipping Setup Issue</p>
                  <p className="text-xs text-amber-700 mt-0.5">{vendorError}</p>
                  <button
                    onClick={resolveVendorAndWarehouse}
                    className="mt-1.5 text-xs text-blue-600 underline hover:text-blue-700"
                  >
                    Retry →
                  </button>
                </div>
              </motion.div>
            )}

            {paymentError && (
              <motion.div
                initial={{ opacity: 0, y: -8 }}
                animate={{ opacity: 1, y: 0 }}
                className="mb-5 flex items-center gap-3 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-sm text-red-700"
              >
                <FiXCircle className="shrink-0" size={15} />
                <span>{paymentError}</span>
              </motion.div>
            )}

            <AnimatePresence mode="wait">

              {/* ══════ STEP 1 – ADDRESS FORM ══════ */}
              {step === 1 && showAddressForm && (
                <motion.div
                  key="step1-form"
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                  transition={{ duration: 0.25 }}
                >
                  <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
                    <div className="px-6 pt-6 pb-4 border-b border-gray-100">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                            <FiMapPin className="text-red-500" size={18} />
                            Delivery Address
                          </h2>
                          <p className="text-xs text-gray-500 mt-1">Where should we send your order?</p>
                        </div>

                        {/* Change Address button — only if saved addresses exist */}
                        {savedAddresses.length > 0 && (
                          <button
                            onClick={() => {
                              setShowAddressForm(false);
                              setShowAddressSelector(true);
                            }}
                            className="flex items-center gap-1.5 text-xs font-semibold text-red-600 border border-red-200 bg-red-50 hover:bg-red-100 px-3 py-1.5 rounded-xl transition"
                          >
                            <FiEdit2 size={11} />
                            Change
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-5">
                      <Field label="Full Name" icon={FiUser} name="name" type="text"
                        placeholder="Your full name" value={formData.name}
                        onChange={handleChange} error={fieldErrors.name} />
                      <Field label="Email" icon={FiMail} name="email" type="email"
                        placeholder="email@example.com" value={formData.email}
                        onChange={handleChange} error={fieldErrors.email} />
                      <Field label="Phone" icon={FiPhone} name="phone" type="tel"
                        placeholder="10-digit mobile number" value={formData.phone}
                        onChange={handleChange} error={fieldErrors.phone} />
                      <Field label="Pincode" icon={FiMapPin} name="pincode" type="text"
                        placeholder="6-digit pincode" maxLength={6} value={formData.pincode}
                        onChange={handleChange} error={fieldErrors.pincode} />

                      <div className="sm:col-span-2 flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          Complete Address
                        </label>
                        <div className="relative">
                          <FiHome size={14} className="absolute left-3.5 top-3.5 text-gray-400 pointer-events-none" />
                          <textarea
                            name="address"
                            rows={3}
                            value={formData.address}
                            onChange={handleChange}
                            placeholder="House no., Building, Street, Area, Landmark..."
                            className={`w-full pl-10 pr-4 py-3 bg-gray-50 border ${
                              fieldErrors.address ? "border-red-400" : "border-gray-200"
                            } rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-400 focus:bg-white transition-all resize-none`}
                          />
                        </div>
                        {fieldErrors.address && <p className="text-xs text-red-500">{fieldErrors.address}</p>}
                      </div>

                      <Field label="City" icon={FiMapPin} name="city" type="text"
                        placeholder="Your city" value={formData.city}
                        onChange={handleChange} error={fieldErrors.city} />
                      <Field label="State" icon={FiMapPin} name="state" type="text"
                        placeholder="Your state" value={formData.state}
                        onChange={handleChange} error={fieldErrors.state} />
                    </div>

                    {/* Dimensions */}
                    <div className="px-6 pb-4">
                      <details className="group">
                        <summary className="cursor-pointer text-xs font-semibold text-blue-600 flex items-center gap-1.5 select-none list-none">
                          <FiPackage size={13} />
                          <span>Advanced: Shipment Dimensions</span>
                        </summary>
                        <div className="mt-3 p-4 bg-blue-50 border border-blue-200 rounded-xl">
                          <p className="text-xs text-blue-700 mb-3">
                            Used by ParcelX for rate calculation. Defaults are pre-filled.
                          </p>
                          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                            {[
                              { label: "Weight (kg)", name: "weight" },
                              { label: "Length (cm)", name: "length" },
                              { label: "Width (cm)", name: "width" },
                              { label: "Height (cm)", name: "height" },
                            ].map((f) => (
                              <div key={f.name}>
                                <label className="block text-xs font-medium text-blue-800 mb-1">{f.label}</label>
                                <input
                                  type="number"
                                  name={f.name}
                                  value={formData[f.name]}
                                  onChange={handleChange}
                                  step="0.1"
                                  min="0.1"
                                  className="w-full px-3 py-2 bg-white border border-blue-200 rounded-lg text-xs focus:outline-none focus:ring-1 focus:ring-blue-400"
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </details>
                    </div>

                    {/* Shipping strip */}
                    <div className="mx-6 mb-6 flex items-center justify-between px-4 py-3 bg-gradient-to-r from-red-50 to-orange-50 border border-red-100 rounded-xl">
                      <div className="flex items-center gap-2">
                        <FiTruck className="text-red-500 shrink-0" size={15} />
                        <span className="text-xs font-semibold text-gray-700">
                          Shipped 3-5 working days
                        </span>
                      </div>
                      <div className="text-xs">
                        {allCartItemsPublic ? (
                          <span className="text-green-600 flex items-center gap-1 font-medium">
                            <FiCheckCircle size={11} /> Auto-configured
                          </span>
                        ) : vendorLoading ? (
                          <span className="text-blue-500 flex items-center gap-1">
                            <FiLoader className="animate-spin" size={11} /> Loading...
                          </span>
                        ) : resolvedWarehouseId ? (
                          <span className="text-green-600 flex items-center gap-1 font-medium">
                            <FiCheckCircle size={11} /> Ready
                          </span>
                        ) : (
                          <span className="text-amber-600 flex items-center gap-1">
                            <FiAlertCircle size={11} /> Pending
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="px-6 pb-6">
                      <button
                        onClick={handleProceedToPayment}
                        className="w-full py-3.5 bg-gradient-to-r from-red-600 to-red-500 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-600 transition-all shadow-lg shadow-red-200 flex items-center justify-center gap-2 text-sm"
                      >
                        <FiCreditCard size={16} />
                        Proceed to Payment
                      </button>
                    </div>
                  </div>
                </motion.div>
              )}

              {/* ══════ STEP 1 – Loading state (selector open hai, form nahi) ══════ */}
              {step === 1 && !showAddressForm && !showAddressSelector && (
                <motion.div
                  key="step1-loading"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="flex items-center justify-center py-20"
                >
                  <FiLoader className="animate-spin text-red-500" size={28} />
                </motion.div>
              )}

              {/* ══════ STEP 2 – PAYMENT ══════ */}
              {step === 2 && (
                <motion.div
                  key="step2"
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                  transition={{ duration: 0.25 }}
                >
                  <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">

                    {/* ✅ Selected Address Preview Card (Step 2 pe dikhao) */}
                    <div className="px-6 pt-5 pb-4 border-b border-gray-100">
                      <div className="flex items-start justify-between gap-3">
                        <div className="flex items-start gap-3">
                          <div className="w-9 h-9 bg-green-100 rounded-xl flex items-center justify-center shrink-0 mt-0.5">
                            <FiMapPin className="text-green-600" size={15} />
                          </div>
                          <div>
                            <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-0.5">
                              Delivering to
                            </p>
                            <p className="text-sm font-bold text-gray-900">{formData.name}</p>
                            <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">
                              {formData.address && `${formData.address}, `}{formData.city}
                              {formData.state && `, ${formData.state}`}
                              {formData.pincode && ` - ${formData.pincode}`}
                            </p>
                            {formData.phone && (
                              <p className="text-xs text-gray-400 mt-0.5">📞 {formData.phone}</p>
                            )}
                          </div>
                        </div>
                        {/* Edit Address button */}
                        <button
                          onClick={() => {
                            setBackendOrderData(null);
                            setRazorpayMeta(null);
                            setPaymentError(null);
                            if (savedAddresses.length > 0) {
                              setShowAddressForm(false);
                              setShowAddressSelector(true);
                            } else {
                              setShowAddressForm(true);
                            }
                            setStep(1);
                          }}
                          className="shrink-0 flex items-center gap-1.5 text-xs font-semibold text-red-600 border border-red-200 bg-red-50 hover:bg-red-100 px-3 py-1.5 rounded-xl transition"
                        >
                          <FiEdit2 size={11} />
                          Change
                        </button>
                      </div>
                    </div>

                    <div className="px-6 pt-6 pb-4 border-b border-gray-100">
                      <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                        <FiCreditCard className="text-red-500" size={18} />
                        Payment Method
                      </h2>
                      <p className="text-xs text-gray-500 mt-1">How would you like to pay?</p>
                    </div>

                    <div className="p-6 space-y-3">
                      {[
                        {
                          value: "cod",
                          label: "Cash on Delivery",
                          sub: "Pay when your order arrives",
                          badge: "Most Popular",
                          icon: <FaPhoneAlt className="text-green-600" size={18} />,
                          badgeColor: "bg-green-100 text-green-700",
                          activeColor: "border-green-400 bg-green-50",
                          deliveryNote: (
                            <span className="text-xs text-orange-600 flex items-center gap-1 mt-1">
                              <FiInfo size={11} /> ₹30 delivery charge applies for COD
                            </span>
                          ),
                        },
                        {
                          value: "razorpay",
                          label: "Online Payment",
                          sub: "Cards • UPI • Net Banking • Wallets",
                          badge: "FREE Delivery",
                          icon: <FiCreditCard className="text-blue-600" size={18} />,
                          badgeColor: "bg-green-100 text-green-700",
                          activeColor: "border-blue-400 bg-blue-50",
                          deliveryNote: (
                            <span className="text-xs text-green-600 flex items-center gap-1 mt-1">
                              <FiCheckCircle size={11} /> Free delivery on online payment!
                            </span>
                          ),
                        },
                      ].map((opt) => (
                        <label
                          key={opt.value}
                          className={`flex items-start gap-4 p-4 border-2 rounded-xl cursor-pointer transition-all ${
                            formData.paymentMethod === opt.value
                              ? opt.activeColor
                              : "border-gray-200 hover:border-gray-300 bg-white"
                          }`}
                        >
                          <input
                            type="radio"
                            name="paymentMethod"
                            value={opt.value}
                            checked={formData.paymentMethod === opt.value}
                            onChange={handleChange}
                            className="w-4 h-4 accent-red-600 mt-1"
                          />
                          <div className="w-10 h-10 bg-white border border-gray-200 rounded-xl flex items-center justify-center shadow-sm shrink-0">
                            {opt.icon}
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center gap-2 flex-wrap">
                              <p className="font-bold text-gray-900 text-sm">{opt.label}</p>
                              <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${opt.badgeColor}`}>
                                {opt.badge}
                              </span>
                            </div>
                            <p className="text-xs text-gray-500 mt-0.5">{opt.sub}</p>
                            {formData.paymentMethod === opt.value && opt.deliveryNote}
                          </div>
                          {formData.paymentMethod === opt.value && (
                            <div className="w-5 h-5 bg-red-600 rounded-full flex items-center justify-center shrink-0 mt-1">
                              <FiCheck className="text-white" size={11} />
                            </div>
                          )}
                        </label>
                      ))}
                    </div>

                    {/* Coupon Section */}
                    <div className="px-6 pb-4">
                      <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl">
                        <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
                          <FiTag className="text-orange-500" size={15} />
                          Have a Coupon?
                        </h3>
                        <div className="flex gap-2">
                          <input
                            type="text"
                            value={couponCode}
                            onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                            placeholder="ENTER CODE"
                            disabled={!!appliedCoupon}
                            className="flex-1 px-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm font-mono font-semibold tracking-widest focus:outline-none focus:ring-2 focus:ring-orange-400 disabled:bg-gray-100 disabled:text-gray-400 uppercase"
                          />
                          {appliedCoupon ? (
                            <button
                              onClick={handleRemoveCoupon}
                              className="px-4 py-2.5 bg-red-100 text-red-600 font-semibold rounded-xl hover:bg-red-200 transition text-sm"
                            >
                              Remove
                            </button>
                          ) : (
                            <button
                              onClick={handleApplyCoupon}
                              disabled={couponLoading}
                              className="px-4 py-2.5 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-600 transition disabled:opacity-50 text-sm flex items-center gap-1.5"
                            >
                              {couponLoading ? <FiLoader className="animate-spin" size={14} /> : "Apply"}
                            </button>
                          )}
                        </div>
                        {couponError && (
                          <p className="mt-2 text-xs text-red-500 flex items-center gap-1">
                            <FiAlertCircle size={12} /> {couponError}
                          </p>
                        )}
                        {appliedCoupon && (
                          <div className="mt-3 flex items-center justify-between px-3 py-2.5 bg-green-50 border border-green-200 rounded-lg">
                            <span className="flex items-center gap-1.5 text-sm font-bold text-green-800">
                              <FiCheckCircle className="text-green-600" size={14} />
                              {appliedCoupon.code}
                            </span>
                            <span className="text-sm font-bold text-green-700">
                              -₹{appliedCoupon.discount.toFixed(2)}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Amount Box */}
                    <div className="px-6 pb-4">
                      <div className="flex items-center justify-between px-5 py-4 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl text-white">
                        <div>
                          <p className="text-xs text-gray-400 font-medium">Total Payable</p>
                          <p className="text-2xl font-extrabold mt-0.5">₹{totals.total.toFixed(2)}</p>
                          {appliedCoupon && (
                            <p className="text-xs text-green-400 mt-0.5">
                              You saved ₹{couponDiscount.toFixed(2)} 🎉
                            </p>
                          )}
                        </div>
                        <div className="text-right text-xs text-gray-400 space-y-1">
                          <p>Subtotal: ₹{totals.subtotal.toFixed(2)}</p>
                          <p className={totals.deliveryFee === 0 ? "text-green-400" : "text-orange-400"}>
                            Delivery: {totals.deliveryFee === 0 ? "FREE" : `₹${totals.deliveryFee}`}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* CTA */}
                    <div className="px-6 pb-6">
                      {!backendOrderData ? (
                        <button
                          onClick={handleCreateOrder}
                          disabled={loading}
                          className="w-full py-3.5 bg-gradient-to-r from-red-600 to-red-500 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-600 transition-all shadow-lg shadow-red-200 flex items-center justify-center gap-2 text-sm disabled:opacity-60 disabled:cursor-not-allowed"
                        >
                          {loading ? (
                            <>
                              <FiLoader className="animate-spin" size={16} />
                              Creating Order & Booking Shipment...
                            </>
                          ) : (
                            <>
                              <FiCheck size={16} />
                              {formData.paymentMethod === "cod"
                                ? "Place Order (COD • ₹30 Delivery)"
                                : "Create Order & Pay Online (Free Delivery)"}
                            </>
                          )}
                        </button>
                      ) : formData.paymentMethod === "razorpay" ? (
                        <button
                          onClick={() => initiateRazorpayPayment(backendOrderData)}
                          disabled={paymentLoading}
                          className="w-full py-3.5 bg-gradient-to-r from-blue-600 to-blue-500 text-white font-bold rounded-xl hover:from-blue-700 hover:to-blue-600 transition-all shadow-lg shadow-blue-200 flex items-center justify-center gap-2 text-sm disabled:opacity-60"
                        >
                          {paymentLoading ? (
                            <><FiLoader className="animate-spin" size={16} /> Opening Payment Gateway...</>
                          ) : (
                            <><FiCreditCard size={16} /> Pay ₹{totals.total.toFixed(2)} with Razorpay</>
                          )}
                        </button>
                      ) : (
                        <div className="p-4 bg-green-50 border border-green-200 rounded-xl">
                          <div className="flex items-center gap-3 mb-3">
                            <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center">
                              <FiCheckCircle className="text-green-600" size={20} />
                            </div>
                            <div>
                              <p className="font-bold text-green-800 text-sm">Order & AWB Created!</p>
                              <p className="text-xs text-green-600">
                                #{backendOrderData._id?.slice(-8).toUpperCase()}
                                {backendOrderData.parcelx?.awb && (
                                  <> · AWB: <strong>{backendOrderData.parcelx.awb}</strong></>
                                )}
                              </p>
                            </div>
                          </div>
                          <button
                            onClick={() => setStep(3)}
                            className="w-full py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition font-semibold text-sm"
                          >
                            View Confirmation →
                          </button>
                        </div>
                      )}
                      <p className="text-center text-xs text-gray-400 mt-3 flex items-center justify-center gap-1">
                        <FiLock size={11} /> Secured with bank-level encryption
                      </p>
                    </div>
                  </div>
                </motion.div>
              )}

              {/* ══════ STEP 3 – CONFIRMATION ══════ */}
              {step === 3 && orderDetails && (
                <motion.div
                  key="step3"
                  initial={{ opacity: 0, scale: 0.96 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  {/* ── THANK YOU BANNER ── */}
                  <motion.div
                    initial={{ opacity: 0, y: -16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.15, duration: 0.4 }}
                    className="mb-4 rounded-2xl overflow-hidden bg-gradient-to-r from-red-600 via-red-500 to-orange-500 px-6 py-5 flex items-center justify-between shadow-lg shadow-red-200"
                  >
                    <div>
                      <p className="text-white/80 text-xs font-semibold uppercase tracking-widest mb-1">
                        HAVBIT
                      </p>
                      <h2 className="text-white text-xl font-extrabold leading-tight">
                        Thank you for your order,
                      </h2>
                      <p className="text-white/90 text-lg font-bold">
                        {formData.name?.split(" ")[0] || "Friend"}! 🎉
                      </p>
                      <p className="text-white/70 text-xs mt-1.5">
                        We're thrilled to have you shop with us. Your order is in safe hands!
                      </p>
                    </div>
                    <motion.div
                      animate={{ scale: [1, 1.15, 1] }}
                      transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
                      className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center shrink-0 ml-4"
                    >
                      <FiHeart className="text-white" size={30} />
                    </motion.div>
                  </motion.div>

                  {/* ── ORDER CONFIRMED CARD ── */}
                  <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
                    <div className="bg-gradient-to-br from-green-500 to-emerald-600 px-6 py-10 text-center">
                      <motion.div
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
                        className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg"
                      >
                        {paymentSuccess ? (
                          <FiCheck className="text-green-500" size={36} />
                        ) : (
                          <FiAlertCircle className="text-amber-500" size={36} />
                        )}
                      </motion.div>
                      <motion.h2
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                        className="text-2xl font-extrabold text-white mb-1"
                      >
                        {paymentSuccess ? "Order Confirmed! 🎉" : "Order Created"}
                      </motion.h2>
                      <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.4 }}
                        className="text-green-100 text-sm"
                      >
                        {paymentSuccess
                          ? "Your order is confirmed and shipment booked"
                          : "Order placed but payment pending"}+*
                          
                      </motion.p>
                    </div>

                    <div className="p-6 space-y-4">
                      <div className="grid grid-cols-2 gap-3">
                        {[
                          { label: "Order ID", value: `#${orderDetails.orderId?.slice(-8).toUpperCase()}` },
                          {
                            label: "Amount",
                            value: `₹${orderDetails.amount?.toFixed(2)}`,
                            valueClass: "text-green-600",
                          },
                          {
                            label: "Payment",
                            value: orderDetails.paymentMethod === "cod" ? "Cash on Delivery" : "Online Payment",
                          },
                          {
                            label: "Status",
                            value: orderDetails.orderStatus || "Confirmed",
                            valueClass: "text-green-600",
                          },
                        ].map((item) => (
                          <div key={item.label} className="bg-gray-50 rounded-xl p-3">
                            <p className="text-xs text-gray-500 uppercase tracking-wider font-medium mb-1">
                              {item.label}
                            </p>
                            <p className={`font-bold text-gray-900 text-sm ${item.valueClass || ""}`}>
                              {item.value}
                            </p>
                          </div>
                        ))}
                      </div>

                      {orderDetails.paymentMethod === "cod" && (
                        <div className="flex items-center gap-2 px-4 py-3 bg-orange-50 border border-orange-200 rounded-xl text-xs text-orange-700">
                          <FiInfo size={13} className="shrink-0" />
                          <span>₹30 delivery charge included • Pay on delivery</span>
                        </div>
                      )}

                      {orderDetails.coupon && (
                        <div className="flex items-center justify-between px-4 py-3 bg-green-50 border border-green-200 rounded-xl">
                          <span className="flex items-center gap-2 text-sm font-semibold text-green-800">
                            <FiTag className="text-green-600" size={14} />
                            Coupon saved!
                          </span>
                          <span className="font-bold text-green-700">
                            -₹{orderDetails.coupon.discount.toFixed(2)}
                          </span>
                        </div>
                      )}

                      <div className="text-center py-3 px-4 bg-gray-50 rounded-xl">
                        <p className="text-xs text-gray-500">
                          Updates sent to{" "}
                          <span className="font-semibold text-gray-700">{formData.email}</span>
                          {" "}and{" "}
                          <span className="font-semibold text-gray-700">{formData.phone}</span>
                        </p>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
                        <button
                          onClick={() => navigate(`/order/${orderDetails.orderId}`)}
                          className="py-3.5 bg-gradient-to-r from-red-600 to-red-500 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-600 transition text-sm"
                        >
                          View Order Details
                        </button>
                        <button
                          onClick={() => navigate("/products")}
                          className="py-3.5 border-2 border-gray-200 text-gray-700 font-bold rounded-xl hover:bg-gray-50 hover:border-gray-300 transition text-sm"
                        >
                          Continue Shopping
                        </button>
                      </div>
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {/* ── Sidebar ── */}
          <div className="lg:col-span-1">
            <div
              className="sticky top-24 flex flex-col gap-5"
              style={{
                maxHeight: "calc(100vh - 7rem)",
                overflowY: "auto",
                paddingBottom: "1rem",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              <style>{`.sidebar-scroll::-webkit-scrollbar { display: none; }`}</style>
              <div className="sidebar-scroll">
                <OrderSummary
                  cart={sidebarCart}
                  totals={sidebarTotals}
                  appliedCoupon={sidebarCoupon}
                  paymentMethod={sidebarPayment}
                  gstin={gstin}
                  gstinInput={gstinInput}
                  gstinExpanded={gstinExpanded}
                  gstinError={gstinError}
                  gstinVerificationLoading={gstinVerificationLoading}
                  gstinVerifiedDetails={gstinVerifiedDetails}
                  onShowGstTerms={() => setShowGstTerms(true)}
                  onGstinInputChange={handleGstinInputChange}
                  onToggleGstin={() => {
                    setGstinExpanded((expanded) => !expanded);
                    setGstinError("");
                  }}
                  onSaveGstin={handleSaveGstin}
                  onRemoveGstin={handleRemoveGstin}
                />
              </div>

              {/* Account info */}
              <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
                <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <FiUser className="text-red-500" size={14} /> Account
                </h3>
                <div className="space-y-1.5">
                  {[
                    { label: "Name", value: user?.fullName || user?.name || "—" },
                    { label: "Email", value: user?.email || "—" },
                    { label: "Phone", value: user?.phone || formData.phone || "—" },
                  ].map(({ label, value }) => (
                    <div key={label} className="flex items-center justify-between text-xs">
                      <span className="text-gray-400">{label}</span>
                      <span className="font-semibold text-gray-700 truncate max-w-[60%] text-right">
                        {value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Help */}
              <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
                <h3 className="text-sm font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <FiInfo className="text-red-500" size={14} /> Need Help?
                </h3>
                <div className="text-xs text-gray-500 space-y-1">
                  <p>support@havbit.in</p>
                  <p>+91 12345 67890</p>
                  <p className="text-gray-400">Mon-Sat · 9 AM - 6 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}